import LoginResponseDto from "./models/dtos/LoginResponseDto";
import FullOverviewDto from "./models/dtos/FullOverviewDto";
import FunnelDto from "./models/dtos/FunnelDto";
import FunnelEligibilityDto from "./models/dtos/FunnelEligibilityDto";
import OverviewChartsDto from "./models/dtos/OverviewChartsDto";
import PromoBannerDto from "./models/dtos/PromoBannerDto";
import MatchDto from "./models/dtos/MatchDto";
import MatchInfoDto from "./models/dtos/MatchInfoDto";
import PaginatedMatchesResponseDto from "./models/dtos/PaginatedMatchesResponseDto";
import Localization from "./models/Localization";
import PromoMatchStat from "./models/dtos/PromoMatchStat";
import PromoMatchChart from "./models/dtos/PromoMatchChart";
import PromoMatchesStat from "./models/dtos/PromoMatchesStat";
import EditablePromoConfig from "./models/dtos/EditablePromoConfig";
import TourMarketingRewardsDto from "./models/dtos/TourMarketingRewardsDto";
import OneClickBetSettingsDto from "./models/dtos/OneClickBetSettingsDto";
import FlashBetSettingsDto from "./models/dtos/FlashBetSettingsDto";
import ShopLayoutSettingsDto from "./models/dtos/ShopLayoutSettingsDto";
import DailyQuestsSettingsDto from "./models/dtos/DailyQuestsSettingsDto";
import DailyQuestTemplateDto, {
    DailyQuestImageKind,
    DailyQuestImagePresetDto,
    DailyQuestTaskTemplateDto,
    UpsertDailyQuestTaskTemplateDto,
    UpsertDailyQuestTemplateDto,
    UserTaskTemplateDto,
    DailyQuestStatus,
    UserTaskType,
} from "./models/dtos/DailyQuestTemplateDto";
import DailyQuestTitleCatalogDto from "./models/dtos/DailyQuestTitleCatalogDto";
import DailyQuestStatisticsDto, { DailyQuestStatisticsTimeframe } from "./models/dtos/DailyQuestStatisticsDto";
import PaginatedDailyQuestInstancesDto from "./models/dtos/PaginatedDailyQuestInstancesDto";
import DailyQuestAdminInstanceDto from "./models/dtos/DailyQuestAdminInstanceDto";
import DailyQuestEligibilityDto from "./models/dtos/DailyQuestEligibilityDto";
import {
    AssignDailyQuestsRequestDto,
    AssignDailyQuestsResponseDto,
    CreateDailyQuestInstanceDto,
    UpdateDailyQuestInstanceDto,
} from "./models/dtos/DailyQuestManualAdminDtos";
import PaginatedMatchesDetailedResponseDto from "./models/dtos/PaginatedMatchesDetailedResponseDto";
import { getAccessToken, getStrapiAccessToken } from "./UserStorage";
import FunnelConfigDto from "./models/dtos/FunnelConfigDto";
import UpdateFunnelDto from "./models/dtos/UpdateFunnelDto";
import FunnelOptions from "./models/dtos/FunnelOptions";
import TemplateDto from "./models/dtos/TemplateDto";
import PaginatedOffersResponseDto from "./models/dtos/PaginatedOffersResponseDto";
import AppVersionDto from "./models/dtos/AppVersionDto";
import type { OnboardingFunnelResponseDto } from "./models/dtos/OnboardingFunnelDto";
import type UserPurposeStatsDto from "./models/dtos/UserPurposeStatsDto";
import StaticOfferAttractivityDto from "./models/dtos/StaticOfferAttractivityDto";
import AccountDeletionRequestDto from "./models/dtos/AccountDeletionRequestDto";
import ShopItemDto from "./models/dtos/ShopItemDto";
import ShopEffectDto from "./models/dtos/ShopEffectDto";
import StoreCodeCheckResult from "./models/dtos/StoreCodeCheckResult";
import UserTagDefinitionDto, { UpsertUserTagDefinitionRequest } from "./models/dtos/UserTagDefinitionDto";
import UserTagDefinitionOptionsDto from "./models/dtos/UserTagDefinitionOptionsDto";
import PaginatedUserTagDefinitionsResponseDto from "./models/dtos/PaginatedUserTagDefinitionsResponseDto";
import UserTagNameCheckResult from "./models/dtos/UserTagNameCheckResult";
import VideoPlacementDto from "./models/dtos/VideoPlacementDto";
import ProviderTaskStatsResponseDto, { ProviderTaskStatsQuery } from "./models/dtos/ProviderTaskStatsDto";
import VideoRewardOptionsDto from "./models/dtos/VideoRewardOptionsDto";
import VideoPlacementStatsDto from "./models/dtos/VideoPlacementStatsDto";
import SummaryVideoPlacementStatsDto from "./models/dtos/SummaryVideoPlacementStatsDto";
import VideoRewardConfigDto from "./models/dtos/VideoRewardConfigDto";
import UpdateVideoRewardConfigRequest from "./models/dtos/UpdateVideoRewardConfigRequest";
import PaginatedUsersResponseDto from "./models/dtos/PaginatedUsersResponseDto";
import AggregateUserInfoDto from "./models/dtos/AggregateUserInfoDto";
import UserAchievementsAdminDto from "./models/dtos/UserAchievementsAdminDto";
import UserDailyBonusAdminDto, { DailyBonusEffectsChangeDto } from "./models/dtos/UserDailyBonusAdminDto";
import UserPremiumAdminDto, {
    StoreEventsPageDto, SubscribersPageDto, SubscriptionEventItemDto, SubscriptionOfferRuleRequest, SubscriptionOffersAdminDto,
    SubscriptionOfferTemplateRequest, SubscriptionPlansAdminDto, SubscriptionValidationDto,
} from "./models/dtos/UserPremiumAdminDto";
import UserCampaignAdminDto from "./models/dtos/UserCampaignAdminDto";
import { BetupFeedReviewSettingsDto, BetupFeedReviewStatsDto } from "./models/dtos/BetupFeedReviewDto";
import {
    BetupFeedAdminPostDto, BetupFeedMessageReportDto, BetupFeedPaginatedDto, BetupFeedReportedPostDto,
    BetupFeedReportStatusFilter, BetupFeedReviewStatus, BetupFeedUserModerationSummaryDto, BetupFeedUserViolationDto,
} from "./models/dtos/BetupFeedPostDto";
import { BetupFeedPageDto } from "./models/dtos/BetupFeedItemDto";
import {
    BetupFeedChannelCategoryDto, BetupFeedChannelCategoryRequestDto, BetupFeedChannelDto, BetupFeedChannelPostDto,
    BetupFeedChannelPostRequestDto, BetupFeedChannelPostStatus, BetupFeedChannelPostUpdateRequestDto,
    BetupFeedChannelRequestDto, BetupFeedChannelSubscriberDto, BetupFeedChannelSubscriberEventDto,
    BetupFeedChannelSubscriberEventKind, BetupFeedChannelSubscriberStatsDto, BetupFeedChannelOverviewDto,
    BetupFeedChannelTimelineDto, BetupFeedWidgetDataDto, BetupFeedCommentPageDto, BetupFeedPostLikeDto,
} from "./models/dtos/BetupFeedChannelDto";
import PaginatedBetlistsResponse from "./models/dtos/PaginatedBetlistsResponse";
import PaginatedBalanceHistoryResponseDto from "./models/dtos/PaginatedBalanceHistoryResponseDto";
import BetlistShortDto from "./models/dtos/BetlistShortDto";
import SupportChatWithUserDto from "./models/dtos/SupportChatWithUserDto";
import SupportChatDto from "./models/dtos/SupportChatDto";
import SupportMessageDto from "./models/dtos/SupportMessageDto";
import MessageTemplateDto from "./models/dtos/MessageTemplateDto";
import PaginatedSupportChatsDto from "./models/dtos/PaginatedSupportChatsDto";
import PaginatedMatchesListResponseDto from "./models/dtos/PaginatedMatchesListResponseDto";
import AggregatedMatchInfoDto from "./models/dtos/AggregatedMatchInfoDto";
import AdminMatchStatDto, { AdminMatchHistoryDto, AdminMatchPlayersDto } from "./models/dtos/AdminMatchStatDto";
import { MatchBettingStatsDto } from "./models/dtos/MatchBettingStatsDto";
import VarietyWithRequestsDto from "./models/dtos/VarietyWithRequestsDto";
import PaginatedMatchBetsDto from "./models/dtos/PaginatedMatchBetsDto";
import ExternalPlacedBetDto, { ExternalPlacedBetResultState, PaginatedExternalPlacedBetsDto } from "./models/dtos/ExternalPlacedBetDto";
import DetailedRecalculationRequestDto from "./models/dtos/DetailedRecalculationRequestDto";
import LocalizationIconDto from "./models/dtos/LocalizationIconDto";
import HomeMatchAdDto from "./models/dtos/HomeMatchAdDto";
import HomeMatchAdIconDto from "./models/dtos/HomeMatchAdIconDto";
import HomeMatchAd from "./models/HomeMatchAd";
import PaginatedHomeMatchAdsResponseDto from "./models/dtos/PaginatedHomeMatchAdsResponseDto";
import ProviderMatchEventInfoDto from "./models/dtos/ProviderMatchEventInfoDto";
import PaginatedPreliminaryResultsDto from "./models/dtos/PaginatedPreliminaryResultsDto";
import PaginatedCompetitionListDto from "./models/dtos/PaginatedCompetitionListDto";
import CompetitionDto from "./models/dtos/CompetitionDto";
import { UserTagCombinationMode } from "./models/UserTagCombinationMode";
import CompetitionOptions from "./models/dtos/CompetitionOptions";
import {
    PaginatedQuizConfigurationListDto,
    PaginatedQuizEligibleMatchesDto,
    QuizBetTypeDto,
    QuizBetTypeGroupOptionDto,
    PaginatedQuizParticipationsDto,
    QuizConfigurationDto,
    QuizParticipationAdminDetailDto,
    QuizTierDto,
    SaveQuizBetTypeRequest,
    SaveQuizConfigurationRequest,
    SaveQuizTierRequest,
} from "./models/dtos/QuizAdminDtos";
import PaginatedMatchesShortListResponseDto from "./models/dtos/PaginatedMatchesShortListResponseDto";
import PaginatedSportListDto from "./models/dtos/PaginatedSportListDto";
import { ChannelArticleExecutionDto, ChannelArticleExecutionPageDto, ChannelArticleStatus, MatchPublishingDto, PublishingPostPageDto, PublishingPostStatus } from "./models/dtos/PublishingDto";
import { MatchAiStatusDto, MatchBriefDto, MatchBriefExecutionDto, MatchBriefExecutionPageDto, MatchBriefExecutionStatus, MatchBriefPageDto, MatchBriefScope, MatchBriefStatus, MatchResearchDto, MatchResearchPageDto } from "./models/dtos/MatchBriefDto";
import SportEntityDto from "./models/dtos/SportEntityDto";
import LeagueCatalogDto, {
    LeagueCatalogCategoryDto,
    LeagueCatalogItemDto,
    SaveLeagueCatalogRequest,
    UpdateCatalogLeagueRequest,
    UpsertLeagueCategoryRequest,
} from "./models/dtos/LeagueCatalogDto";
import {
    ChallengeAdminDetailDto,
    ChallengeAdminSort,
    PaginatedChallengesResponseDto,
    UpdateChallengeAdminRequest,
    UpdateChallengeParticipantAdminRequest,
} from "./models/dtos/ChallengeAdminDto";
import FlashBetSportDto from "./models/dtos/FlashBetSportDto";
import FlashBetCategoryDto from "./models/dtos/FlashBetCategoryDto";
import FlashBetLeagueDto, { PageFlashBetLeagueDto } from "./models/dtos/FlashBetLeagueDto";
import FlashBetStadiumDto, { PageFlashBetStadiumDto } from "./models/dtos/FlashBetStadiumDto";
import FlashBetQuestionTemplateDto from "./models/dtos/FlashBetQuestionTemplateDto";
import {
    FlashBetMatchDto, CreateMatchRequest, UpdateMatchRequest, UpdateMatchMetadataRequest,
    AddMatchQuestionRequest, UpdateMatchQuestionByIdRequest, PageFlashBetMatchDto
} from "./models/dtos/FlashBetMatchDto";
import UpdateSportRequest from "./models/dtos/UpdateSportRequest";
import UpdateCategoryRequest from "./models/dtos/UpdateCategoryRequest";
import CreateCategoryRequest from "./models/dtos/CreateCategoryRequest";
import CreateQuestionTemplateRequest from "./models/dtos/CreateQuestionTemplateRequest";
import UpdateQuestionTemplateRequest from "./models/dtos/UpdateQuestionTemplateRequest";
import MatchTimeScoreRecordDto from "./models/dtos/MatchTimeScoreRecordDto";
import UpdateMatchScoreRecordsRequest from "./models/dtos/UpdateMatchScoreRecordsRequest";
import FlashBetEventDto, { UpdateMatchEventsRequest } from "./models/dtos/FlashBetEventDto";
import TaskQueueStatusDto from "./models/dtos/TaskQueueStatusDto";
import FlashBetTaskDetailDto, { PageFlashBetTaskDetailDto } from "./models/dtos/FlashBetTaskDetailDto";
import FlashBetMatchCreationTaskDto from "./models/dtos/FlashBetMatchCreationTaskDto";
import FlashBetMatchQuestionsStatsDto from "./models/dtos/FlashBetMatchQuestionsStatsDto";
import FlashBetOverviewStatsDto from "./models/dtos/FlashBetOverviewStatsDto";
import StatsInterval from "./models/dtos/StatsInterval";
import FlashBetSportPromptDto from "./models/dtos/FlashBetSportPromptDto";
import FlashBetSportPromptSummaryDto from "./models/dtos/FlashBetSportPromptSummaryDto";
import UpdateSportPromptRequest from "./models/dtos/UpdateSportPromptRequest";
import CreateSportPromptRequest from "./models/dtos/CreateSportPromptRequest";
import SetActivePromptRequest from "./models/dtos/SetActivePromptRequest";
import PromptMacrosDto from "./models/dtos/PromptMacrosDto";
import UserPurchaseDto from "./models/dtos/UserPurchaseDto";
import VideoRewardRecordDto from "./models/dtos/VideoRewardRecordDto";
import AISupportConfigurationDto from "./models/dtos/AISupportConfigurationDto";
import UpdateAISupportConfigurationDto from "./models/dtos/UpdateAISupportConfigurationDto";
import SupportChatCategoryDto from "./models/dtos/SupportChatCategoryDto";
import TranslateMessageResponseDto from "./models/dtos/TranslateMessageResponseDto";
import AIChatSummaryDto from "./models/dtos/AIChatSummaryDto";
import RacingParticipantResultDto from "./models/dtos/RacingParticipantResultDto";
import LeagueInfoDto, { LeagueScheduledMatchesDto, PaginatedLeagueInfoResponseDto } from "./models/dtos/LeagueInfoDto";
import {
    VIRTUAL_SPORT_IDS,
    VirtualCatalogLeagueDto,
    VirtualCatalogMatchDto,
    VirtualCatalogPageDto,
    VirtualCatalogSportDto,
    VirtualLeagueSort,
} from "./models/dtos/VirtualSportsCatalogDto";
import {
    AdjustMatchStartDatesResultDto,
    CreateVirtualMatchRequest,
    CreateVirtualTeamRequest,
    GeneratedVirtualTeamDto,
    GenerateMatchBetsResultDto,
    GenerateVirtualMatchRequest,
    VirtualLeagueDraftDto,
    VirtualPlayerDraftDto,
    VirtualPlayerImportResultDto,
    VirtualTeamImportResultDto,
    VirtualLeagueImportResultDto,
    VirtualPlayerPageDto,
    VirtualPoolPlayerAssignment,
    VirtualProviderLeagueDto,
    MockVirtualCityViewDto,
    VirtualMatchScheduleResultDto,
    VirtualProviderMatchLiveInfoDto,
    VirtualProviderPlayerDto,
    VirtualProviderTeamDto,
    VirtualTeamDraftDto,
    VirtualTeamGenerationHints,
    UpdateVirtualTeamRequest,
    UpdateVirtualLeagueRequest,
    VirtualPlayerSearchQuery,
    VirtualTeamPageDto,
    VirtualTeamSearchQuery,
    VirtualProviderSeasonDto,
    VirtualProviderTournamentStandingDto,
    VirtualProviderMatchSummaryDto,
    VirtualActivityLogPageDto,
    VirtualProviderMatchPageDto,
    VirtualMatchState,
    VirtualStatisticsDto,
    VirtualStatisticsRange,
} from "./models/dtos/VirtualProviderCatalogDto";
import { VirtualAiSettingsDto } from "./models/dtos/VirtualAiSettingsDto";
import { VirtualSportSettingsDto } from "./models/dtos/VirtualSportSettingsDto";
import ReplicationHealthResponseDto from "./models/dtos/ReplicationHealthResponseDto";
import QueueStatusInfoDto, { QueueActionResultDto } from "./models/dtos/QueueStatusInfoDto";
import KubernetesDeploymentHealthResponseDto from "./models/dtos/KubernetesDeploymentHealthResponseDto";
import PaginatedPurchaseRequestsResponseDto from "./models/dtos/PaginatedPurchaseRequestsResponseDto";
import PaginatedUserOffersResponseDto from "./models/dtos/PaginatedUserOffersResponseDto";
import PaginatedAccountEventsResponseDto from "./models/dtos/PaginatedAccountEventsResponseDto";
import ServerHealthStatusResponseDto from "./models/dtos/ServerHealthStatusResponseDto";
import ServerHealthChartResponseDto, { ServerHealthChartTimeFilter } from "./models/dtos/ServerHealthChartResponseDto";
import CronHealthResponseDto from "./models/dtos/CronHealthResponseDto";
import HtmlTemplateDto, { GenerateHtmlTemplateLocalizationsRequest, HtmlTemplateAnalysisDto, HtmlTemplateCloneResponse, HtmlTemplateImprovementResponse, HtmlTemplateLocalizationsGenerationResponse, HtmlTemplateUpsertDto, HtmlTemplateValidationResultDto } from "./models/dtos/HtmlTemplateDto";
import { AviatorAdminRoundHistoryResponseDto, PaginatedWebGameSessionHistoryResponseDto, UpdateWebGameAdminConfigRequest, UpdateWebGameTemplateHtmlRequest, WebGameAdminConfigDto, WebGameImagePresetDto, WebGameListItemDto, WebGameSessionCodeDto, WebGameSoundAssetDto, WebGameSoundAssetsResponseDto, WebGameTemplateHtmlDto } from "./models/dtos/WebGameDto";
import { PresentationActionRequest, PresentationCampaignDto, PresentationCampaignUpsertRequest, PresentationEligibilityContextDto } from "./models/dtos/PresentationCampaignDto";
import PrivateClubDto, {
    CoreExternalGrabbedBetsResponseDto,
    CreatePrivateClubRequestDto,
    JoinPrivateClubRequestDto,
    PaginatedPrivateClubJoinRequestsDto,
    PlacePrivateClubPickRequestDto,
    PrivateClubBetGroupAvailabilityDto,
    PrivateClubLeaderboardResponseDto,
    PrivateClubJoinRequestDto,
    PrivateClubPlacedBetsResponseDto,
    PrivateClubPlacedBetDto,
    PrivateClubTemplateStatus,
    UpdatePrivateClubRequestDto,
} from "./models/dtos/PrivateClubDto";
import PrivateClubAdminDto, {
    AgentRunAdminDto,
    PaginatedPrivateClubAgenticLogsAdminResponseDto,
    PrivateClubCurrentRoundMatchesAdminResponseDto,
    PaginatedPrivateClubsAdminResponseDto,
    PaginatedPrivateClubTemplateMatchesAdminResponseDto,
    PrivateClubAgenticConfigurationAdminDto,
    PrivateClubAgenticConfigurationAdminRequestDto,
    PrivateClubAgenticEventAdminDto,
    PrivateClubAgenticEventsAdminResponseDto,
    PrivateClubAgenticRunAdminResponseDto,
    PrivateClubOverridePlacedBetStatusAdminRequestDto,
    PrivateClubOverridePlacedBetStatusAdminResponseDto,
    PrivateClubBetTypeGroupOptionAdminDto,
    PrivateClubTemplateAdminDto,
    PrivateClubTemplatePlacedBetsAdminResponseDto,
    PrivateClubTemplatePlacedBetsAdminView,
    UpsertPrivateClubTemplateAdminDto,
} from "./models/dtos/PrivateClubAdminDto";
import type {
    InterstitialCampaignDto,
    InterstitialCampaignStatsDto,
    InterstitialCampaignUpsertRequest,
    InterstitialTriggerRegistryDto,
    InterstitialUserStatsRowDto,
} from "./models/dtos/InterstitialCampaignDto";
import type {
    RewardedPromptCampaignDto,
    RewardedPromptCampaignStatsDto,
    RewardedPromptCampaignUpsertRequest,
    RewardedPromptTriggerRegistryDto,
    RewardedPromptUserStatsRowDto,
} from "./models/dtos/RewardedPromptCampaignDto";
import type {
    BattleAgentCandidateUsersResponse,
    BattleAgentCreatorSort,
    BattleAgentDto,
    BattleAgentInviteTagMode,
    BattleAgentRunDto,
    BattleAgentBotAccountsResponse,
    BattleAgentBotAccountDto,
    BattleAgentRunHistoryPageDto,
    BattleAgentRunHistoryQuery,
    BattleAgentsSettingsDto,
    BattleAgentsStatsOverview,
    BattleAgentUpsertRequest,
} from "./models/dtos/BattleAgentDto";
import {
    PresentationScreenRegistryDto,
    PresentationScreenRegistryMutationResult,
    PresentationScreenRegistryUpsertRequest,
} from "./models/dtos/PresentationScreenRegistryDto";
import type {
    PollAnswerFilter,
    PollAnswerRowDto,
    PollAudienceDto,
    PollAudienceRequest,
    PollDto,
    PollLocalizationGenerateRequest,
    PollLocalizationGenerateResponse,
    PollMutationResult,
    PollPageDto,
    PollSendDto,
    PollSendRequest,
    PollStatsDto,
    PollStatus,
    PollUpsertRequest,
} from "./models/dtos/PollDto";
import type { PushTemplate, PushSendRequest, PushAudience, PushStatsView, MarketingPushSend, PushPage, LegacyRateSend, PushAudienceRequest, PushAudienceEstimate, PushSendingTemplate, PushSendingTemplateRequest, PushMatchDetails } from "./models/dtos/MarketingPushDto";
import {
    AiAgentDto, AiAgentLinksDto, AiAgentRunDto, AiAgentSummaryDto, AiAgentToolsDto, AiBudgetDto, AiBudgetEventDto,
    AiEndUserDataDeletionDto, AiEndUserUsageDto, AiExecuteTaskRequest, AiJsonObject, AiMaxCallsRequest, AiMcpCheckDto,
    AiMcpServerDto, AiMcpToolDto, AiMcpResourceDto, AiMetaDto, AiModelDto, AiPage, AiProviderKeyDto, AiPutMcpLinkRequest, AiRunDetailDto,
    AiRunSummaryDto, AiAgentStatsDto, AiEffectiveParamsDto, AiEffectiveParamsRequest, AiToolStatsDto, AiToolInvocationDto, AiToolInvocationsFilter, AiConversationDetailDto, AiConversationSummaryDto, AiConversationsFilter, AiStartAgentRunRequest, AiTaskDto, AiTaskExecutionDto, AiTaskPreviewDto, AiTaskSummaryDto,
    AiUpsertAgentRequest, AiUpsertBudgetRequest, AiUpsertMcpServerRequest, AiUpsertModelRequest,
    AiUpsertProviderKeyRequest, AiUpsertTaskRequest, AiUsageCallDto,
    AiTaskExecutionSummaryDto, AiTaskExecutionDetailDto, AiUsageGroupBy, AiUsageSummaryDto,
    AiBundle, AiExportRequest, AiImportMode, AiImportReportDto,
    DashboardAiHealthDto,
    AiTaskCacheClearDto, AiUserBudgetDto, AiUpsertUserBudgetRequest, AiEndUserBudgetUsageDto,
    AiEndUserBudgetResetRequest, AiRunExportDto, AiUserBudgetWindowKind,
    AiWorkflowDto, AiUpsertWorkflowRequest, AiWorkflowStatsDto, AiWorkflowOverviewDto, AiWorkflowRunDetailDto,
} from "./models/dtos/AiDto";
import { handleResponseError } from "./utils/ErrorUtil";
import { isWebGameUploadsApiPath, normalizeWebGameUploadStoredPath, resolveWebGameUploadsPublicUrl } from "./webGames/webGameUploads";
import { filesPublicApiOriginFromEnv, isStrapiPublicDlPath, resolveStrapiPublicFileDisplayUrl } from "./webGames/strapiPublicFileUrl";

const BASE_URL = process.env.REACT_APP_API_URL || 'https://analytics.betup.org';
const STRAPI_BASE_URL = process.env.REACT_APP_STRAPI_API_URL;

/** Android loads competition banners as strapiOrigin + backgroundUrl — persist path e.g. /uploads/... */
function strapiOriginFromEnv(): string {
    const raw = process.env.REACT_APP_STRAPI_API_URL || ''
    if (!raw) return ''
    try {
        return new URL(raw).origin
    } catch {
        return ''
    }
}

function apiOriginFromEnv(): string {
    const raw = process.env.REACT_APP_API_URL || ''
    if (!raw) return ''
    try {
        return new URL(raw).origin
    } catch {
        return ''
    }
}

export function normalizeCompetitionBackgroundUrl(url: string | null | undefined): string | null {
    if (url == null || typeof url !== 'string') return null
    const t = url.trim()
    if (!t) return null
    const strapiOrigin = strapiOriginFromEnv()
    const filesOrigin = filesPublicApiOriginFromEnv()
    if (t.startsWith('http://') || t.startsWith('https://')) {
        try {
            const u = new URL(t)
            if (strapiOrigin && u.origin === strapiOrigin) {
                return u.pathname + (u.search || '')
            }
            if (filesOrigin && u.origin === filesOrigin && isStrapiPublicDlPath(u.pathname)) {
                return u.pathname + (u.search || '')
            }
        } catch {
            return null
        }
        return t
    }
    return t.startsWith('/') ? t : `/${t}`
}

export function resolveStrapiMediaUrlForDisplay(pathOrUrl: string | null | undefined): string | null {
    const stored = normalizeCompetitionBackgroundUrl(pathOrUrl)
    if (stored == null) return null
    if (stored.startsWith('http://') || stored.startsWith('https://')) return stored

    const publicFileUrl = resolveStrapiPublicFileDisplayUrl(stored)
    if (publicFileUrl && (publicFileUrl.startsWith('http://') || publicFileUrl.startsWith('https://'))) {
        return publicFileUrl
    }

    if (stored.startsWith('/uploads_api/') || stored.startsWith('uploads_api/')) {
        const uploadsUrl = resolveWebGameUploadsPublicUrl(stored)
        if (uploadsUrl) {
            return uploadsUrl
        }
        const apiOrigin = apiOriginFromEnv()
        if (apiOrigin) {
            const path = stored.startsWith('/') ? stored : `/${stored}`
            return `${apiOrigin}${path}`
        }
    }
    const origin = strapiOriginFromEnv()
    if (!origin) return stored.startsWith('/') ? stored : `/${stored}`
    const path = stored.startsWith('/') ? stored : `/${stored}`
    return `${origin}${path}`
}

function gamesServerOriginFromEnv(): string {
    const raw = process.env.REACT_APP_GAMES_SERVER_URL || ''
    if (!raw) return ''
    try {
        return new URL(raw).origin
    } catch {
        return ''
    }
}

export function resolveWebGameSoundAssetUrl(
    pathOrUrl: string | null | undefined,
    options?: { gamesServerOrigin?: string }
): string {
    if (pathOrUrl == null) return ''
    const raw = pathOrUrl.trim()
    if (!raw) return ''

    if (isWebGameUploadsApiPath(raw)) {
        const uploadsUrl = resolveWebGameUploadsPublicUrl(raw)
        if (uploadsUrl) {
            return uploadsUrl
        }
    }

    const normalized = normalizeCompetitionBackgroundUrl(raw)
    if (normalized == null) return ''
    if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
        return normalized
    }

    const gamesOrigin = (options?.gamesServerOrigin || gamesServerOriginFromEnv()).replace(/\/$/, '')
    const webgamesPath = normalized.startsWith('/webgames/')
        ? normalized
        : normalized.startsWith('webgames/')
            ? `/${normalized}`
            : null
    if (webgamesPath) {
        return gamesOrigin ? `${gamesOrigin}${webgamesPath}` : ''
    }

    if (normalized.startsWith('/uploads_api/') || normalized.startsWith('uploads_api/')) {
        const uploadsUrl = resolveWebGameUploadsPublicUrl(normalized)
        if (uploadsUrl) {
            return uploadsUrl
        }
    }

    const resolved = resolveStrapiMediaUrlForDisplay(normalized)
    if (resolved && (resolved.startsWith('http://') || resolved.startsWith('https://'))) {
        return resolved
    }
    if (gamesOrigin && normalized.startsWith('/')) {
        return `${gamesOrigin}${normalized}`
    }
    return resolved ?? ''
}

const fetchFromApi = (path: string, init: RequestInit = {}) => {
    let accessToken = getAccessToken()
    if (accessToken == null || undefined) {
        return fetch(BASE_URL + path, init)
    } else {
        const headers = new Headers(init.headers)
        headers.set('Authorization', accessToken)
        return fetch(BASE_URL + path, {
            ...init,
            method: init.method || 'GET',
            headers
        });
    }
}

const fetchFromStrapiApi = async (path: string) => {
    let accessToken = getStrapiAccessToken()
    if (accessToken == null || undefined) {
        return fetch(STRAPI_BASE_URL + path)
    } else {
        return fetch(STRAPI_BASE_URL + path, {
            method: 'GET', headers: { 'Authorization': accessToken }
        });
    }
}

export const loginUser = (username: string, password: string) => {
    return fetch(BASE_URL + '/api/dashboard/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username, password: password })
    }).then(response => response.ok ? response.json() : null).then(data => data as LoginResponseDto);
}

export const getStats = (osType?: string) => {
    const query = osType ? '?osType=' + encodeURIComponent(osType) : '';
    return fetchFromApi('/api/dashboard/overview' + query).then(response => response.json().then(data => data as FullOverviewDto));
}

export const getFunnels = () => {
    return fetchFromApi('/api/dashboard/offers/funnels').then(response => response.json().then(data => data as FunnelDto[]));
}

export const getFunnelList = () => {
    return fetchFromApi('/api/dashboard/offers/funnels/list').then(response => response.json().then(data => data as FunnelConfigDto[]));
}

export const getFunnel = (id: string) => {
    return fetchFromApi('/api/dashboard/offers/funnels/' + id + '/info').then(response => response.json().then(data => data as FunnelConfigDto));
}

export const getFunnelOptions = () => {
    return fetchFromApi('/api/dashboard/offers/funnels/options').then(response => response.json().then(data => data as FunnelOptions));
}

export const getFunnelDiscount = (priceTier: string, osType: string, oldPriceTier?: string | null) => {
    const params = new URLSearchParams({
        priceTier,
        osType,
    });
    if (oldPriceTier) {
        params.set('oldPriceTier', oldPriceTier);
    }

    return fetchFromApi('/api/dashboard/offers/funnels/discount?' + params.toString())
        .then(response => response.ok ? response.json().then(data => data as number) : null);
}

export const getStaticOfferAttractivity = (priceTier: string, betcoins: number, osType: string) => {
    const params = new URLSearchParams({
        priceTier,
        betcoins: String(betcoins),
        osType,
    });

    return fetchFromApi('/api/dashboard/offers/funnels/static-offer-attractivity?' + params.toString())
        .then(response => response.ok ? response.json().then(data => data as StaticOfferAttractivityDto) : null);
}

export const getUserTagsPaginated = (offset: number, limit: number) => {
    return fetchFromApi('/api/dashboard/user-tags/paginated?offset=' + offset + '&limit=' + limit)
        .then(response => response.ok ? response.json().then(data => data as PaginatedUserTagDefinitionsResponseDto) : null);
}

export const getUserTags = () => {
    return fetchFromApi('/api/dashboard/user-tags')
        .then(response => response.ok ? response.json().then(data => data as UserTagDefinitionDto[]) : null);
}

export const getUserTagOptions = () => {
    return fetchFromApi('/api/dashboard/user-tags/options')
        .then(response => response.ok ? response.json().then(data => data as UserTagDefinitionOptionsDto) : null);
}

export const getUserTag = (id: string) => {
    return fetchFromApi('/api/dashboard/user-tags/' + id)
        .then(response => response.ok ? response.json().then(data => data as UserTagDefinitionDto) : null);
}

export const checkUserTagNameExists = (tagName: string) => {
    return fetchFromApi('/api/dashboard/user-tags/check-name?tagName=' + encodeURIComponent(tagName))
        .then(response => response.ok ? response.json().then(data => data as UserTagNameCheckResult) : null);
}

export const createUserTag = async (payload: UpsertUserTagDefinitionRequest): Promise<{ ok: boolean; data?: UserTagDefinitionDto; error?: string }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) {
            return { ok: false, error: 'Missing access token.' };
        }

        const response = await fetch(BASE_URL + '/api/dashboard/user-tags', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            return { ok: false, error: await handleResponseError(response, 'Failed to create user tag.') };
        }

        return { ok: true, data: await response.json().then(data => data as UserTagDefinitionDto) };
    } catch {
        return { ok: false, error: 'Failed to create user tag.' };
    }
}

export const updateUserTag = async (id: string, payload: UpsertUserTagDefinitionRequest): Promise<{ ok: boolean; data?: UserTagDefinitionDto; error?: string }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) {
            return { ok: false, error: 'Missing access token.' };
        }

        const response = await fetch(BASE_URL + '/api/dashboard/user-tags/' + id, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            return { ok: false, error: await handleResponseError(response, 'Failed to update user tag.' ) };
        }

        return { ok: true, data: await response.json().then(data => data as UserTagDefinitionDto) };
    } catch {
        return { ok: false, error: 'Failed to update user tag.' };
    }
}

export const recalculateUserTag = async (id: string): Promise<{ ok: boolean; data?: UserTagDefinitionDto; error?: string }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) {
            return { ok: false, error: 'Missing access token.' };
        }

        const response = await fetch(BASE_URL + '/api/dashboard/user-tags/' + id + '/recalculate', {
            method: 'POST',
            headers: { 'Authorization': accessToken }
        });

        if (!response.ok) {
            return { ok: false, error: await handleResponseError(response, 'Failed to recalculate user tag.') };
        }

        return { ok: true, data: await response.json().then(data => data as UserTagDefinitionDto) };
    } catch {
        return { ok: false, error: 'Failed to recalculate user tag.' };
    }
}

export const cancelUserTagRecalculation = async (id: string): Promise<{ ok: boolean; data?: UserTagDefinitionDto; error?: string }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) {
            return { ok: false, error: 'Missing access token.' };
        }

        const response = await fetch(BASE_URL + '/api/dashboard/user-tags/' + id + '/recalculate/cancel', {
            method: 'POST',
            headers: { 'Authorization': accessToken }
        });

        if (!response.ok) {
            return { ok: false, error: await handleResponseError(response, 'Failed to cancel user tag recalculation.') };
        }

        return { ok: true, data: await response.json().then(data => data as UserTagDefinitionDto) };
    } catch {
        return { ok: false, error: 'Failed to cancel user tag recalculation.' };
    }
}

export const deleteUserTag = async (id: string): Promise<{ ok: boolean; error?: string }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) {
            return { ok: false, error: 'Missing access token.' };
        }

        const response = await fetch(BASE_URL + '/api/dashboard/user-tags/' + encodeURIComponent(id), {
            method: 'DELETE',
            headers: { 'Authorization': accessToken }
        });

        if (!response.ok) {
            return { ok: false, error: await handleResponseError(response, 'Failed to delete user tag.') };
        }

        return { ok: true };
    } catch {
        return { ok: false, error: 'Failed to delete user tag.' };
    }
}

export const getAppVersions = (osType: string) => {
    return fetchFromApi('/api/dashboard/appVersions?osType=' + encodeURIComponent(osType)).then(response => response.ok ? response.json().then(data => data as AppVersionDto[]) : []);
}

export const getOnboardingFunnel = (period: string, osType?: string, countryCode?: string, lang?: string) => {
    const params = new URLSearchParams();
    params.set('period', period);
    if (osType) params.set('osType', osType);
    if (countryCode) params.set('countryCode', countryCode);
    if (lang) params.set('lang', lang);
    return fetchFromApi('/api/dashboard/onboarding-funnel?' + params.toString())
        .then(response => response.ok ? response.json().then(data => data as OnboardingFunnelResponseDto) : null);
}

//TODO Change to FunnelConfigElementDto
export const getFunnelElementTypes = () => {
    return fetchFromApi('/api/dashboard/offers/funnels/element/types').then(response => response.json().then(data => data as string[]));
}

export const getTemplates = () => {
    return fetchFromApi('/api/dashboard/offers/funnels/templates').then(response => response.json().then(data => data as TemplateDto[]));
}

export const getTemplate = (id: string) => {
    return fetchFromApi('/api/dashboard/offers/funnels/templates/' + id).then(response => response.json().then(data => data as TemplateDto));
}
export const getLocalizationIcons = () => {
    return fetchFromApi('/api/dashboard/offers/funnels/templates/icons').then(response => response.json().then(data => data as LocalizationIconDto[]));
}

export const getHomeMatchAdIcons = () => {
    return fetchFromStrapiApi('/api/home-match-ads?fields[0]=id&fields[1]=ad_name&populate[ad_resource][fields][0]=url').then(response => response.json().then(data => data.data as HomeMatchAdIconDto[]));
}

export const getStrapiUploadUrl = (url: string) => {
    return STRAPI_BASE_URL + url;
}

export const getOverviewCharts = (osType?: string) => {
    const query = osType ? '?osType=' + encodeURIComponent(osType) : '';
    return fetchFromApi('/api/dashboard/overview/charts' + query).then(response => response.json().then(data => data as OverviewChartsDto));
}

export const getUserPurposeStats = (period: string, osType?: string) => {
    const params = new URLSearchParams();
    params.set('period', period);
    if (osType) params.set('osType', osType);
    return fetchFromApi('/api/dashboard/user-purposes?' + params.toString())
        .then(response => response.ok ? response.json().then(data => data as UserPurposeStatsDto) : null);
}

export const getUserAggregatedInfo = (id: number) => {
    return fetchFromApi('/api/dashboard/accounts/users/' + id).then(response => response.ok ? response.json().then(data => data as AggregateUserInfoDto) : null);
}

export const getUserAchievements = (id: number, lang: string = 'en') => {
    return dashboardGetJson<UserAchievementsAdminDto>(
        '/api/dashboard/accounts/users/' + id + '/achievements?lang=' + encodeURIComponent(lang),
        'user-achievements',
    );
}

const postUserAchievementsAction = async (
    id: number,
    action: string,
): Promise<{ data: UserAchievementsAdminDto | null; error: string | null }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { data: null, error: 'Missing access token' };
        const result = await fetch(BASE_URL + '/api/dashboard/accounts/users/' + id + '/achievements/' + action, {
            method: 'POST',
            headers: { 'Authorization': accessToken },
        });
        if (!result.ok) {
            const errorText = await result.text().catch(() => '');
            return { data: null, error: errorText || `HTTP ${result.status}` };
        }
        return { data: (await result.json()) as UserAchievementsAdminDto, error: null };
    } catch (e) {
        return { data: null, error: e instanceof Error ? e.message : 'Network error' };
    }
}

/** Completes the backing user task; the legacy row flips when the crons listener applies the unlock. */
export const openUserAchievement = (id: number, achievementId: number) =>
    postUserAchievementsAction(id, achievementId + '/open');

export const resetUserAchievement = (id: number, achievementId: number) =>
    postUserAchievementsAction(id, achievementId + '/reset');

/** ensureProvisioned on demand: adds missing legacy rows and tasks. */
export const consolidateUserAchievements = (id: number) =>
    postUserAchievementsAction(id, 'consolidate');

export const getUserDailyBonus = (id: number) => {
    return dashboardGetJson<UserDailyBonusAdminDto>(
        '/api/dashboard/accounts/users/' + id + '/daily-bonus',
        'user-daily-bonus',
    );
}

/** Spring error bodies carry the reason in `message` (when enabled); fall back to the raw text. */
const errorMessageOf = (text: string, status: number) => {
    try {
        const parsed = JSON.parse(text);
        if (parsed && typeof parsed.message === 'string' && parsed.message) return parsed.message as string;
        if (parsed && typeof parsed.error === 'string') return `${parsed.error} (HTTP ${status})`;
    } catch { /* not JSON */ }
    return text || `HTTP ${status}`;
}

const postUserDailyBonusAction = async (
    id: number,
    action: string,
    body?: object,
): Promise<{ data: DailyBonusEffectsChangeDto | null; error: string | null }> => {
    try {
        const result = await fetchFromApi('/api/dashboard/accounts/users/' + id + '/daily-bonus/' + action, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body ?? {}),
        });
        if (!result.ok) {
            const errorText = await result.text().catch(() => '');
            return { data: null, error: errorMessageOf(errorText, result.status) };
        }
        return { data: (await result.json()) as DailyBonusEffectsChangeDto, error: null };
    } catch (e) {
        return { data: null, error: e instanceof Error ? e.message : 'Network error' };
    }
}

/** Marketing › Subscriptions: the plans (read-only) with their benefits and the subscription effect catalogue. */
export const getSubscriptionPlans = () =>
    dashboardGetJson<SubscriptionPlansAdminDto>('/api/dashboard/subscriptions/plans', 'subscription-plans');

/** Live subscribers, newest first; `tier` PLUS / MAX, `shop` APPLE / GOOGLE / BETUP, `test` REAL / TEST (each or ALL), `page` from 0. */
export const getSubscribers = (tier: string, shop: string, test: string, page: number, limit: number) =>
    dashboardGetJson<SubscribersPageDto>(
        `/api/dashboard/subscriptions/subscribers?tier=${encodeURIComponent(tier)}&shop=${encodeURIComponent(shop)}`
            + `&test=${encodeURIComponent(test)}&offset=${page}&limit=${limit}`,
        'subscribers',
    );

/** One subscription's events, oldest first. */
export const getSubscriptionEvents = (subscriptionId: number) =>
    dashboardGetJson<SubscriptionEventItemDto[]>(`/api/dashboard/subscriptions/subscribers/${subscriptionId}/events`, 'subscription-events');

/**
 * The app's subscription purchases and the stores' notifications, newest first; `type` / `status`, `store` APPLE / GOOGLE,
 * `test` REAL / TEST (each or ALL), `page` from 0.
 */
export const getSubscriptionStoreEvents = (type: string, status: string, store: string, test: string, page: number, limit: number) =>
    dashboardGetJson<StoreEventsPageDto>(
        `/api/dashboard/subscriptions/store-events?type=${encodeURIComponent(type)}&status=${encodeURIComponent(status)}`
            + `&store=${encodeURIComponent(store)}&test=${encodeURIComponent(test)}&offset=${page}&limit=${limit}`,
        'subscription-store-events',
    );

/** Replaces a plan's benefits, in order. */
export const updateSubscriptionPlanBenefits = async (
    planId: number,
    benefits: { type: 'EFFECT' | 'DAILY_COINS'; effectId?: number | null; dailyCoins?: number | null }[],
): Promise<{ data: SubscriptionPlansAdminDto | null; error: string | null }> => {
    try {
        const result = await fetchFromApi(`/api/dashboard/subscriptions/plans/${planId}/benefits`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ benefits }),
        });
        if (!result.ok) {
            const errorText = await result.text().catch(() => '');
            return { data: null, error: errorMessageOf(errorText, result.status) };
        }
        return { data: (await result.json()) as SubscriptionPlansAdminDto, error: null };
    } catch (e) {
        return { data: null, error: e instanceof Error ? e.message : 'Network error' };
    }
}

const subscriptionOffersRequest = async (
    path: string,
    method: 'POST' | 'PUT' | 'DELETE',
    body?: object,
): Promise<{ data: SubscriptionOffersAdminDto | null; error: string | null }> => {
    try {
        const result = await fetchFromApi('/api/dashboard/subscriptions/offers/' + path, {
            method,
            headers: { 'Content-Type': 'application/json' },
            body: body === undefined ? undefined : JSON.stringify(body),
        });
        if (!result.ok) {
            const errorText = await result.text().catch(() => '');
            return { data: null, error: errorMessageOf(errorText, result.status) };
        }
        return { data: (await result.json()) as SubscriptionOffersAdminDto, error: null };
    } catch (e) {
        return { data: null, error: e instanceof Error ? e.message : 'Network error' };
    }
}

/** Marketing › Subscriptions › Offers: benefit offer templates, the rules giving them, and the plan catalogue. */
export const getSubscriptionOffers = () =>
    dashboardGetJson<SubscriptionOffersAdminDto>('/api/dashboard/subscriptions/offers', 'subscription-offers');

export const createSubscriptionOfferTemplate = (request: SubscriptionOfferTemplateRequest) =>
    subscriptionOffersRequest('templates', 'POST', request);

export const updateSubscriptionOfferTemplate = (id: number, request: SubscriptionOfferTemplateRequest) =>
    subscriptionOffersRequest(`templates/${id}`, 'PUT', request);

export const createSubscriptionOfferRule = (request: SubscriptionOfferRuleRequest) =>
    subscriptionOffersRequest('rules', 'POST', request);

export const updateSubscriptionOfferRule = (id: string, request: SubscriptionOfferRuleRequest) =>
    subscriptionOffersRequest(`rules/${encodeURIComponent(id)}`, 'PUT', request);

export const deleteSubscriptionOfferRule = (id: string) =>
    subscriptionOffersRequest(`rules/${encodeURIComponent(id)}`, 'DELETE');

export const getUserPremium = (id: number) => {
    return dashboardGetJson<UserPremiumAdminDto>(
        '/api/dashboard/accounts/users/' + id + '/premium',
        'user-premium',
    );
}

const userPremiumRequest = async <T = UserPremiumAdminDto>(
    id: number,
    path: string,
    method: 'GET' | 'POST' | 'PUT',
    body?: object,
): Promise<{ data: T | null; error: string | null }> => {
    try {
        const result = await fetchFromApi('/api/dashboard/accounts/users/' + id + '/premium/' + path, {
            method,
            headers: { 'Content-Type': 'application/json' },
            body: method === 'GET' ? undefined : JSON.stringify(body ?? {}),
        });
        if (!result.ok) {
            const errorText = await result.text().catch(() => '');
            return { data: null, error: errorMessageOf(errorText, result.status) };
        }
        return { data: (await result.json()) as T, error: null };
    } catch (e) {
        return { data: null, error: e instanceof Error ? e.message : 'Network error' };
    }
}

/** Grants `plan` for `days` days as a BETUP subscription (extends a live BETUP one of the same plan). */
export const grantUserSubscription = (id: number, plan: string, days: number, note?: string) =>
    userPremiumRequest(id, 'subscriptions', 'POST', { plan, days, note });

/** Ends a subscription now (REVOKED) with its benefits. */
export const revokeUserSubscription = (id: number, subscriptionId: number, note?: string) =>
    userPremiumRequest(id, `subscriptions/${subscriptionId}/revoke`, 'POST', { note });

/** Gives the player a benefit offer template, to take by subscribing within `days` (1–90; default the template's claim days). */
export const giveUserSubscriptionOffer = (id: number, offerId: number, days: number | undefined, note: string | undefined, push: boolean) =>
    userPremiumRequest(id, 'offers', 'POST', { offerId, days, note, push });

/** Revokes a given benefit offer (AVAILABLE or TAKEN). */
export const revokeUserSubscriptionOffer = (id: number, userOfferId: number, note?: string) =>
    userPremiumRequest(id, `offers/${userOfferId}/revoke`, 'POST', { note });

/** Checks a subscription against its plan and the effects it should have given. */
export const validateUserSubscription = (id: number, subscriptionId: number) =>
    userPremiumRequest<SubscriptionValidationDto>(id, `subscriptions/${subscriptionId}/validation`, 'GET');

/** Re-applies a subscription's benefits (what its validation expects). */
export const applyUserSubscriptionBenefits = (id: number, subscriptionId: number) =>
    userPremiumRequest(id, `subscriptions/${subscriptionId}/apply-benefits`, 'POST');

/** Changes one subscription-group effect: another row of its group, a new end, on or off. */
export const updateUserSubscriptionEffect = (
    id: number,
    userEffectId: number,
    change: { effectId?: number; expires?: string; active?: boolean },
) => userPremiumRequest(id, `effects/${userEffectId}`, 'PUT', change);

/** Deactivates every active daily bonus effect (multiplier back to x1). */
export const cleanupUserDailyBonusEffects = (id: number) =>
    postUserDailyBonusAction(id, 'effects/cleanup');

export const deactivateUserDailyBonusEffect = (id: number, userEffectId: number) =>
    postUserDailyBonusAction(id, 'effects/' + userEffectId + '/deactivate');

/** Grants an existing daily bonus effect (group 15) for durationHours; Crons expires it. */
export const grantUserDailyBonusEffect = (id: number, effectId: number, durationHours: number) =>
    postUserDailyBonusAction(id, 'effects', { effectId, durationHours });

export const getUserCampaign = (id: number) => {
    return dashboardGetJson<UserCampaignAdminDto>(
        '/api/dashboard/accounts/users/' + id + '/campaign',
        'user-campaign',
    );
}

const postUserCampaignAction = async (
    id: number,
    action: string,
    body?: object,
): Promise<{ data: UserCampaignAdminDto | null; error: string | null }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { data: null, error: 'Missing access token' };
        const result = await fetch(BASE_URL + '/api/dashboard/accounts/users/' + id + '/campaign/' + action, {
            method: 'POST',
            headers: { 'Authorization': accessToken, 'Content-Type': 'application/json' },
            body: JSON.stringify(body ?? {}),
        });
        if (!result.ok) {
            const errorText = await result.text().catch(() => '');
            return { data: null, error: errorText || `HTTP ${result.status}` };
        }
        return { data: (await result.json()) as UserCampaignAdminDto, error: null };
    } catch (e) {
        return { data: null, error: e instanceof Error ? e.message : 'Network error' };
    }
}

/** Sets a goal's progress on the active chapter; never a paid skip. */
export const setUserCampaignGoalProgress = (id: number, goalId: number, body: { progressCurrent?: number; markCompleted?: boolean }) =>
    postUserCampaignAction(id, 'goals/' + goalId + '/progress', body);

/** Closes the active chapter as 1–3 stars and pays the reward scaled by them. */
export const completeUserCampaignMission = (id: number, stars: number) =>
    postUserCampaignAction(id, 'current/complete', { stars });

/** Timer from now, every goal back to zero. */
export const resetUserCampaignMission = (id: number) =>
    postUserCampaignAction(id, 'current/reset');

/** Only the last completed chapter (with nothing active after it). */
export const reopenUserCampaignMission = (id: number, missionId: number) =>
    postUserCampaignAction(id, 'missions/' + missionId + '/reopen');

// ---- BETUP Feed moderation (analytics `/api/dashboard/marketing/feed` → v7 admin; betup-server-api docs/feed-moderation.md) ----

const BETUP_FEED_BASE = '/api/dashboard/marketing/feed';

/** GET labels, for {@link getDashboardApiError}. */
export const BETUP_FEED_LABELS = {
    reviewSettings: 'betup-feed-review-settings',
    reviewStats: 'betup-feed-review-stats',
    posts: 'betup-feed-posts',
    postReports: 'betup-feed-post-reports',
    messageReports: 'betup-feed-message-reports',
    topUsers: 'betup-feed-top-users',
    userPosts: 'betup-feed-user-posts',
    userViolations: 'betup-feed-user-violations',
    userModerationSummary: 'betup-feed-user-moderation-summary',
    channels: 'betup-feed-channels',
    channelPosts: 'betup-feed-channel-posts',
    channelCategories: 'betup-feed-channel-categories',
    channelSubscriberStats: 'betup-feed-channel-subscriber-stats',
    channelSubscribers: 'betup-feed-channel-subscribers',
    channelSubscriberEvents: 'betup-feed-channel-subscriber-events',
    channelOverview: 'betup-feed-channel-overview',
    channelTimeline: 'betup-feed-channel-timeline',
    widgets: 'betup-feed-widgets',
    postLikes: 'betup-feed-post-likes',
    postComments: 'betup-feed-post-comments',
} as const;

/** The `message` (or `error`) of a v7 error JSON, else the raw body text. */
const betupFeedErrorMessage = (text: string): string => {
    try {
        const parsed = JSON.parse(text);
        const message = parsed?.message ?? parsed?.error;
        return typeof message === 'string' && message ? message : text;
    } catch {
        return text;
    }
}

/**
 * POST / PUT / DELETE under the feed proxy. Actions answer 204 with no body: success is `error == null`, and `data`
 * is null then. Errors carry the response body text (the v7 error JSON) or the HTTP status. DELETE sends no body.
 */
const sendBetupFeedRequest = async <T,>(
    method: 'POST' | 'PUT' | 'DELETE',
    path: string,
    body?: object,
): Promise<{ data: T | null; error: string | null }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { data: null, error: 'Missing access token' };
        const result = await fetch(BASE_URL + BETUP_FEED_BASE + path, method === 'DELETE'
            ? { method, headers: { 'Authorization': accessToken } }
            : {
                method,
                headers: { 'Authorization': accessToken, 'Content-Type': 'application/json' },
                body: JSON.stringify(body ?? {}),
            });
        if (!result.ok) {
            const errorText = await result.text().catch(() => '');
            return { data: null, error: betupFeedErrorMessage(errorText) || `HTTP ${result.status}` };
        }
        if (result.status === 204) return { data: null, error: null };
        const text = await result.text();
        return { data: text ? (JSON.parse(text) as T) : null, error: null };
    } catch (e) {
        return { data: null, error: e instanceof Error ? e.message : 'Network error' };
    }
}

/** A `qbet_app_settings` row through the analytics generic settings proxy (`/api/dashboard/admin/settings`). */
export interface DashboardAppSettingDto {
    key: string;
    valueType: 'STRING' | 'TEXT' | 'DECIMAL' | 'BOOLEAN' | 'DATETIME';
    stringValue?: string | null;
    textValue?: string | null;
    decimalValue?: number | null;
    booleanValue?: boolean | null;
    dateTimeValue?: string | null;
}

/** The feed's hot-match threshold (docs/feed-configuration.md §2): matches with at least this many bets are hot. */
export const FEED_HOT_MATCH_MIN_BETS_KEY = 'feed.hot_match.min_bets';

/** null when missing (not seeded yet) or on failure — see getDashboardApiError(label). */
export const getDashboardAppSetting = (key: string) =>
    dashboardGetJson<DashboardAppSettingDto>(`/api/dashboard/admin/settings/key/${encodeURIComponent(key)}`, `app-setting-${key}`);

/** Every app setting whose key starts with [prefix]; null on failure. */
export const listDashboardAppSettings = (prefix: string) =>
    dashboardGetJson<DashboardAppSettingDto[]>(`/api/dashboard/admin/settings?prefix=${encodeURIComponent(prefix)}`, `app-settings-${prefix}`);

/** Upserts a setting of any type (`{valueType, decimalValue | stringValue | booleanValue | …}`); returns the saved row. */
export const putDashboardAppSetting = async (key: string, body: Partial<DashboardAppSettingDto> & { valueType: DashboardAppSettingDto['valueType'] }): Promise<{ data: DashboardAppSettingDto | null; error: string | null }> => {
    try {
        const result = await fetchFromApi(`/api/dashboard/admin/settings/key/${encodeURIComponent(key)}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        if (!result.ok) {
            const errorText = await result.text().catch(() => '');
            return { data: null, error: betupFeedErrorMessage(errorText) || `HTTP ${result.status}` };
        }
        const text = await result.text();
        return { data: text ? (JSON.parse(text) as DashboardAppSettingDto) : null, error: null };
    } catch (e) {
        return { data: null, error: e instanceof Error ? e.message : 'Network error' };
    }
}

/** Upserts a DECIMAL setting; returns the saved row. */
export const putDashboardDecimalSetting = async (key: string, value: number): Promise<{ data: DashboardAppSettingDto | null; error: string | null }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { data: null, error: 'Missing access token' };
        const result = await fetch(BASE_URL + `/api/dashboard/admin/settings/key/${encodeURIComponent(key)}`, {
            method: 'PUT',
            headers: { 'Authorization': accessToken, 'Content-Type': 'application/json' },
            body: JSON.stringify({ valueType: 'DECIMAL', decimalValue: value }),
        });
        if (!result.ok) {
            const errorText = await result.text().catch(() => '');
            return { data: null, error: betupFeedErrorMessage(errorText) || `HTTP ${result.status}` };
        }
        const text = await result.text();
        return { data: text ? (JSON.parse(text) as DashboardAppSettingDto) : null, error: null };
    } catch (e) {
        return { data: null, error: e instanceof Error ? e.message : 'Network error' };
    }
}

export const getBetupFeedReviewSettings = () =>
    dashboardGetJson<BetupFeedReviewSettingsDto>(BETUP_FEED_BASE + '/review/settings', BETUP_FEED_LABELS.reviewSettings);

/** Returns the saved settings. */
export const updateBetupFeedReviewSettings = (settings: BetupFeedReviewSettingsDto) =>
    sendBetupFeedRequest<BetupFeedReviewSettingsDto>('PUT', '/review/settings', settings);

export const getBetupFeedReviewStats = () =>
    dashboardGetJson<BetupFeedReviewStatsDto>(BETUP_FEED_BASE + '/review/stats', BETUP_FEED_LABELS.reviewStats);

export const getBetupFeedPosts = (status: BetupFeedReviewStatus, offset: number, limit: number) =>
    dashboardGetJson<BetupFeedPaginatedDto<BetupFeedAdminPostDto>>(
        `${BETUP_FEED_BASE}/posts?status=${status}&offset=${offset}&limit=${limit}`,
        BETUP_FEED_LABELS.posts,
    );

/** Publishes the post (a pending or rejected one). 204. */
export const approveBetupFeedPost = (postId: number) =>
    sendBetupFeedRequest<void>('POST', `/posts/${postId}/approve`);

/** Rejects the post with an optional reason the author sees. 204. */
/** Both required; the author sees them. Resolves the post's open reports; final (the author can no longer edit it). */
export const rejectBetupFeedPost = (postId: number, reason: string, categories: string[]) =>
    sendBetupFeedRequest<void>('POST', `/posts/${postId}/reject`, { reason: reason.trim(), categories });

export const getBetupFeedPostReports = (status: BetupFeedReportStatusFilter, offset: number, limit: number) =>
    dashboardGetJson<BetupFeedPaginatedDto<BetupFeedReportedPostDto>>(
        `${BETUP_FEED_BASE}/post-reports?status=${status}&offset=${offset}&limit=${limit}`,
        BETUP_FEED_LABELS.postReports,
    );

/** 204. */
export const hideBetupFeedPost = (postId: number) =>
    sendBetupFeedRequest<void>('POST', `/posts/${postId}/hide`);

/** 204. Republishes only an approved post. */
export const unhideBetupFeedPost = (postId: number) =>
    sendBetupFeedRequest<void>('POST', `/posts/${postId}/unhide`);

/** Marks the post's open reports reviewed. 204. */
export const resolveBetupFeedPostReports = (postId: number) =>
    sendBetupFeedRequest<void>('POST', `/posts/${postId}/reports/resolve`);

export const getBetupFeedMessageReports = (status: BetupFeedReportStatusFilter, offset: number, limit: number) =>
    dashboardGetJson<BetupFeedPaginatedDto<BetupFeedMessageReportDto>>(
        `${BETUP_FEED_BASE}/message-reports?status=${status}&offset=${offset}&limit=${limit}`,
        BETUP_FEED_LABELS.messageReports,
    );

/** 204. */
export const resolveBetupFeedMessageReport = (reportId: number) =>
    sendBetupFeedRequest<void>('POST', `/message-reports/${reportId}/resolve`);

/** All of one user's posts (pending, approved, rejected, deleted), newest first. */
export const getBetupFeedUserPosts = (userId: number, offset: number, limit: number) =>
    dashboardGetJson<BetupFeedPaginatedDto<BetupFeedAdminPostDto>>(
        `${BETUP_FEED_BASE}/users/${userId}/posts?offset=${offset}&limit=${limit}`,
        BETUP_FEED_LABELS.userPosts,
    );

/** Post and message reports other players made about the user, newest first. */
export const getBetupFeedUserViolations = (userId: number, offset: number, limit: number) =>
    dashboardGetJson<BetupFeedPaginatedDto<BetupFeedUserViolationDto>>(
        `${BETUP_FEED_BASE}/users/${userId}/violations?offset=${offset}&limit=${limit}`,
        BETUP_FEED_LABELS.userViolations,
    );

export const getBetupFeedUserModerationSummary = (userId: number) =>
    dashboardGetJson<BetupFeedUserModerationSummaryDto>(
        `${BETUP_FEED_BASE}/users/${userId}/moderation-summary`,
        BETUP_FEED_LABELS.userModerationSummary,
    );

/** One page of the top players feed; pass the previous page's `next_cursor`. */
export const getBetupFeedTopUsers = (cursor: string | null, limit: number) =>
    dashboardGetJson<BetupFeedPageDto>(
        `${BETUP_FEED_BASE}/top-users?limit=${limit}` + (cursor ? '&cursor=' + encodeURIComponent(cursor) : ''),
        BETUP_FEED_LABELS.topUsers,
    );

// ---- BETUP Feed channels (betup-server-api docs/feed-channels.md §4) ----

/** All channels, inactive too. */
export const getBetupFeedChannels = () =>
    dashboardGetJson<BetupFeedChannelDto[]>(BETUP_FEED_BASE + '/channels', BETUP_FEED_LABELS.channels);

/** The channel page's figures now (subscribers, posts by status, engagement, sales, top posts). */
export const getBetupFeedChannelOverview = (channelId: number) =>
    dashboardGetJson<BetupFeedChannelOverviewDto>(`${BETUP_FEED_BASE}/channels/${channelId}/overview`, BETUP_FEED_LABELS.channelOverview);

/** A page of the channel's posts, newest first; `cursor` null = the first page. */
export const getBetupFeedChannelTimeline = (
    channelId: number, cursor: string | null, limit: number, status: BetupFeedChannelPostStatus, deleted: boolean,
) =>
    dashboardGetJson<BetupFeedChannelTimelineDto>(
        `${BETUP_FEED_BASE}/channels/${channelId}/timeline?limit=${limit}&status=${status}&deleted=${deleted}` +
        (cursor ? `&cursor=${encodeURIComponent(cursor)}` : ''),
        BETUP_FEED_LABELS.channelTimeline,
    );

/** Who liked a channel post, newest first. */
export const getBetupFeedChannelPostLikes = (channelId: number, postId: number, offset: number, limit: number) =>
    dashboardGetJson<BetupFeedPaginatedDto<BetupFeedPostLikeDto>>(
        `${BETUP_FEED_BASE}/channels/${channelId}/posts/${postId}/likes?offset=${offset}&limit=${limit}`,
        BETUP_FEED_LABELS.postLikes,
    );

/** Feed-post comments live in the messaging service, reached through the support proxy (admin API key). */
const FEED_COMMENTS_BASE = '/api/dashboard/support/admin/feed';

/** A post's root comments, newest first; `continuationToken` null = the first page. */
export const getBetupFeedPostComments = (postId: number, continuationToken: string | null, pageSize = 20) =>
    dashboardGetJson<BetupFeedCommentPageDto>(
        `${FEED_COMMENTS_BASE}/posts/${postId}/comments?pageSize=${pageSize}` +
        (continuationToken ? `&continuationToken=${encodeURIComponent(continuationToken)}` : ''),
        BETUP_FEED_LABELS.postComments,
    );

/** The replies to a comment, newest first. */
export const getBetupFeedCommentReplies = (messageId: number, continuationToken: string | null, pageSize = 20) =>
    dashboardGetJson<BetupFeedCommentPageDto>(
        `${FEED_COMMENTS_BASE}/comments/${messageId}/replies?pageSize=${pageSize}` +
        (continuationToken ? `&continuationToken=${encodeURIComponent(continuationToken)}` : ''),
        BETUP_FEED_LABELS.postComments,
    );

/** Deletes any comment with its replies; the post's comment counter follows within seconds (via the queue). */
export const deleteBetupFeedComment = async (messageId: number): Promise<{ deleted: number | null; error: string | null }> => {
    try {
        const response = await fetchFromApi(`${FEED_COMMENTS_BASE}/comments/${messageId}`, { method: 'DELETE' });
        if (!response.ok) {
            const text = await response.text().catch(() => '');
            return { deleted: null, error: betupFeedErrorMessage(text) || `HTTP ${response.status}` };
        }
        const body = await response.json().catch(() => null);
        return { deleted: typeof body?.deleted === 'number' ? body.deleted : null, error: null };
    } catch (e) {
        return { deleted: null, error: e instanceof Error ? e.message : String(e) };
    }
};

/** What live post widgets draw, by id, names in `lang`. */
export const getBetupFeedWidgets = (ids: { matchIds: number[]; userIds: number[]; teamIds: number[] }, lang: string) =>
    dashboardGetJson<BetupFeedWidgetDataDto>(
        `${BETUP_FEED_BASE}/widgets?match_ids=${ids.matchIds.join(',')}&user_ids=${ids.userIds.join(',')}` +
        `&team_ids=${ids.teamIds.join(',')}&lang=${encodeURIComponent(lang)}`,
        BETUP_FEED_LABELS.widgets,
    );

/** A period of whole days `from`..`to` (yyyy-MM-dd, both included) in the IANA time zone `tz`. */
export interface BetupFeedPeriod {
    from: string;
    to: string;
    tz: string;
}

const periodQuery = (period: BetupFeedPeriod) =>
    `from=${encodeURIComponent(period.from)}&to=${encodeURIComponent(period.to)}&tz=${encodeURIComponent(period.tz)}`;

/** Subscribes, unsubscribes and totals per day of the period, and who subscribed (country / platform / language). */
export const getBetupFeedChannelSubscriberStats = (channelId: number, period: BetupFeedPeriod) =>
    dashboardGetJson<BetupFeedChannelSubscriberStatsDto>(
        `${BETUP_FEED_BASE}/channels/${channelId}/subscribers/stats?${periodQuery(period)}`,
        BETUP_FEED_LABELS.channelSubscriberStats,
    );

/** The channel's current subscribers, newest first; `query` = part of a name or a user id. */
export const getBetupFeedChannelSubscribers = (channelId: number, query: string, offset: number, limit: number) =>
    dashboardGetJson<BetupFeedPaginatedDto<BetupFeedChannelSubscriberDto>>(
        `${BETUP_FEED_BASE}/channels/${channelId}/subscribers?query=${encodeURIComponent(query)}&offset=${offset}&limit=${limit}`,
        BETUP_FEED_LABELS.channelSubscribers,
    );

/** The channel's subscribes and unsubscribes over the period, newest first. */
export const getBetupFeedChannelSubscriberEvents = (
    channelId: number, period: BetupFeedPeriod, kind: BetupFeedChannelSubscriberEventKind, offset: number, limit: number,
) =>
    dashboardGetJson<BetupFeedPaginatedDto<BetupFeedChannelSubscriberEventDto>>(
        `${BETUP_FEED_BASE}/channels/${channelId}/subscribers/events?${periodQuery(period)}&kind=${kind}&offset=${offset}&limit=${limit}`,
        BETUP_FEED_LABELS.channelSubscriberEvents,
    );

/** All channel categories, inactive too. */
export const getBetupFeedChannelCategories = () =>
    dashboardGetJson<BetupFeedChannelCategoryDto[]>(BETUP_FEED_BASE + '/channel-categories', BETUP_FEED_LABELS.channelCategories);

export const createBetupFeedChannelCategory = (category: BetupFeedChannelCategoryRequestDto) =>
    sendBetupFeedRequest<BetupFeedChannelCategoryDto>('POST', '/channel-categories', category);

export const updateBetupFeedChannelCategory = (categoryId: number, category: BetupFeedChannelCategoryRequestDto) =>
    sendBetupFeedRequest<BetupFeedChannelCategoryDto>('PUT', `/channel-categories/${categoryId}`, category);

/** Returns the created channel; a 400 carries the validation message (e.g. a duplicate English name). */
export const createBetupFeedChannel = (channel: BetupFeedChannelRequestDto) =>
    sendBetupFeedRequest<BetupFeedChannelDto>('POST', '/channels', channel);

/** Fields left out keep their value. Returns the saved channel. */
export const updateBetupFeedChannel = (channelId: number, changes: BetupFeedChannelRequestDto) =>
    sendBetupFeedRequest<BetupFeedChannelDto>('PUT', `/channels/${channelId}`, changes);

/** The channel's posts, newest first, deleted too; `status` filters drafts / published ones. */
export const getBetupFeedChannelPosts = (
    channelId: number, offset: number, limit: number, status: BetupFeedChannelPostStatus = 'all',
) =>
    dashboardGetJson<BetupFeedPaginatedDto<BetupFeedChannelPostDto>>(
        `${BETUP_FEED_BASE}/channels/${channelId}/posts?offset=${offset}&limit=${limit}&status=${status}`,
        BETUP_FEED_LABELS.channelPosts,
    );

/** Creates an `AGENT_POST` (published, or a draft with `draft: true`); returns it. */
export const createBetupFeedChannelPost = (channelId: number, post: BetupFeedChannelPostRequestDto) =>
    sendBetupFeedRequest<BetupFeedChannelPostDto>('POST', `/channels/${channelId}/posts`, post);

/** Soft-deletes the post (it leaves the feeds). 204. */
export const deleteBetupFeedChannelPost = (channelId: number, postId: number) =>
    sendBetupFeedRequest<void>('DELETE', `/channels/${channelId}/posts/${postId}`);

/** Edits a post (draft or published) in place: only the changed fields. Returns the saved post. */
export const updateBetupFeedChannelPost = (channelId: number, postId: number, changes: BetupFeedChannelPostUpdateRequestDto) =>
    sendBetupFeedRequest<BetupFeedChannelPostDto>('PUT', `/channels/${channelId}/posts/${postId}`, changes);

/** Publishes a draft now: it moves to the top of the feed. A published post is a no-op. */
export const publishBetupFeedChannelPost = (channelId: number, postId: number) =>
    sendBetupFeedRequest<BetupFeedChannelPostDto>('POST', `/channels/${channelId}/posts/${postId}/publish`);

// ---- Publishing: AI channel articles (betup-server-api docs/channel-articles.md §8) ----

const PUBLISHING_BASE = BETUP_FEED_BASE + '/publishing';

/** Channel posts across channels, newest first; null on failure. */
export const getPublishingPosts = (offset: number, limit: number, status: PublishingPostStatus, filters: { channelId?: number | null; matchId?: number | null; ai?: boolean | null } = {}) =>
    dashboardGetJson<PublishingPostPageDto>(
        `${PUBLISHING_BASE}/posts?offset=${offset}&limit=${limit}&status=${status}`
        + `${filters.channelId ? `&channel_id=${filters.channelId}` : ''}${filters.matchId ? `&match_id=${filters.matchId}` : ''}`
        + `${filters.ai != null ? `&ai=${filters.ai}` : ''}`,
        'publishing-posts',
    );

/** Article invocations newest first; `sort` 'status' orders by stage; null on failure. */
export const getChannelArticleExecutions = (offset: number, limit: number, status: ChannelArticleStatus | null, sort: 'created' | 'status',
    direction: 'asc' | 'desc', filters: { channelId?: number | null; matchId?: number | null } = {}) =>
    dashboardGetJson<ChannelArticleExecutionPageDto>(
        `${PUBLISHING_BASE}/executions?offset=${offset}&limit=${limit}&sort=${sort}&direction=${direction}${status ? `&status=${status}` : ''}`
        + `${filters.channelId ? `&channel_id=${filters.channelId}` : ''}${filters.matchId ? `&match_id=${filters.matchId}` : ''}`,
        'channel-article-executions',
    );

export const getChannelArticleExecution = (id: number) =>
    dashboardGetJson<ChannelArticleExecutionDto>(`${PUBLISHING_BASE}/executions/${id}`, 'channel-article-execution');

/** A match's channel posts (drafts too) and an article invocation in progress; null on failure. */
export const getMatchPublishing = (matchId: number) =>
    dashboardGetJson<MatchPublishingDto>(`${PUBLISHING_BASE}/matches/${matchId}`, 'match-publishing');

/** A channel's article invocation in progress; null when none (204) or on failure. */
export const getChannelArticleRunning = async (channelId: number): Promise<ChannelArticleExecutionDto | null> => {
    try {
        const response = await fetchFromApi(`${PUBLISHING_BASE}/channels/${channelId}/running`);
        return response.status === 200 ? (await response.json()) as ChannelArticleExecutionDto : null;
    } catch {
        return null;
    }
}

/**
 * A manual article trigger to Crons (no scheduler limits): for [channelId] (null = the scheduler's next channel) about
 * [matchId] (null = the channel's best match); error = the server's message.
 */
export const triggerChannelArticle = async (channelId: number | null, matchId: number | null): Promise<{ error: string | null }> => {
    try {
        const response = await fetchFromApi(`${PUBLISHING_BASE}/trigger`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...(channelId == null ? {} : { channel_id: channelId }), ...(matchId == null ? {} : { match_id: matchId }) }),
        });
        if (response.ok) return { error: null };
        const text = await response.text().catch(() => '');
        let message = '';
        try { message = JSON.parse(text)?.message ?? ''; } catch { message = text; }
        return { error: message || `HTTP ${response.status}` };
    } catch (e) {
        return { error: e instanceof Error ? e.message : 'Network error' };
    }
}

// ---- AI (analytics `/api/dashboard/ai/**` → betup-server-ai `/api/v1/admin/**`; betup-server-ai docs/api.md) ----

const AI_BASE = '/api/dashboard/ai';

/** GET labels, for {@link getDashboardApiError}. */
export const AI_LABELS = {
    meta: 'ai-meta',
    health: 'ai-health',
    models: 'ai-models',
    providerKeys: 'ai-provider-keys',
    tasks: 'ai-tasks',
    task: 'ai-task',
    agents: 'ai-agents',
    agent: 'ai-agent',
    agentLinks: 'ai-agent-links',
    agentTools: 'ai-agent-tools',
    mcpServers: 'ai-mcp-servers',
    mcpTools: 'ai-mcp-tools',
    mcpResources: 'ai-mcp-resources',
    budgets: 'ai-budgets',
    budgetEvents: 'ai-budget-events',
    userBudgets: 'ai-user-budgets',
    usageSummary: 'ai-usage-summary',
    usageCalls: 'ai-usage-calls',
    endUserUsage: 'ai-end-user-usage',
    runs: 'ai-runs',
    run: 'ai-run',
    taskExecutions: 'ai-task-executions',
    taskExecution: 'ai-task-execution',
    conversations: 'ai-conversations',
    toolStats: 'ai-tool-stats',
    toolInvocations: 'ai-tool-invocations',
    agentStats: 'ai-agent-stats',
    conversation: 'ai-conversation',
    workflows: 'ai-workflows',
    workflow: 'ai-workflow',
    workflowStats: 'ai-workflow-stats',
    workflowRun: 'ai-workflow-run',
    workflowOverview: 'ai-workflow-overview',
} as const;

/** `success` = `error == null`; `code` / `details` come from the AI error body `{ message, code, details }`. */
export interface AiRequestResult<T> {
    data: T | null;
    error: string | null;
    code: string | null;
    status: number | null;
    details: AiJsonObject | null;
}

const aiQuery = (params: Record<string, string | number | boolean | null | undefined>): string => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value === null || value === undefined || value === '') return;
        search.set(key, String(value));
    });
    const text = search.toString();
    return text ? '?' + text : '';
};

/** Parses an AI error body; falls back to the raw text. */
export const parseAiError = (text: string): { message: string; code: string | null; details: AiJsonObject | null } => {
    try {
        const parsed = JSON.parse(text);
        const message = parsed?.message ?? parsed?.error;
        return {
            message: typeof message === 'string' && message ? message : text,
            code: typeof parsed?.code === 'string' ? parsed.code : null,
            details: parsed?.details && typeof parsed.details === 'object' ? parsed.details as AiJsonObject : null,
        };
    } catch {
        return { message: text, code: null, details: null };
    }
};

/**
 * Request under the AI proxy. 204 → `data` null. 202 (agent run still running) counts as success.
 * GET and a body-less DELETE send no body. Plain GETs use dashboardGetJson; GET here when the caller needs the error code.
 */
const sendAiRequest = async <T,>(
    method: 'GET' | 'POST' | 'PUT' | 'DELETE',
    path: string,
    body?: object,
): Promise<AiRequestResult<T>> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { data: null, error: 'Missing access token', code: null, status: null, details: null };
        const result = await fetch(BASE_URL + AI_BASE + path, method === 'GET' || (method === 'DELETE' && body === undefined)
            ? { method, headers: { 'Authorization': accessToken } }
            : {
                method,
                headers: { 'Authorization': accessToken, 'Content-Type': 'application/json' },
                body: JSON.stringify(body ?? {}),
            });
        if (!result.ok) {
            const errorText = await result.text().catch(() => '');
            const parsed = parseAiError(errorText);
            return {
                data: null,
                error: parsed.message || `HTTP ${result.status}`,
                code: parsed.code,
                status: result.status,
                details: parsed.details,
            };
        }
        if (result.status === 204) return { data: null, error: null, code: null, status: 204, details: null };
        const text = await result.text();
        return { data: text ? (JSON.parse(text) as T) : null, error: null, code: null, status: result.status, details: null };
    } catch (e) {
        return { data: null, error: e instanceof Error ? e.message : 'Network error', code: null, status: null, details: null };
    }
};

const enc = encodeURIComponent;

export const getAiHealth = () =>
    dashboardGetJson<DashboardAiHealthDto>('/api/dashboard/health/ai', AI_LABELS.health);

export const getAiMeta = () => dashboardGetJson<AiMetaDto>(AI_BASE + '/meta', AI_LABELS.meta);

// Models
export const getAiServiceModels = () => dashboardGetJson<AiModelDto[]>(AI_BASE + '/models', AI_LABELS.models);
export const createAiModel = (model: AiUpsertModelRequest) => sendAiRequest<AiModelDto>('POST', '/models', model);
export const updateAiModel = (id: number, model: AiUpsertModelRequest) => sendAiRequest<AiModelDto>('PUT', `/models/${id}`, model);
export const deleteAiModel = (id: number) => sendAiRequest<void>('DELETE', `/models/${id}`);

// Provider keys
export const getAiProviderKeys = () => dashboardGetJson<AiProviderKeyDto[]>(AI_BASE + '/provider-keys', AI_LABELS.providerKeys);
export const createAiProviderKey = (key: AiUpsertProviderKeyRequest) => sendAiRequest<AiProviderKeyDto>('POST', '/provider-keys', key);
export const updateAiProviderKey = (id: number, key: AiUpsertProviderKeyRequest) =>
    sendAiRequest<AiProviderKeyDto>('PUT', `/provider-keys/${id}`, key);
export const deleteAiProviderKey = (id: number) => sendAiRequest<void>('DELETE', `/provider-keys/${id}`);

// Tasks
export const getAiTasks = (filter: { q?: string; ownerService?: string; status?: string }, offset: number, limit: number) =>
    dashboardGetJson<AiPage<AiTaskSummaryDto>>(AI_BASE + '/tasks' + aiQuery({ ...filter, offset, limit }), AI_LABELS.tasks);
export const getAiTask = (code: string) => dashboardGetJson<AiTaskDto>(`${AI_BASE}/tasks/${enc(code)}`, AI_LABELS.task);
export const createAiTask = (task: AiUpsertTaskRequest) => sendAiRequest<AiTaskDto>('POST', '/tasks', task);
export const updateAiTask = (code: string, task: AiUpsertTaskRequest) => sendAiRequest<AiTaskDto>('PUT', `/tasks/${enc(code)}`, task);
export const deleteAiTask = (code: string) => sendAiRequest<void>('DELETE', `/tasks/${enc(code)}`);
export const previewAiTask = (code: string, variables: AiJsonObject) =>
    sendAiRequest<AiTaskPreviewDto>('POST', `/tasks/${enc(code)}/previews`, { variables });
export const executeAiTask = (code: string, request: AiExecuteTaskRequest) =>
    sendAiRequest<AiTaskExecutionDto>('POST', `/tasks/${enc(code)}/executions`, request);
/** Drops the task's stored answers (result cache). */
export const clearAiTaskCache = (code: string) =>
    sendAiRequest<AiTaskCacheClearDto>('DELETE', `/tasks/${enc(code)}/cache`);

// Agents
export const getAiAgents = (filter: { q?: string; ownerService?: string; status?: string }, offset: number, limit: number) =>
    dashboardGetJson<AiPage<AiAgentSummaryDto>>(AI_BASE + '/agents' + aiQuery({ ...filter, offset, limit }), AI_LABELS.agents);
export const getAiAgent = (code: string) => dashboardGetJson<AiAgentDto>(`${AI_BASE}/agents/${enc(code)}`, AI_LABELS.agent);
export const createAiAgent = (agent: AiUpsertAgentRequest) => sendAiRequest<AiAgentDto>('POST', '/agents', agent);
export const updateAiAgent = (code: string, agent: AiUpsertAgentRequest) => sendAiRequest<AiAgentDto>('PUT', `/agents/${enc(code)}`, agent);
export const deleteAiAgent = (code: string) => sendAiRequest<void>('DELETE', `/agents/${enc(code)}`);
export const getAiAgentLinks = (code: string) =>
    dashboardGetJson<AiAgentLinksDto>(`${AI_BASE}/agents/${enc(code)}/links`, AI_LABELS.agentLinks);
export const putAiAgentMcpLink = (code: string, serverCode: string, link: AiPutMcpLinkRequest) =>
    sendAiRequest<unknown>('PUT', `/agents/${enc(code)}/mcp-servers/${enc(serverCode)}`, link);
export const deleteAiAgentMcpLink = (code: string, serverCode: string) =>
    sendAiRequest<void>('DELETE', `/agents/${enc(code)}/mcp-servers/${enc(serverCode)}`);
export const putAiAgentSubagentLink = (code: string, subagentCode: string, maxCallsPerRun: number) =>
    sendAiRequest<unknown>('PUT', `/agents/${enc(code)}/subagents/${enc(subagentCode)}`, { maxCallsPerRun } as AiMaxCallsRequest);
export const deleteAiAgentSubagentLink = (code: string, subagentCode: string) =>
    sendAiRequest<void>('DELETE', `/agents/${enc(code)}/subagents/${enc(subagentCode)}`);
export const putAiAgentTaskLink = (code: string, taskCode: string, maxCallsPerRun: number) =>
    sendAiRequest<unknown>('PUT', `/agents/${enc(code)}/tasks/${enc(taskCode)}`, { maxCallsPerRun } as AiMaxCallsRequest);
export const deleteAiAgentTaskLink = (code: string, taskCode: string) =>
    sendAiRequest<void>('DELETE', `/agents/${enc(code)}/tasks/${enc(taskCode)}`);
export const getAiAgentTools = (code: string) =>
    dashboardGetJson<AiAgentToolsDto>(`${AI_BASE}/agents/${enc(code)}/tools`, AI_LABELS.agentTools);
/** What each model gets for these params (thinking, effort, notes); saves and calls nothing. */
export const getAiEffectiveParams = (request: AiEffectiveParamsRequest) =>
    sendAiRequest<AiEffectiveParamsDto>('POST', '/effective-params', request);
/** 202 while the run is still going (poll {@link getAiRun}), 200 when it finished within `waitSeconds`. */
export const startAiAgentRun = (code: string, request: AiStartAgentRunRequest, waitSeconds = 0) =>
    sendAiRequest<AiAgentRunDto>('POST', `/agents/${enc(code)}/runs${aiQuery({ waitSeconds })}`, request);

// MCP servers
export const getAiMcpServers = () => dashboardGetJson<AiMcpServerDto[]>(AI_BASE + '/mcp-servers', AI_LABELS.mcpServers);
export const createAiMcpServer = (server: AiUpsertMcpServerRequest) => sendAiRequest<AiMcpServerDto>('POST', '/mcp-servers', server);
export const updateAiMcpServer = (code: string, server: AiUpsertMcpServerRequest) =>
    sendAiRequest<AiMcpServerDto>('PUT', `/mcp-servers/${enc(code)}`, server);
export const deleteAiMcpServer = (code: string) => sendAiRequest<void>('DELETE', `/mcp-servers/${enc(code)}`);
export const getAiMcpServerTools = (code: string) =>
    dashboardGetJson<AiMcpToolDto[]>(`${AI_BASE}/mcp-servers/${enc(code)}/tools`, AI_LABELS.mcpTools);
export const getAiMcpServerResources = (code: string) =>
    dashboardGetJson<AiMcpResourceDto[]>(`${AI_BASE}/mcp-servers/${enc(code)}/resources`, AI_LABELS.mcpResources);
export const checkAiMcpServer = (code: string) => sendAiRequest<AiMcpCheckDto>('POST', `/mcp-servers/${enc(code)}/checks`);

// Import / export (portable specs)
/** Bundle of the given tasks / agents (or everything with `all`); errors keep the AI `code` / `details`. */
export const exportAiBundle = (request: AiExportRequest) =>
    sendAiRequest<AiBundle>('GET', '/export' + aiQuery({
        tasks: request.tasks && request.tasks.length > 0 ? request.tasks.join(',') : null,
        agents: request.agents && request.agents.length > 0 ? request.agents.join(',') : null,
        workflows: request.workflows && request.workflows.length > 0 ? request.workflows.join(',') : null,
        all: request.all ? true : null,
        includeDependencies: request.includeDependencies,
    }));
/** Always 200 with a report; 400 VALIDATION_FAILED when the body is not a supported `betup-ai-bundle`. */
export const importAiBundle = (bundle: AiBundle | AiJsonObject, options: { mode: AiImportMode; dryRun: boolean }) =>
    sendAiRequest<AiImportReportDto>('POST', '/import' + aiQuery({ mode: options.mode, dryRun: options.dryRun }), bundle);

// Workflows
export const getAiWorkflows = () => dashboardGetJson<AiWorkflowDto[]>(AI_BASE + '/workflows', AI_LABELS.workflows);
export const getAiWorkflow = (code: string) => dashboardGetJson<AiWorkflowDto>(`${AI_BASE}/workflows/${enc(code)}`, AI_LABELS.workflow);
export const createAiWorkflow = (workflow: AiUpsertWorkflowRequest) => sendAiRequest<AiWorkflowDto>('POST', '/workflows', workflow);
export const updateAiWorkflow = (code: string, workflow: AiUpsertWorkflowRequest) =>
    sendAiRequest<AiWorkflowDto>('PUT', `/workflows/${enc(code)}`, workflow);
export const deleteAiWorkflow = (code: string) => sendAiRequest<void>('DELETE', `/workflows/${enc(code)}`);
export const getAiWorkflowStats = (code: string, days: number) =>
    dashboardGetJson<AiWorkflowStatsDto>(`${AI_BASE}/workflows/${enc(code)}/stats` + aiQuery({ days }), AI_LABELS.workflowStats);
/** One workflow instance by its run key (the caller's correlation id): every call, agent runs and cost. */
export const getAiWorkflowRun = (code: string, runKey: string) =>
    dashboardGetJson<AiWorkflowRunDetailDto>(`${AI_BASE}/workflows/${enc(code)}/runs/${enc(runKey)}`, AI_LABELS.workflowRun);
/** Spend by workflow: the most expensive [top], the rest of the hub as unassigned, a daily series. */
export const getAiWorkflowOverview = (days: number, top: number) =>
    dashboardGetJson<AiWorkflowOverviewDto>(AI_BASE + '/usage/workflows' + aiQuery({ days, top }), AI_LABELS.workflowOverview);

// Budgets
export const getAiBudgets = () => dashboardGetJson<AiBudgetDto[]>(AI_BASE + '/budgets', AI_LABELS.budgets);
export const createAiBudget = (budget: AiUpsertBudgetRequest) => sendAiRequest<AiBudgetDto>('POST', '/budgets', budget);
export const updateAiBudget = (id: number, budget: AiUpsertBudgetRequest) => sendAiRequest<AiBudgetDto>('PUT', `/budgets/${id}`, budget);
export const deleteAiBudget = (id: number) => sendAiRequest<void>('DELETE', `/budgets/${id}`);
export const getAiBudgetEvents = (filter: { budgetId?: number | null; from?: string; to?: string }, offset: number, limit: number) =>
    dashboardGetJson<AiPage<AiBudgetEventDto>>(AI_BASE + '/budget-events' + aiQuery({ ...filter, offset, limit }), AI_LABELS.budgetEvents);

// Per-user budgets
export const getAiUserBudgets = () => dashboardGetJson<AiUserBudgetDto[]>(AI_BASE + '/user-budgets', AI_LABELS.userBudgets);
export const createAiUserBudget = (budget: AiUpsertUserBudgetRequest) => sendAiRequest<AiUserBudgetDto>('POST', '/user-budgets', budget);
export const updateAiUserBudget = (id: number, budget: AiUpsertUserBudgetRequest) =>
    sendAiRequest<AiUserBudgetDto>('PUT', `/user-budgets/${id}`, budget);
export const deleteAiUserBudget = (id: number) => sendAiRequest<void>('DELETE', `/user-budgets/${id}`);
/** Per-user budget use of one end user; `caller` empty = every caller's budgets; errors keep the AI message. */
export const getAiEndUserBudgets = (
    endUserId: number,
    filter: { caller?: string | null; agentCode?: string | null; taskCode?: string | null; tier?: string | null } = {},
) => sendAiRequest<AiEndUserBudgetUsageDto>('GET', `/end-users/${endUserId}/budgets` + aiQuery(filter));
/** Spend before now stops counting for `window` (HOURS frees the short windows, WEEK the week and the short windows) → every caller's budgets. */
export const resetAiEndUserBudget = (endUserId: number, window: AiUserBudgetWindowKind) =>
    sendAiRequest<AiEndUserBudgetUsageDto>('POST', `/end-users/${endUserId}/budget-resets`, { window } as AiEndUserBudgetResetRequest);

// Usage
/** `from` / `to` are inclusive days (YYYY-MM-DD); omitted → last 30 days. */
export const getAiUsageSummary = (from: string | null, to: string | null, groupBy: AiUsageGroupBy[], label: string = AI_LABELS.usageSummary) =>
    dashboardGetJson<AiUsageSummaryDto>(
        AI_BASE + '/usage/summary' + aiQuery({ from, to, groupBy: groupBy.length > 0 ? groupBy.join(',') : null }),
        label,
    );
export interface AiUsageCallsFilter {
    from?: string;
    to?: string;
    caller?: string;
    taskCode?: string;
    agentCode?: string;
    status?: string;
    endUserId?: string;
    subjectType?: string;
    subjectId?: string;
}
export const getAiUsageCalls = (filter: AiUsageCallsFilter, offset: number, limit: number) =>
    dashboardGetJson<AiPage<AiUsageCallDto>>(AI_BASE + '/usage/calls' + aiQuery({ ...filter, offset, limit }), AI_LABELS.usageCalls);
export const getAiEndUserUsage = (endUserId: number, from?: string, to?: string) =>
    dashboardGetJson<AiEndUserUsageDto>(`${AI_BASE}/usage/end-users/${endUserId}` + aiQuery({ from, to }), AI_LABELS.endUserUsage);

// Runs
export interface AiRunsFilter {
    agentCode?: string;
    status?: string;
    endUserId?: string;
    from?: string;
    to?: string;
    topLevelOnly?: boolean;
}
export const getAiRuns = (filter: AiRunsFilter, offset: number, limit: number) =>
    dashboardGetJson<AiPage<AiRunSummaryDto>>(AI_BASE + '/runs' + aiQuery({ ...filter, offset, limit }), AI_LABELS.runs);
export const getAiRun = (runId: string) => dashboardGetJson<AiRunDetailDto>(`${AI_BASE}/runs/${enc(runId)}`, AI_LABELS.run);
/** The run with its totals, agent settings, model / tool calls, conversation and child runs; errors keep the AI message. */
export const exportAiRun = (runId: string) => sendAiRequest<AiRunExportDto>('GET', `/runs/${enc(runId)}/export`);

// Task executions
export interface AiTaskExecutionsFilter {
    taskCode?: string;
    status?: string;
    errorCode?: string;
    endUserId?: string;
    caller?: string;
    runId?: string;
    subjectType?: string;
    subjectId?: string;
    from?: string;
    to?: string;
}
export const getAiTaskExecutions = (filter: AiTaskExecutionsFilter, offset: number, limit: number) =>
    dashboardGetJson<AiPage<AiTaskExecutionSummaryDto>>(AI_BASE + '/task-executions' + aiQuery({ ...filter, offset, limit }), AI_LABELS.taskExecutions);
export const getAiTaskExecution = (executionId: string) =>
    dashboardGetJson<AiTaskExecutionDetailDto>(`${AI_BASE}/task-executions/${enc(executionId)}`, AI_LABELS.taskExecution);

// Agent stats
export const getAiAgentStats = (code: string, hours: number) =>
    dashboardGetJson<AiAgentStatsDto>(`${AI_BASE}/agents/${enc(code)}/stats${aiQuery({ hours })}`, AI_LABELS.agentStats);
export const getAiToolStats = (hours: number, agentCode?: string, toolName?: string, target?: string) =>
    dashboardGetJson<AiToolStatsDto>(`${AI_BASE}/tool-invocations/stats${aiQuery({ hours, agentCode, toolName, target })}`, AI_LABELS.toolStats);
export const getAiToolInvocations = (filter: AiToolInvocationsFilter, offset: number, limit: number) =>
    dashboardGetJson<AiPage<AiToolInvocationDto>>(`${AI_BASE}/tool-invocations${aiQuery({ ...filter, offset, limit })}`, AI_LABELS.toolInvocations);

// Conversations
export const getAiConversations = (filter: AiConversationsFilter, offset: number, limit: number) =>
    dashboardGetJson<AiPage<AiConversationSummaryDto>>(AI_BASE + '/conversations' + aiQuery({ ...filter, offset, limit }), AI_LABELS.conversations);
export const getAiConversation = (conversationId: string) =>
    dashboardGetJson<AiConversationDetailDto>(`${AI_BASE}/conversations/${enc(conversationId)}`, AI_LABELS.conversation);
/** The conversation of a caller's thread, e.g. support.betty / support_chat / chat id; status 404 = none yet. */
export const getAiConversationBySubject = (agentCode: string, subjectType: string, subjectId: string | number) =>
    sendAiRequest<AiConversationDetailDto>('GET', '/conversations/by-subject' + aiQuery({ agentCode, subjectType, subjectId: String(subjectId) }));
export const deleteAiConversation = (conversationId: string) =>
    sendAiRequest<void>('DELETE', `/conversations/${enc(conversationId)}`);

// Privacy
export const deleteAiEndUserData = (endUserId: number) =>
    sendAiRequest<AiEndUserDataDeletionDto>('DELETE', `/end-users/${endUserId}/data`);

export const getUserPurchases = (id: number) => {
    return fetchFromApi('/api/dashboard/accounts/users/' + id + '/purchases').then(response => response.ok ? response.json().then(data => data as UserPurchaseDto[]) : []);
}

export const getUserVideoRewards = (id: number) => {
    return fetchFromApi('/api/dashboard/accounts/users/' + id + '/videoRewards').then(response => response.ok ? response.json().then(data => data as VideoRewardRecordDto[]) : []);
}

export const getUserPurchaseRequests = (id: number, offset: number, limit: number) => {
    return fetchFromApi('/api/dashboard/accounts/users/' + id + '/purchaseRequests?offset=' + offset + '&limit=' + limit).then(response => response.ok ? response.json().then(data => data as PaginatedPurchaseRequestsResponseDto) : null);
}

export const getUserOffersPaginated = (id: number, offset: number, limit: number) => {
    return fetchFromApi('/api/dashboard/accounts/users/' + id + '/offers?offset=' + offset + '&limit=' + limit).then(response => response.ok ? response.json().then(data => data as PaginatedUserOffersResponseDto) : null);
}

export const getUserEventsPaginated = (id: number, offset: number, limit: number) => {
    return fetchFromApi('/api/dashboard/accounts/users/' + id + '/events?offset=' + offset + '&limit=' + limit).then(response => response.ok ? response.json().then(data => data as PaginatedAccountEventsResponseDto) : null);
}

export const getWebGames = (lang?: string | null) => {
    const query = lang ? '?lang=' + encodeURIComponent(lang) : '';
    return fetchFromApi('/api/dashboard/games/web-games' + query)
        .then(response => response.ok ? response.json().then(data => data as WebGameListItemDto[]) : []);
}

export const getWebGameConfigs = () => {
    return fetchFromApi('/api/dashboard/games/web-games/configs').then(async response => {
        const contentType = response.headers.get('content-type') ?? '';
        if (!contentType.toLowerCase().includes('application/json')) {
            const errorText = await response.text();
            return {
                data: [] as WebGameAdminConfigDto[],
                error: response.ok
                    ? 'Web games API returned a non-JSON response. Check REACT_APP_API_URL and your dashboard login session.'
                    : (errorText?.trim() || `Failed to load web games (HTTP ${response.status}).`)
            };
        }
        if (response.ok) {
            try {
                return {
                    data: await response.json() as WebGameAdminConfigDto[],
                    error: null as string | null
                };
            } catch {
                return {
                    data: [] as WebGameAdminConfigDto[],
                    error: 'Web games API returned invalid JSON.'
                };
            }
        }
        const errorText = await response.text();
        return {
            data: [] as WebGameAdminConfigDto[],
            error: errorText?.trim() || `Failed to load web games (HTTP ${response.status}).`
        };
    });
}

export const getWebGameSoundAssets = () => {
    return fetchFromApi('/api/dashboard/games/web-games/sound-assets')
        .then(response => response.ok ? response.json().then(data => data as WebGameSoundAssetsResponseDto) : null);
}

export const getWebGameImagePresets = async (): Promise<WebGameImagePresetDto[] | null> => {
    return dashboardGetJson<WebGameImagePresetDto[]>(
        '/api/dashboard/games/web-games/image-presets',
        'web-game-image-presets',
    );
};

export const getWebGameUploadedImages = async (): Promise<string[] | null> => {
    const response = await dashboardGetJson<{ items: string[] }>(
        '/api/dashboard/files/webGameUploadedImages',
        'web-game-uploaded-images',
    );
    return response?.items ?? null;
};

export { normalizeWebGameUploadStoredPath, normalizeWebGameUploadCollectionStoredPath, normalizeWebGameCoverImageStoredPath, resolveWebGameUploadsPublicUrl, isWebGameUploadsApiPath } from './webGames/webGameUploads';

export const createWebGameImagePreset = async (payload: { url: string }): Promise<WebGameImagePresetDto | null> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return null;
        const result = await fetch(BASE_URL + '/api/dashboard/games/web-games/image-presets', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) return null;
        return result.json() as Promise<WebGameImagePresetDto>;
    } catch {
        return null;
    }
};

export const deleteWebGameImagePreset = async (id: string): Promise<boolean> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return false;
        const result = await fetch(BASE_URL + '/api/dashboard/games/web-games/image-presets/' + encodeURIComponent(id), {
            method: 'DELETE',
            headers: { Authorization: accessToken },
        });
        return result.ok;
    } catch {
        return false;
    }
};

export const updateWebGameConfig = async (gameCode: string, payload: UpdateWebGameAdminConfigRequest): Promise<WebGameAdminConfigDto | null> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return null;
        const response = await fetch(BASE_URL + '/api/dashboard/games/web-games/' + encodeURIComponent(gameCode) + '/config', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload)
        });
        return response.ok ? response.json().then(data => data as WebGameAdminConfigDto) : null;
    } catch {
        return null;
    }
}

export const getWebGameTemplateHtml = (gameCode: string) => {
    return fetchFromApi('/api/dashboard/games/web-games/' + encodeURIComponent(gameCode) + '/template-html')
        .then(response => response.ok ? response.json().then(data => data as WebGameTemplateHtmlDto) : null);
}

export const updateWebGameTemplateHtml = async (
    gameCode: string,
    payload: UpdateWebGameTemplateHtmlRequest
): Promise<WebGameTemplateHtmlDto | null> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return null;
        const response = await fetch(BASE_URL + '/api/dashboard/games/web-games/' + encodeURIComponent(gameCode) + '/template-html', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload)
        });
        return response.ok ? response.json().then(data => data as WebGameTemplateHtmlDto) : null;
    } catch {
        return null;
    }
}

export const resetWebGameTemplateHtml = async (gameCode: string): Promise<WebGameTemplateHtmlDto | null> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return null;
        const response = await fetch(BASE_URL + '/api/dashboard/games/web-games/' + encodeURIComponent(gameCode) + '/template-html', {
            method: 'DELETE',
            headers: { 'Authorization': accessToken }
        });
        return response.ok ? response.json().then(data => data as WebGameTemplateHtmlDto) : null;
    } catch {
        return null;
    }
}

export const getUserWebGameSessionsPaginated = (userId: number, offset: number, limit: number) => {
    return fetchFromApi('/api/dashboard/games/web-games/users/' + userId + '/sessions?offset=' + offset + '&limit=' + limit)
        .then(response => response.ok ? response.json().then(data => data as PaginatedWebGameSessionHistoryResponseDto) : null);
}

export const generateUserWebGameSessionCode = async (userId: number): Promise<WebGameSessionCodeDto | null> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return null;
        const response = await fetch(BASE_URL + '/api/dashboard/games/web-games/users/' + userId + '/session-code', {
            method: 'POST',
            headers: { 'Authorization': accessToken }
        });
        return response.ok ? response.json().then(data => data as WebGameSessionCodeDto) : null;
    } catch {
        return null;
    }
}


export const getAviatorRoundHistory = (offset: number, limit: number) => {
    const safeOffset = Math.max(0, offset | 0);
    const safeLimit = Math.min(100, Math.max(1, limit | 0));
    return fetchFromApi('/api/dashboard/games/web-games/aviator-simplified/rounds?offset=' + safeOffset + '&limit=' + safeLimit)
        .then(response => response.ok ? response.json().then(data => data as AviatorAdminRoundHistoryResponseDto) : null);
};

export const getPresentationCampaigns = async (): Promise<PresentationCampaignDto[] | null> => {
    return dashboardGetJson<PresentationCampaignDto[]>(
        '/api/dashboard/presentations',
        'presentation-campaigns',
    );
};

export const getPresentationScreenRegistry = async (): Promise<PresentationScreenRegistryDto | null> => {
    return dashboardGetJson<PresentationScreenRegistryDto>(
        '/api/dashboard/presentations/screen-registry',
        'presentation-screen-registry',
    );
};

export const updatePresentationScreenRegistry = async (
    payload: PresentationScreenRegistryUpsertRequest,
): Promise<PresentationScreenRegistryMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/presentations/screen-registry', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', Authorization: accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Screen registry was not saved.') };
        }
        return { ok: true, data: await result.json() as PresentationScreenRegistryDto };
    } catch {
        return { ok: false, error: 'Screen registry was not saved.' };
    }
};

export const createPresentationCampaign = async (
    payload: PresentationCampaignUpsertRequest
): Promise<PresentationCampaignMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/presentations', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Presentation campaign was not saved.') };
        }
        return { ok: true, data: await result.json() as PresentationCampaignDto };
    } catch {
        return { ok: false, error: 'Presentation campaign was not saved.' };
    }
};

export const updatePresentationCampaign = async (
    id: string,
    payload: PresentationCampaignUpsertRequest
): Promise<PresentationCampaignMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/presentations/' + encodeURIComponent(id), {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', Authorization: accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Presentation campaign was not updated.') };
        }
        return { ok: true, data: await result.json() as PresentationCampaignDto };
    } catch {
        return { ok: false, error: 'Presentation campaign was not updated.' };
    }
};

export const deletePresentationCampaign = async (id: string): Promise<PresentationCampaignDeleteResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/presentations/' + encodeURIComponent(id), {
            method: 'DELETE',
            headers: { Authorization: accessToken },
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Presentation campaign was not deleted.') };
        }
        return { ok: true };
    } catch {
        return { ok: false, error: 'Presentation campaign was not deleted.' };
    }
};

type InterstitialCampaignMutationResult =
    | { ok: true; data: InterstitialCampaignDto }
    | { ok: false; error: string };

type InterstitialCampaignDeleteResult = { ok: true } | { ok: false; error: string };

export const getInterstitialCampaigns = async (): Promise<InterstitialCampaignDto[] | null> => {
    return dashboardGetJson<InterstitialCampaignDto[]>('/api/dashboard/interstitials', 'interstitial-campaigns');
};

export const getInterstitialCampaign = async (id: string): Promise<InterstitialCampaignDto | null> => {
    return dashboardGetJson<InterstitialCampaignDto>(`/api/dashboard/interstitials/${encodeURIComponent(id)}`, `interstitial-${id}`);
};

export const getInterstitialTriggerRegistry = async (): Promise<InterstitialTriggerRegistryDto | null> => {
    return dashboardGetJson<InterstitialTriggerRegistryDto>('/api/dashboard/interstitials/trigger-registry', 'interstitial-triggers');
};

export const createInterstitialCampaign = async (
    payload: InterstitialCampaignUpsertRequest,
): Promise<InterstitialCampaignMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/interstitials', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Interstitial campaign was not saved.') };
        }
        return { ok: true, data: await result.json() as InterstitialCampaignDto };
    } catch {
        return { ok: false, error: 'Interstitial campaign was not saved.' };
    }
};

export const updateInterstitialCampaign = async (
    id: string,
    payload: InterstitialCampaignUpsertRequest,
): Promise<InterstitialCampaignMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/interstitials/' + encodeURIComponent(id), {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', Authorization: accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Interstitial campaign was not updated.') };
        }
        return { ok: true, data: await result.json() as InterstitialCampaignDto };
    } catch {
        return { ok: false, error: 'Interstitial campaign was not updated.' };
    }
};

export const deleteInterstitialCampaign = async (id: string): Promise<InterstitialCampaignDeleteResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/interstitials/' + encodeURIComponent(id), {
            method: 'DELETE',
            headers: { Authorization: accessToken },
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Interstitial campaign was not deleted.') };
        }
        return { ok: true };
    } catch {
        return { ok: false, error: 'Interstitial campaign was not deleted.' };
    }
};

export const getInterstitialCampaignStats = async (id: string): Promise<InterstitialCampaignStatsDto | null> => {
    return dashboardGetJson<InterstitialCampaignStatsDto>(
        `/api/dashboard/interstitials/${encodeURIComponent(id)}/stats`,
        `interstitial-stats-${id}`,
    );
};

export const getInterstitialCampaignUserStats = async (id: string): Promise<InterstitialUserStatsRowDto[] | null> => {
    return dashboardGetJson<InterstitialUserStatsRowDto[]>(
        `/api/dashboard/interstitials/${encodeURIComponent(id)}/stats/users`,
        `interstitial-user-stats-${id}`,
    );
};

type RewardedPromptCampaignMutationResult =
    | { ok: true; data: RewardedPromptCampaignDto }
    | { ok: false; error: string };

type RewardedPromptCampaignDeleteResult = { ok: true } | { ok: false; error: string };

export const getRewardedPromptCampaigns = async (): Promise<RewardedPromptCampaignDto[] | null> => {
    return dashboardGetJson<RewardedPromptCampaignDto[]>('/api/dashboard/rewarded-prompts', 'rewarded-prompt-campaigns');
};

export const getRewardedPromptCampaign = async (id: string): Promise<RewardedPromptCampaignDto | null> => {
    return dashboardGetJson<RewardedPromptCampaignDto>(
        `/api/dashboard/rewarded-prompts/${encodeURIComponent(id)}`,
        `rewarded-prompt-${id}`,
    );
};

export const getRewardedPromptTriggerRegistry = async (): Promise<RewardedPromptTriggerRegistryDto | null> => {
    return dashboardGetJson<RewardedPromptTriggerRegistryDto>(
        '/api/dashboard/rewarded-prompts/trigger-registry',
        'rewarded-prompt-triggers',
    );
};

export const createRewardedPromptCampaign = async (
    payload: RewardedPromptCampaignUpsertRequest,
): Promise<RewardedPromptCampaignMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/rewarded-prompts', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Rewarded prompt campaign was not saved.') };
        }
        return { ok: true, data: await result.json() as RewardedPromptCampaignDto };
    } catch {
        return { ok: false, error: 'Rewarded prompt campaign was not saved.' };
    }
};

export const updateRewardedPromptCampaign = async (
    id: string,
    payload: RewardedPromptCampaignUpsertRequest,
): Promise<RewardedPromptCampaignMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/rewarded-prompts/' + encodeURIComponent(id), {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', Authorization: accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Rewarded prompt campaign was not updated.') };
        }
        return { ok: true, data: await result.json() as RewardedPromptCampaignDto };
    } catch {
        return { ok: false, error: 'Rewarded prompt campaign was not updated.' };
    }
};

export const deleteRewardedPromptCampaign = async (id: string): Promise<RewardedPromptCampaignDeleteResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/rewarded-prompts/' + encodeURIComponent(id), {
            method: 'DELETE',
            headers: { Authorization: accessToken },
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Rewarded prompt campaign was not deleted.') };
        }
        return { ok: true };
    } catch {
        return { ok: false, error: 'Rewarded prompt campaign was not deleted.' };
    }
};

export const getRewardedPromptCampaignStats = async (id: string): Promise<RewardedPromptCampaignStatsDto | null> => {
    return dashboardGetJson<RewardedPromptCampaignStatsDto>(
        `/api/dashboard/rewarded-prompts/${encodeURIComponent(id)}/stats`,
        `rewarded-prompt-stats-${id}`,
    );
};

export const getRewardedPromptCampaignUserStats = async (id: string): Promise<RewardedPromptUserStatsRowDto[] | null> => {
    return dashboardGetJson<RewardedPromptUserStatsRowDto[]>(
        `/api/dashboard/rewarded-prompts/${encodeURIComponent(id)}/stats/users`,
        `rewarded-prompt-user-stats-${id}`,
    );
};

// ---- User polls (/api/dashboard/polls) ----

/** JSON mutation against the polls API; `{message}` error bodies become `error`. */
async function pollMutation<T>(method: string, path: string, body: unknown, fallback: string): Promise<PollMutationResult<T>> {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + path, {
            method,
            headers: body === undefined
                ? { Authorization: accessToken }
                : { 'Content-Type': 'application/json', Authorization: accessToken },
            body: body === undefined ? undefined : JSON.stringify(body),
        });
        if (!result.ok) return { ok: false, error: await handleResponseError(result, fallback) };
        const text = await result.text();
        return { ok: true, data: (text ? JSON.parse(text) : undefined) as T };
    } catch {
        return { ok: false, error: fallback };
    }
}

const pollPath = (id: string) => '/api/dashboard/polls/' + encodeURIComponent(id);

export const getPolls = (): Promise<PollDto[] | null> =>
    dashboardGetJson<PollDto[]>('/api/dashboard/polls', 'polls');

export const getPoll = (id: string): Promise<PollDto | null> =>
    dashboardGetJson<PollDto>(pollPath(id), `poll-${id}`);

export const createPoll = (payload: PollUpsertRequest) =>
    pollMutation<PollDto>('POST', '/api/dashboard/polls', payload, 'Poll was not saved.');

export const updatePoll = (id: string, payload: PollUpsertRequest) =>
    pollMutation<PollDto>('PUT', pollPath(id), payload, 'Poll was not updated.');

export const setPollStatus = (id: string, status: PollStatus) =>
    pollMutation<PollDto>('POST', pollPath(id) + '/status', { status }, 'Poll status was not changed.');

export const deletePoll = (id: string) =>
    pollMutation<void>('DELETE', pollPath(id), undefined, 'Poll was not deleted.');

export const generatePollLocalizations = (payload: PollLocalizationGenerateRequest) =>
    pollMutation<PollLocalizationGenerateResponse>(
        'POST', '/api/dashboard/polls/localizations/generate', payload, 'Translations were not generated.');

export const previewPollAudience = (payload: PollAudienceRequest, pollId?: string) =>
    pollMutation<PollAudienceDto>(
        'POST',
        '/api/dashboard/polls/audience' + (pollId ? '?pollId=' + encodeURIComponent(pollId) : ''),
        payload,
        'Audience was not counted.',
    );

export const sendPoll = (id: string, payload: PollSendRequest) =>
    pollMutation<PollSendDto>('POST', pollPath(id) + '/sends', payload, 'Poll was not sent.');

export const testSendPoll = (id: string, betupIds: number[]) =>
    pollMutation<PollSendDto>('POST', pollPath(id) + '/test-send', { betupIds }, 'Test poll was not sent.');

export const getPollSends = (pollId: string | null, offset: number, limit: number): Promise<PollPageDto<PollSendDto> | null> => {
    const params = new URLSearchParams({ offset: String(offset), limit: String(limit) });
    if (pollId) params.set('pollId', pollId);
    return dashboardGetJson<PollPageDto<PollSendDto>>('/api/dashboard/polls/sends?' + params.toString(), 'poll-sends');
};

export const getPollStats = (id: string, sendId?: string | null): Promise<PollStatsDto | null> =>
    dashboardGetJson<PollStatsDto>(
        pollPath(id) + '/stats' + (sendId ? '?sendId=' + encodeURIComponent(sendId) : ''),
        `poll-stats-${id}`,
    );

export const getPollAnswers = (
    id: string,
    query: { filter: PollAnswerFilter; sendId?: string | null; optionKey?: string | null; includeTest?: boolean; offset: number; limit: number },
): Promise<PollPageDto<PollAnswerRowDto> | null> => {
    const params = new URLSearchParams({
        filter: query.filter,
        offset: String(query.offset),
        limit: String(query.limit),
        includeTest: String(query.includeTest ?? false),
    });
    if (query.sendId) params.set('sendId', query.sendId);
    if (query.optionKey) params.set('optionKey', query.optionKey);
    return dashboardGetJson<PollPageDto<PollAnswerRowDto>>(pollPath(id) + '/answers?' + params.toString(), `poll-answers-${id}`);
};

// Generic marketing push. Legacy rate history is read-only.
const marketingPushPath = '/api/dashboard/marketing/push-notifications';
export const getMarketingPushMatch = (id:number) => dashboardGetJson<PushMatchDetails>(marketingPushPath + '/matches/' + id, 'push-match-' + id);
export const getMarketingPushTypes = () => dashboardGetJson<PushTemplate[]>(marketingPushPath + '/types', 'push-types');
export const estimateMarketingPushAudience = (request: PushAudienceRequest) => pollMutation<PushAudienceEstimate>('POST', marketingPushPath + '/audience/estimate', request, 'Audience estimate is unavailable.');
export const getMarketingPushDraft = (id:string) => dashboardGetJson<PushSendRequest>(marketingPushPath + '/sends/' + encodeURIComponent(id) + '/draft', 'push-draft-' + id);
export const getPushSendingTemplates = (offset=0) => dashboardGetJson<PushPage<PushSendingTemplate>>(marketingPushPath + '/sending-templates?offset=' + offset + '&limit=25', 'push-sending-templates');
export const createPushSendingTemplate = (request:PushSendingTemplateRequest) => pollMutation<PushSendingTemplate>('POST', marketingPushPath + '/sending-templates', request, 'Template was not saved.');
export const updatePushSendingTemplate = (id:string, request:PushSendingTemplateRequest) => pollMutation<PushSendingTemplate>('PUT', marketingPushPath + '/sending-templates/' + encodeURIComponent(id), request, 'Template was not updated.');
export const deletePushSendingTemplate = (id:string, version:number) => pollMutation<void>('DELETE', marketingPushPath + '/sending-templates/' + encodeURIComponent(id) + '?version=' + version, undefined, 'Template was not deleted.');
export const createPushTemplateFromSend = (id:string, name:string) => pollMutation<PushSendingTemplate>('POST', marketingPushPath + '/sends/' + encodeURIComponent(id) + '/template', {name}, 'Template was not created.');
export const validateMarketingPush = (request: PushSendRequest) => pollMutation<Record<string,string>>('POST', marketingPushPath + '/validate', request, 'Notification was not validated.');
export const previewMarketingPushAudience = (request: PushSendRequest) => pollMutation<PushAudience>('POST', marketingPushPath + '/audience/preview', request, 'Audience was not counted.');
export const createMarketingPush = (request: PushSendRequest, test: boolean) => pollMutation<MarketingPushSend>('POST', marketingPushPath + (test ? '/test-sends' : '/sends'), request, 'Sending was not created.');
export const getMarketingPushSends = (offset = 0) => dashboardGetJson<PushPage<MarketingPushSend>>(marketingPushPath + '/sends?offset=' + offset + '&limit=25', 'push-history');
export const getMarketingPushSend = (id: string) => dashboardGetJson<MarketingPushSend>(marketingPushPath + '/sends/' + encodeURIComponent(id), 'push-send-' + id);
export const getMarketingPushStats = (id: string) => dashboardGetJson<PushStatsView>(marketingPushPath + '/sends/' + encodeURIComponent(id) + '/stats', 'push-stats-' + id);
export const refreshMarketingPushStats = (id: string) => pollMutation<PushStatsView>('POST', marketingPushPath + '/sends/' + encodeURIComponent(id) + '/stats/refresh', {}, 'Statistics could not be refreshed.');
export const getLegacyRatePushSends = (offset = 0) => dashboardGetJson<PushPage<LegacyRateSend>>('/api/dashboard/rate-app/sends?offset=' + offset + '&limit=25', 'legacy-rate-history');
export const generateMarketingPushLocalizations = (texts: {title: string; body: string}, supportedLanguages: string[]) => pollMutation<{texts: Record<string,{title: string; body: string}>}>('POST', marketingPushPath + '/localizations/generate', {texts, supportedLanguages, improveEnglish: false}, 'Translations were not generated.');

type BattleAgentMutationResult =
    | { ok: true; data: BattleAgentDto }
    | { ok: false; error: string };

type BattleAgentDeleteResult = { ok: true } | { ok: false; error: string };

export const getBattleAgents = async (): Promise<BattleAgentDto[] | null> => {
    return dashboardGetJson<BattleAgentDto[]>('/api/dashboard/battle-agents', 'battle-agents');
};

export const getBattleAgentsSettings = async (): Promise<BattleAgentsSettingsDto | null> => {
    return dashboardGetJson<BattleAgentsSettingsDto>('/api/dashboard/battle-agents/settings', 'battle-agents-settings');
};

export const updateBattleAgentsSettings = async (
    payload: BattleAgentsSettingsDto,
): Promise<{ ok: true; data: BattleAgentsSettingsDto } | { ok: false; error: string }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/battle-agents/settings', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', Authorization: accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Battle agent settings were not saved.') };
        }
        return { ok: true, data: await result.json() as BattleAgentsSettingsDto };
    } catch {
        return { ok: false, error: 'Battle agent settings were not saved.' };
    }
};

export const getBattleAgent = async (id: string): Promise<BattleAgentDto | null> => {
    return dashboardGetJson<BattleAgentDto>(`/api/dashboard/battle-agents/${encodeURIComponent(id)}`, `battle-agent-${id}`);
};

export const createBattleAgent = async (payload: BattleAgentUpsertRequest): Promise<BattleAgentMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/battle-agents', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Battle agent was not saved.') };
        }
        return { ok: true, data: await result.json() as BattleAgentDto };
    } catch {
        return { ok: false, error: 'Battle agent was not saved.' };
    }
};

export const updateBattleAgent = async (
    id: string,
    payload: BattleAgentUpsertRequest,
): Promise<BattleAgentMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/battle-agents/' + encodeURIComponent(id), {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', Authorization: accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Battle agent was not updated.') };
        }
        return { ok: true, data: await result.json() as BattleAgentDto };
    } catch {
        return { ok: false, error: 'Battle agent was not updated.' };
    }
};

export const deleteBattleAgent = async (id: string): Promise<BattleAgentDeleteResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/battle-agents/' + encodeURIComponent(id), {
            method: 'DELETE',
            headers: { Authorization: accessToken },
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Battle agent was not deleted.') };
        }
        return { ok: true };
    } catch {
        return { ok: false, error: 'Battle agent was not deleted.' };
    }
};

export const enableBattleAgent = async (id: string): Promise<BattleAgentMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/battle-agents/' + encodeURIComponent(id) + '/enable', {
            method: 'POST',
            headers: { Authorization: accessToken },
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Failed to enable battle agent.') };
        }
        return { ok: true, data: await result.json() as BattleAgentDto };
    } catch {
        return { ok: false, error: 'Failed to enable battle agent.' };
    }
};

export const disableBattleAgent = async (id: string): Promise<BattleAgentMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/battle-agents/' + encodeURIComponent(id) + '/disable', {
            method: 'POST',
            headers: { Authorization: accessToken },
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Failed to disable battle agent.') };
        }
        return { ok: true, data: await result.json() as BattleAgentDto };
    } catch {
        return { ok: false, error: 'Failed to disable battle agent.' };
    }
};

export const setBattleAgentsKillSwitch = async (enabled: boolean): Promise<{ ok: true } | { ok: false; error: string }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/battle-agents/kill-switch', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: accessToken },
            body: JSON.stringify({ enabled }),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Failed to update kill switch.') };
        }
        return { ok: true };
    } catch {
        return { ok: false, error: 'Failed to update kill switch.' };
    }
};

export const getBattleAgentRuns = async (id: string, offset = 0, limit = 50): Promise<BattleAgentRunDto[] | null> => {
    return dashboardGetJson<BattleAgentRunDto[]>(
        `/api/dashboard/battle-agents/${encodeURIComponent(id)}/runs?offset=${offset}&limit=${limit}`,
        `battle-agent-runs-${id}`,
    );
};

export const getBattleAgentRunHistory = async (
    query: BattleAgentRunHistoryQuery = {},
): Promise<BattleAgentRunHistoryPageDto | null> => {
    const params = new URLSearchParams();
    if (query.agentId) params.set('agentId', query.agentId);
    if (query.creatorUserId) params.set('creatorUserId', query.creatorUserId);
    if (query.inviteeUserId) params.set('inviteeUserId', query.inviteeUserId);
    if (query.status) params.set('status', query.status);
    if (query.mode) params.set('mode', query.mode);
    if (query.onlyWithChallenge) params.set('onlyWithChallenge', 'true');
    if (query.createdAfterMs != null) params.set('createdAfterMs', String(query.createdAfterMs));
    if (query.createdBeforeMs != null) params.set('createdBeforeMs', String(query.createdBeforeMs));
    params.set('offset', String(query.offset ?? 0));
    params.set('limit', String(query.limit ?? 50));
    return dashboardGetJson<BattleAgentRunHistoryPageDto>(
        `/api/dashboard/battle-agents/history/runs?${params.toString()}`,
        'battle-agent-run-history',
    );
};

export const getBattleAgentsStatsOverview = async (): Promise<BattleAgentsStatsOverview | null> => {
    return dashboardGetJson<BattleAgentsStatsOverview>(
        '/api/dashboard/battle-agents/stats/overview',
        'battle-agents-stats-overview',
    );
};

export const getBattleAgentBotAccounts = async (): Promise<BattleAgentBotAccountsResponse | null> => {
    return dashboardGetJson<BattleAgentBotAccountsResponse>(
        '/api/dashboard/battle-agents/bots',
        'battle-agent-bots',
    );
};

export const updateBattleAgentBotProfile = async (
    userId: number,
    payload: { name?: string; photoUrl?: string; countryIso?: string },
): Promise<{ ok: true; data: BattleAgentBotAccountDto } | { ok: false; error: string }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + `/api/dashboard/battle-agents/bots/${userId}/profile`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', Authorization: accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Failed to update bot profile.') };
        }
        return { ok: true, data: await result.json() as BattleAgentBotAccountDto };
    } catch {
        return { ok: false, error: 'Failed to update bot profile.' };
    }
};

export const updateBattleAgentBotBalance = async (
    userId: number,
    newBalance: number,
): Promise<{ ok: true; data: BattleAgentBotAccountDto } | { ok: false; error: string }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + `/api/dashboard/battle-agents/bots/${userId}/balance`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', Authorization: accessToken },
            body: JSON.stringify({ newBalance }),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Failed to update bot balance.') };
        }
        return { ok: true, data: await result.json() as BattleAgentBotAccountDto };
    } catch {
        return { ok: false, error: 'Failed to update bot balance.' };
    }
};

export const assignBattleAgentBot = async (
    userId: number,
    agentIds: number[],
): Promise<{ ok: true; data: BattleAgentBotAccountDto } | { ok: false; error: string }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + `/api/dashboard/battle-agents/bots/${userId}/assign`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: accessToken },
            body: JSON.stringify({ agentIds }),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Failed to assign bot.') };
        }
        return { ok: true, data: await result.json() as BattleAgentBotAccountDto };
    } catch {
        return { ok: false, error: 'Failed to assign bot.' };
    }
};

export const removeBattleAgentBotFromAgent = async (
    userId: number,
    agentId: number,
): Promise<{ ok: true; data: BattleAgentBotAccountDto } | { ok: false; error: string }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(
            BASE_URL + `/api/dashboard/battle-agents/bots/${userId}/agents/${agentId}`,
            { method: 'DELETE', headers: { Authorization: accessToken } },
        );
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Failed to remove bot from agent.') };
        }
        return { ok: true, data: await result.json() as BattleAgentBotAccountDto };
    } catch {
        return { ok: false, error: 'Failed to remove bot from agent.' };
    }
};

export const searchBattleAgentCreators = async (params: {
    searchTerm?: string;
    userTags?: string[];
    tagCombinationMode?: BattleAgentInviteTagMode;
    inactiveDaysMin?: number;
    offset?: number;
    limit?: number;
    sort?: BattleAgentCreatorSort;
}): Promise<BattleAgentCandidateUsersResponse | null> => {
    const query = new URLSearchParams();
    query.set('offset', String(params.offset ?? 0));
    query.set('limit', String(params.limit ?? 25));
    if (params.searchTerm) query.set('searchTerm', params.searchTerm);
    params.userTags?.forEach(tag => query.append('userTags', tag));
    if (params.userTags?.length) query.set('tagCombinationMode', params.tagCombinationMode ?? 'ANY');
    if (params.inactiveDaysMin != null) query.set('inactiveDaysMin', String(params.inactiveDaysMin));
    if (params.sort) query.set('sort', params.sort);
    return dashboardGetJson<BattleAgentCandidateUsersResponse>(
        `/api/dashboard/battle-agents/candidates/creators?${query.toString()}`,
        'battle-agent-creators',
    );
};

export const getActivePresentationCampaignsForPreview = async (
    context: PresentationEligibilityContextDto
): Promise<PresentationCampaignDto[] | null> => {
    const query = new URLSearchParams();
    if (context.screenKey) query.set('screenKey', context.screenKey);
    if (context.buildNumber != null) query.set('buildNumber', String(context.buildNumber));
    if (context.osType) query.set('osType', context.osType);
    const suffix = query.toString().length > 0 ? ('?' + query.toString()) : '';
    return dashboardGetJson<PresentationCampaignDto[]>(
        '/api/dashboard/presentations/active' + suffix,
        'presentation-campaigns-active',
    );
};

export const postPresentationActionForPreview = async (
    campaignId: string,
    action: 'impression' | 'close' | 'skip' | 'later',
    payload: PresentationActionRequest
): Promise<boolean> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return false;
        const result = await fetch(
            BASE_URL + '/api/dashboard/presentations/' + encodeURIComponent(campaignId) + '/' + action,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: accessToken },
                body: JSON.stringify(payload),
            },
        );
        return result.ok;
    } catch {
        return false;
    }
};

export const generateOffer = async (userId: number, priceTier: string, funnelId: string, bonusSize: number, lang: string, customBetcoins: number | null) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return null;
        let response = await fetch(BASE_URL + '/api/dashboard/offers/generate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify({ userId, priceTier, funnelId, bonusSize, lang, customBetcoins })
        });
        return response.ok ? response.json() : null;
    } catch (e) {
        return null;
    }
}

export const testFunnelEligibility = async (userId: number, funnelId: string): Promise<{ ok: boolean; data?: FunnelEligibilityDto; error?: string }> => {
    try {
        const response = await fetchFromApi('/api/dashboard/offers/funnels/' + encodeURIComponent(funnelId) + '/eligibility?userId=' + encodeURIComponent(String(userId)));
        if (!response.ok) {
            return { ok: false, error: await handleResponseError(response, 'Failed to test funnel eligibility.') };
        }

        return { ok: true, data: await response.json().then(data => data as FunnelEligibilityDto) };
    } catch {
        return { ok: false, error: 'Failed to test funnel eligibility.' };
    }
}

export const getUsersPaginated = (
    offset: number,
    limit: number,
    searchTerm?: string,
    userTags?: string[],
    tagCombinationMode?: UserTagCombinationMode,
) => {
    const params = new URLSearchParams();
    params.set('offset', String(offset));
    params.set('limit', String(limit));
    if (searchTerm != null && searchTerm.length > 0) {
        params.set('searchTerm', searchTerm);
    }
    userTags?.forEach(tag => params.append('userTags', tag));
    if (userTags != null && userTags.length > 0 && tagCombinationMode != null) {
        params.set('tagCombinationMode', tagCombinationMode);
    }

    return fetchFromApi('/api/dashboard/accounts/users?' + params.toString()).then(response => response.ok ? response.json().then(data => data as PaginatedUsersResponseDto) : null);
}

export const getSupportChatsPaginated = (offset: number, limit: number, showOnlyPriority?: boolean, showOnlyActive?: boolean, categoryIds?: string[], allCategoriesSelected?: boolean) => {
    let url = '/api/dashboard/support/admin/chats?offset=' + offset + '&pageSize=' + limit;
    if (showOnlyPriority != null) url += '&showOnlyPriority=' + showOnlyPriority;
    if (showOnlyActive != null) url += '&showOnlyActive=' + showOnlyActive;
    // Only send categoryIds if not all categories are selected
    if (!allCategoriesSelected && categoryIds && categoryIds.length > 0) {
        categoryIds.forEach(id => url += '&categoryIds=' + id);
    }
    return fetchFromApi(url).then(response => response.ok ? response.json().then(data => data as PaginatedSupportChatsDto) : null);
}

export const getBetlistsPaginated = (userId: number, offset: number, limit: number, state?: string, betlistId?: number) => {
    let url = '/api/dashboard/accounts/users/' + userId + '/betlists?offset=' + offset + '&limit=' + limit;
    if (state && state !== 'all') url += '&state=' + encodeURIComponent(state);
    if (betlistId != null) url += '&betlistId=' + betlistId;
    return fetchFromApi(url).then(response => response.ok ? response.json().then(data => data as PaginatedBetlistsResponse) : null);
}

export const getBalancePaginated = (userId: number, offset: number, limit: number) => {
    return fetchFromApi('/api/dashboard/accounts/users/' + userId + '/balanceHistoryRecords?offset=' + offset + '&limit=' + limit).then(response => response.ok ? response.json().then(data => data as PaginatedBalanceHistoryResponseDto) : null);
}

export const getSupportChatsForUser = (userId: number, offset: number, limit: number) => {
    return fetchFromApi('/api/dashboard/support/admin/' + userId + '/chats?offset=' + offset + '&pageSize=' + limit).then(response => response.ok ? response.json().then(data => data as PaginatedSupportChatsDto) : null);
}

export const getSupportChatById = (userId: number, chatId: number) => {
    return fetchFromApi('/api/dashboard/support/admin/' + userId + '/chats/' + chatId).then(response => response.ok ? response.json().then(data => data as SupportChatDto) : null);
}

export const getChatMessagesById = (userId: number, chatId: number, offset: number, limit: number) => {
    return fetchFromApi('/api/dashboard/support/admin/' + userId + '/chats/' + chatId + '/messages?offset=' + offset + '&pageSize=' + limit).then(response => response.ok ? response.json().then(data => data as SupportChatWithUserDto) : null);
}

export const getMessageTemplates = () => {
    return fetchFromApi('/api/dashboard/accounts/messageTemplates').then(response => response.ok ? response.json().then(data => data as MessageTemplateDto[]) : null);
}

export const getSupportChatCategories = () => {
    return fetchFromApi('/api/dashboard/support/admin/categories').then(response => response.ok ? response.json().then(data => data as SupportChatCategoryDto[]) : null);
}

export const getPromoMatches = (onlyActive: boolean, offset: number, limit: number, searchTerm: string) => {
    return fetchFromApi('/api/dashboard/promo/matches' + (onlyActive ? '' : '/all') + '?offset=' + offset + '&limit=' + limit + '&searchTerm=' + searchTerm).then(response => response.ok ? response.json().then(data => data as PaginatedMatchesResponseDto) : null);
}

export const getOffers = (offset: number, limit: number, userId?: string, funnelId?: string, purchased?: boolean, onlyActive?: Boolean) => {
    return fetchFromApi('/api/dashboard/offers/recent?' + 'offset=' + offset + '&limit=' + limit + (userId != null ? '&userId=' + userId : '') + (funnelId != null ? '&funnelId=' + funnelId : '') + (purchased != null ? '&purchased=' + purchased : '') + '&onlyActive=' + (onlyActive ?? false)).then(response => response.ok ? response.json().then(data => data as PaginatedOffersResponseDto) : null);
}

export const getTopMatches = (offset: number, limit: number, period: string) => {
    return fetchFromApi('/api/dashboard/matches/top?offset=' + offset + '&limit=' + limit + '&periodType=' + period).then(response => response.ok ? response.json().then(data => data as PaginatedMatchesDetailedResponseDto) : null);
}

export const getPromoMatch = (matchId: number) => {
    return fetchFromApi('/api/dashboard/promo/matches/' + matchId).then(response => response.ok ? response.json().then(data => data) : null);
}

export const getPromoBanners = () => {
    return fetchFromApi('/api/dashboard/promo/banners').then(response => response.ok ? response.json().then(data => data as PromoBannerDto[]) : []);
}

export const getHomeMatchAds = (onlyActive: boolean, offset: number, limit: number): Promise<PaginatedHomeMatchAdsResponseDto> => {
    return fetchFromApi('/api/dashboard/matches/ad/list?onlyActive=' + onlyActive + '&offset=' + offset + '&limit=' + limit)
        .then(response => response.ok ? response.json().then(data => data as PaginatedHomeMatchAdsResponseDto) : { items: [], offset: 0, limit: limit, totalItems: 0 });
}

export const deleteHomeMatchAd = async (adId: string) => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/matches/ad/' + adId, {
            method: 'DELETE',
            headers: { 'Authorization': accessToken }
        }).then(response => response.ok);
        return result;
    } catch (e) {
        return false;
    }
}

export const getMatchById = (matchId: number) => {
    return fetchFromApi('/api/dashboard/matches/' + matchId).then(response => response.ok ? response.json().then(data => data as MatchDto) : null);
}

export const getLeagueById = (leagueId: number): Promise<LeagueInfoDto | null> => {
    return fetchFromApi('/api/dashboard/leagues/' + leagueId).then(response => response.ok ? response.json().then(data => data as LeagueInfoDto) : null);
}

export const getLeagueScheduledMatches = (leagueId: number): Promise<LeagueScheduledMatchesDto | null> => {
    return fetchFromApi('/api/dashboard/leagues/' + leagueId + '/scheduled-matches')
        .then(response => response.ok ? response.json().then(data => data as LeagueScheduledMatchesDto) : null);
}

export const getHomeMatchAd = (adId: string) => {
    return fetchFromApi('/api/dashboard/matches/ad/' + adId).then(response => response.ok ? response.json().then(data => data as HomeMatchAd) : null);
}
export const getMatchWithFilter = (filter: string) => {
    return fetchFromApi('/api/dashboard/matches/filter?filter=' + filter).then(response => response.ok ? response.json().then(data => data as MatchDto[]) : []);
}

export const getPromoBanner = (bannerId: string) => {
    return fetchFromApi('/api/dashboard/promo/banners/' + bannerId).then(response => response.ok ? response.json().then(data => data as PromoBannerDto) : null);
}

export const getPromoConfig = () => {
    return fetchFromApi('/api/dashboard/promo/config').then(response => response.ok ? response.json().then(data => data as EditablePromoConfig) : null);
}

export const getTourMarketingRewards = (): Promise<TourMarketingRewardsDto | null> => {
    return fetchFromApi('/api/dashboard/marketing/tour-rewards').then(response =>
        response.ok ? response.json().then(data => data as TourMarketingRewardsDto) : null
    );
};

export const updateTourMarketingRewards = async (payload: TourMarketingRewardsDto): Promise<boolean> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return false;
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/tour-rewards', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload)
        });
        return result.ok;
    } catch {
        return false;
    }
};

export const getOneClickBetSettings = (): Promise<OneClickBetSettingsDto | null> => {
    return fetchFromApi('/api/dashboard/marketing/one-click-bet-settings').then(response =>
        response.ok ? response.json().then(data => data as OneClickBetSettingsDto) : null
    );
};

export const updateOneClickBetSettings = async (payload: OneClickBetSettingsDto): Promise<boolean> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return false;
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/one-click-bet-settings', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload)
        });
        return result.ok;
    } catch {
        return false;
    }
};

export const getBattleStakeSettings = (): Promise<import('./models/dtos/BattleStakeSettingsDto').default | null> => {
    return fetchFromApi('/api/dashboard/battles/stake-settings').then(response =>
        response.ok ? response.json() : null
    );
};

export const updateBattleStakeSettings = async (
    payload: import('./models/dtos/BattleStakeSettingsDto').default,
): Promise<boolean> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return false;
        const result = await fetch(BASE_URL + '/api/dashboard/battles/stake-settings', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload)
        });
        return result.ok;
    } catch {
        return false;
    }
};

export const getVarietyBetRestrictions = (): Promise<import('./models/dtos/VarietyBetRestrictionsDto').default | null> => {
    return fetchFromApi('/api/dashboard/marketing/variety-bet-restrictions').then(response =>
        response.ok ? response.json() : null
    );
};

export const getVarietyVersionGates = (): Promise<import('./models/dtos/VarietyVersionGatesDto').default | null> => {
    return fetchFromApi('/api/dashboard/marketing/variety-version-gates').then(response =>
        response.ok ? response.json() : null
    );
};

/** null = success; string = error message to show in UI */
async function putMarketingSettingsJson(
    path: string,
    payload: unknown,
): Promise<string | null> {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) {
            return 'Not signed in (missing access token).';
        }
        const result = await fetch(BASE_URL + path, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', Authorization: accessToken },
            body: JSON.stringify(payload),
        });
        if (result.ok) {
            return null;
        }
        const text = await result.text();
        if (!text) {
            return `Save failed (HTTP ${result.status}). Check analytics → API connection.`;
        }
        try {
            const json = JSON.parse(text) as { message?: string; error?: string };
            if (json.message) return json.message;
            if (json.error) return json.error;
        } catch {
            /* plain text body from API */
        }
        return text;
    } catch (e) {
        return e instanceof Error ? e.message : 'Network error while saving.';
    }
}

export const updateVarietyVersionGates = async (
    payload: import('./models/dtos/VarietyVersionGatesDto').default
): Promise<string | null> =>
    putMarketingSettingsJson('/api/dashboard/marketing/variety-version-gates', payload);

export const updateVarietyBetRestrictions = async (
    payload: import('./models/dtos/VarietyBetRestrictionsDto').default
): Promise<string | null> =>
    putMarketingSettingsJson('/api/dashboard/marketing/variety-bet-restrictions', payload);

export const getFlashBetSettings = (): Promise<FlashBetSettingsDto | null> => {
    return fetchFromApi('/api/dashboard/marketing/flash-bet-settings').then(response =>
        response.ok ? response.json().then(data => data as FlashBetSettingsDto) : null
    );
};

export const updateFlashBetSettings = async (payload: FlashBetSettingsDto): Promise<boolean> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return false;
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/flash-bet-settings', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload)
        });
        return result.ok;
    } catch {
        return false;
    }
};

export const getPromoInterstitialSettings = (): Promise<import('./models/dtos/PromoInterstitialSettingsDto').default | null> => {
    return fetchFromApi('/api/dashboard/promo/interstitial-settings').then(response =>
        response.ok ? response.json().then(data => data as import('./models/dtos/PromoInterstitialSettingsDto').default) : null
    );
};

export const updatePromoInterstitialSettings = async (
    payload: import('./models/dtos/PromoInterstitialSettingsDto').default
): Promise<boolean> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return false;
        const result = await fetch(BASE_URL + '/api/dashboard/promo/interstitial-settings', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload)
        });
        return result.ok;
    } catch {
        return false;
    }
};

export const getInterstitialPolicies = (): Promise<import('./models/dtos/InterstitialPolicyDocument').InterstitialPoliciesBundle | null> => {
    return fetchFromApi('/api/dashboard/promo/interstitial-policies').then(response =>
        response.ok ? response.json() : null
    );
};

async function sendInterstitialPolicies(
    path: string,
    method: 'PUT' | 'POST',
    body?: unknown,
): Promise<{ ok: true; bundle: import('./models/dtos/InterstitialPolicyDocument').InterstitialPoliciesBundle } | { ok: false; error: string }> {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Not signed in.' };
        const result = await fetch(BASE_URL + path, {
            method,
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: body == null ? undefined : JSON.stringify(body),
        });
        const text = await result.text();
        if (!result.ok) {
            return { ok: false, error: text || `Request failed (${result.status})` };
        }
        return { ok: true, bundle: JSON.parse(text) };
    } catch (e) {
        return { ok: false, error: e instanceof Error ? e.message : 'Request failed' };
    }
}

export const updateInterstitialPolicies = (
    payload: import('./models/dtos/InterstitialPolicyDocument').InterstitialPolicyDocument,
) => sendInterstitialPolicies('/api/dashboard/promo/interstitial-policies', 'PUT', payload);

export const rollbackInterstitialPolicies = () =>
    sendInterstitialPolicies('/api/dashboard/promo/interstitial-policies/rollback', 'POST');

export const previewInterstitialPolicy = (
    betupId: number,
): Promise<import('./models/dtos/InterstitialPolicyDocument').InterstitialPolicyPreview | null> => {
    return fetchFromApi(`/api/dashboard/promo/interstitial-policies/preview?betupId=${betupId}`).then(response =>
        response.ok ? response.json() : null
    );
};

export const getChainOffers = (): Promise<import('./models/dtos/ChainOfferDocument').ChainOfferBundleDto | null> => {
    return fetchFromApi('/api/dashboard/promo/chain-offers').then(response =>
        response.ok ? response.json() : null
    );
};

async function sendChainOffers(
    path: string,
    method: 'PUT' | 'POST',
    body?: unknown,
): Promise<{ ok: true; bundle: import('./models/dtos/ChainOfferDocument').ChainOfferBundleDto } | { ok: false; error: string }> {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Not signed in.' };
        const result = await fetch(BASE_URL + path, {
            method,
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: body == null ? undefined : JSON.stringify(body),
        });
        const text = await result.text();
        if (!result.ok) {
            return { ok: false, error: text || `Request failed (${result.status})` };
        }
        return { ok: true, bundle: JSON.parse(text) };
    } catch (e) {
        return { ok: false, error: e instanceof Error ? e.message : 'Request failed' };
    }
}

export const updateChainOffers = (
    payload: import('./models/dtos/ChainOfferDocument').ChainOfferDocument,
) => sendChainOffers('/api/dashboard/promo/chain-offers', 'PUT', payload);

export const rollbackChainOffers = () =>
    sendChainOffers('/api/dashboard/promo/chain-offers/rollback', 'POST');

export const previewChainOffer = (
    betupId: number,
): Promise<import('./models/dtos/ChainOfferDocument').ChainOfferPreviewDto | null> => {
    return fetchFromApi(`/api/dashboard/promo/chain-offers/preview?betupId=${betupId}`).then(response =>
        response.ok ? response.json() : null
    );
};

export const getAppUpdateSettings = (): Promise<import('./models/dtos/AppUpdateSettingsDto').default | null> => {
    return fetchFromApi('/api/dashboard/marketing/app-update-settings').then(response =>
        response.ok ? response.json().then(data => data as import('./models/dtos/AppUpdateSettingsDto').default) : null
    );
};

export const updateAppUpdateSettings = async (
    payload: import('./models/dtos/AppUpdateSettingsDto').default
): Promise<boolean> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return false;
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/app-update-settings', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload)
        });
        return result.ok;
    } catch {
        return false;
    }
};

export const getShopLayoutSettings = (): Promise<ShopLayoutSettingsDto | null> => {
    return fetchFromApi('/api/dashboard/shop/settings').then(response =>
        response.ok ? response.json().then(data => data as ShopLayoutSettingsDto) : null
    );
};

export const updateShopLayoutSettings = async (payload: ShopLayoutSettingsDto): Promise<boolean> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return false;
        const result = await fetch(BASE_URL + '/api/dashboard/shop/settings', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload),
        });
        return result.ok;
    } catch {
        return false;
    }
};

export const getDailyQuestsSettings = (): Promise<DailyQuestsSettingsDto | null> => {
    return fetchFromApi('/api/dashboard/marketing/daily-quests-settings').then(response =>
        response.ok ? response.json().then(data => data as DailyQuestsSettingsDto) : null
    );
};

export const updateDailyQuestsSettings = async (payload: DailyQuestsSettingsDto): Promise<boolean> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return false;
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quests-settings', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload)
        });
        return result.ok;
    } catch {
        return false;
    }
};

function appendQueryParam(qs: string[], key: string, value: string | number | boolean | undefined): void {
    if (value === undefined) return;
    qs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
}

export interface DashboardApiErrorInfo {
    label: string;
    path: string;
    status?: number;
    bodySnippet?: string;
    message?: string;
    timestamp: string;
}

const dashboardApiErrors: Record<string, DashboardApiErrorInfo | null> = {};

export function getDashboardApiError(label: string): DashboardApiErrorInfo | null {
    return dashboardApiErrors[label] ?? null;
}

export type DailyQuestTemplateMutationResult = {
    ok: boolean;
    data?: DailyQuestTemplateDto;
    error?: string;
};

export type DailyQuestTemplateDeleteResult = {
    ok: boolean;
    error?: string;
};

export type PresentationCampaignMutationResult = {
    ok: boolean;
    data?: PresentationCampaignDto;
    error?: string;
};

export type PresentationCampaignDeleteResult = {
    ok: boolean;
    error?: string;
};

export type PrivateClubMutationResult = {
    ok: boolean;
    data?: PrivateClubDto;
    error?: string;
};

export type PrivateClubAdminMutationResult = {
    ok: boolean;
    data?: PrivateClubAdminDto;
    error?: string;
};

export type PrivateClubDeleteResult = {
    ok: boolean;
    error?: string;
};

export type PrivateClubPickMutationResult = {
    ok: boolean;
    data?: PrivateClubPlacedBetDto[];
    error?: string;
};

export type PrivateClubTemplateMutationResult = {
    ok: boolean;
    data?: PrivateClubTemplateAdminDto;
    error?: string;
};

export type PrivateClubTemplateDeleteResult = {
    ok: boolean;
    error?: string;
};

/** GET via analytics dashboard; logs non-OK or parse errors (proxy → v7 issues show up here). */
async function dashboardGetJson<T>(path: string, label: string): Promise<T | null> {
    try {
        const response = await fetchFromApi(path);
        if (!response.ok) {
            const snippet = (await response.text().catch(() => '')).slice(0, 1200);
            dashboardApiErrors[label] = {
                label,
                path,
                status: response.status,
                bodySnippet: snippet,
                timestamp: new Date().toISOString(),
            };
            console.error(`[dashboard] ${label} HTTP ${response.status}`, snippet || '(empty body)');
            return null;
        }
        dashboardApiErrors[label] = null;
        return (await response.json()) as T;
    } catch (e) {
        dashboardApiErrors[label] = {
            label,
            path,
            message: e instanceof Error ? e.message : String(e),
            timestamp: new Date().toISOString(),
        };
        console.error(`[dashboard] ${label}`, e);
        return null;
    }
}

export const getPrivateClubTemplates = async (
    status?: PrivateClubTemplateStatus,
): Promise<PrivateClubTemplateAdminDto[] | null> => {
    const qs: string[] = [];
    appendQueryParam(qs, 'status', status);
    const query = qs.length > 0 ? ('?' + qs.join('&')) : '';
    return dashboardGetJson<PrivateClubTemplateAdminDto[]>(
        '/api/dashboard/private-clubs/templates' + query,
        'private-club-templates',
    );
};

export const getPrivateClubAgenticConfiguration = async (): Promise<PrivateClubAgenticConfigurationAdminDto | null> => {
    return dashboardGetJson<PrivateClubAgenticConfigurationAdminDto>(
        '/api/dashboard/private-clubs/agentic/configuration',
        'private-club-agentic-configuration',
    );
};

export const updatePrivateClubAgenticConfiguration = async (
    payload: PrivateClubAgenticConfigurationAdminRequestDto,
): Promise<PrivateClubAgenticConfigurationAdminDto | null> => {
    const accessToken = getAccessToken();
    if (accessToken == null) return null;
    const result = await fetch(BASE_URL + '/api/dashboard/private-clubs/agentic/configuration', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
        body: JSON.stringify(payload),
    });
    return result.ok ? await result.json() as PrivateClubAgenticConfigurationAdminDto : null;
};

export const getPrivateClubAgenticLogs = async (
    offset: number,
    limit: number,
    templateId?: string | null,
): Promise<PaginatedPrivateClubAgenticLogsAdminResponseDto | null> => {
    const params = new URLSearchParams();
    params.set('offset', String(offset));
    params.set('limit', String(limit));
    if (templateId) params.set('templateId', templateId);
    return dashboardGetJson<PaginatedPrivateClubAgenticLogsAdminResponseDto>(
        '/api/dashboard/private-clubs/agentic/logs?' + params.toString(),
        'private-club-agentic-logs',
    );
};

export const getPrivateClubAgenticEvents = async (
    offset: number,
    limit: number,
    templateId?: string | null,
): Promise<PrivateClubAgenticEventsAdminResponseDto | null> => {
    const params = new URLSearchParams();
    params.set('offset', String(offset));
    params.set('limit', String(limit));
    if (templateId) params.set('templateId', templateId);
    return dashboardGetJson<PrivateClubAgenticEventsAdminResponseDto>(
        '/api/dashboard/private-clubs/agentic/events?' + params.toString(),
        'private-club-agentic-events',
    );
};

export const getPrivateClubAgenticRuns = async (): Promise<AgentRunAdminDto[] | null> => {
    return dashboardGetJson<AgentRunAdminDto[]>(
        '/api/dashboard/private-clubs/agentic/runs',
        'private-club-agentic-runs',
    );
};

export const markPrivateClubAgenticEventRead = async (
    eventId: string,
): Promise<PrivateClubAgenticEventAdminDto | null> => {
    const accessToken = getAccessToken();
    if (accessToken == null) return null;
    const result = await fetch(
        BASE_URL + '/api/dashboard/private-clubs/agentic/events/' + encodeURIComponent(eventId) + '/read',
        { method: 'POST', headers: { 'Authorization': accessToken } },
    );
    return result.ok ? await result.json() as PrivateClubAgenticEventAdminDto : null;
};

export const markAllPrivateClubAgenticEventsRead = async (
    templateId?: string | null,
): Promise<{ updatedCount: number } | null> => {
    const accessToken = getAccessToken();
    if (accessToken == null) return null;
    const params = new URLSearchParams();
    if (templateId) params.set('templateId', templateId);
    const suffix = params.toString() ? '?' + params.toString() : '';
    const result = await fetch(
        BASE_URL + '/api/dashboard/private-clubs/agentic/events/read-all' + suffix,
        { method: 'POST', headers: { 'Authorization': accessToken } },
    );
    return result.ok ? await result.json() as { updatedCount: number } : null;
};

export const runPrivateClubAgenticTemplates = async (): Promise<PrivateClubAgenticRunAdminResponseDto | null> => {
    const accessToken = getAccessToken();
    if (accessToken == null) return null;
    const result = await fetch(BASE_URL + '/api/dashboard/private-clubs/agentic/run', {
        method: 'POST',
        headers: { 'Authorization': accessToken },
    });
    return result.ok ? await result.json() as PrivateClubAgenticRunAdminResponseDto : null;
};

export const runPrivateClubAgenticTemplateCreation = async (): Promise<PrivateClubAgenticRunAdminResponseDto | null> => {
    const accessToken = getAccessToken();
    if (accessToken == null) return null;
    const result = await fetch(BASE_URL + '/api/dashboard/private-clubs/agentic/templates/run', {
        method: 'POST',
        headers: { 'Authorization': accessToken },
    });
    return result.ok ? await result.json() as PrivateClubAgenticRunAdminResponseDto : null;
};

export const runPrivateClubTemplateAgent = async (
    templateId: string,
): Promise<PrivateClubAgenticRunAdminResponseDto | null> => {
    const accessToken = getAccessToken();
    if (accessToken == null) return null;
    const result = await fetch(
        BASE_URL + '/api/dashboard/private-clubs/templates/' + encodeURIComponent(templateId) + '/agentic/run',
        { method: 'POST', headers: { 'Authorization': accessToken } },
    );
    return result.ok ? await result.json() as PrivateClubAgenticRunAdminResponseDto : null;
};

export const createPrivateClubTemplate = async (
    payload: UpsertPrivateClubTemplateAdminDto,
): Promise<PrivateClubTemplateMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/private-clubs/templates', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Private club template was not created.') };
        }
        return { ok: true, data: await result.json() as PrivateClubTemplateAdminDto };
    } catch {
        return { ok: false, error: 'Private club template was not created.' };
    }
};

export const updatePrivateClubTemplate = async (
    id: string,
    payload: UpsertPrivateClubTemplateAdminDto,
): Promise<PrivateClubTemplateMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/private-clubs/templates/' + encodeURIComponent(id), {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Private club template was not updated.') };
        }
        return { ok: true, data: await result.json() as PrivateClubTemplateAdminDto };
    } catch {
        return { ok: false, error: 'Private club template was not updated.' };
    }
};

export const cancelPrivateClubRound = async (
    templateId: string,
    roundId: string,
): Promise<PrivateClubTemplateMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(
            BASE_URL + '/api/dashboard/private-clubs/templates/' + encodeURIComponent(templateId)
            + '/rounds/' + encodeURIComponent(roundId) + '/cancel',
            { method: 'POST', headers: { 'Authorization': accessToken } },
        );
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Private club round was not cancelled.') };
        }
        return { ok: true, data: await result.json() as PrivateClubTemplateAdminDto };
    } catch {
        return { ok: false, error: 'Private club round was not cancelled.' };
    }
};

export const removePrivateClubMember = async (
    clubId: string,
    userId: number,
): Promise<PrivateClubAdminMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(
            BASE_URL + '/api/dashboard/private-clubs/clubs/' + encodeURIComponent(clubId)
            + '/members/' + encodeURIComponent(String(userId)),
            { method: 'DELETE', headers: { 'Authorization': accessToken } },
        );
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Private club member was not removed.') };
        }
        return { ok: true, data: await result.json() as PrivateClubAdminDto };
    } catch {
        return { ok: false, error: 'Private club member was not removed.' };
    }
};

export const addPrivateClubMember = async (
    clubId: string,
    userId: number,
): Promise<PrivateClubAdminMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(
            BASE_URL + '/api/dashboard/private-clubs/clubs/' + encodeURIComponent(clubId) + '/members',
            {
                method: 'POST',
                headers: { 'Authorization': accessToken, 'Content-Type': 'application/json' },
                body: JSON.stringify({ userId }),
            },
        );
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Private club member was not added.') };
        }
        return { ok: true, data: await result.json() as PrivateClubAdminDto };
    } catch {
        return { ok: false, error: 'Private club member was not added.' };
    }
};

export const deletePrivateClubTemplate = async (
    id: string,
): Promise<PrivateClubTemplateDeleteResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/private-clubs/templates/' + encodeURIComponent(id), {
            method: 'DELETE',
            headers: { 'Authorization': accessToken },
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Private club template was not deleted.') };
        }
        return { ok: true };
    } catch {
        return { ok: false, error: 'Private club template was not deleted.' };
    }
};

export const getUserPrivateClubs = async (userId: number): Promise<PrivateClubDto[] | null> => {
    return dashboardGetJson<PrivateClubDto[]>(
        '/api/dashboard/private-clubs/users/' + userId + '/clubs',
        'user-private-clubs',
    );
};

export const getPrivateClubsByTemplate = async (
    templateId: string,
    offset: number,
    limit: number,
): Promise<PaginatedPrivateClubsAdminResponseDto | null> => {
    return dashboardGetJson<PaginatedPrivateClubsAdminResponseDto>(
        '/api/dashboard/private-clubs/templates/' + encodeURIComponent(templateId)
        + '/clubs?offset=' + encodeURIComponent(String(offset))
        + '&limit=' + encodeURIComponent(String(limit)),
        'private-clubs-by-template',
    );
};

export const getPrivateClubTemplateMatches = async (
    templateId: string,
    offset: number,
    limit: number,
): Promise<PaginatedPrivateClubTemplateMatchesAdminResponseDto | null> => {
    return dashboardGetJson<PaginatedPrivateClubTemplateMatchesAdminResponseDto>(
        '/api/dashboard/private-clubs/templates/' + encodeURIComponent(templateId)
        + '/matches?offset=' + encodeURIComponent(String(offset))
        + '&limit=' + encodeURIComponent(String(limit)),
        'private-club-template-matches',
    );
};

export const getPrivateClubTemplatePlacedBets = async (
    templateId: string,
    view: PrivateClubTemplatePlacedBetsAdminView,
    offset: number,
    limit: number,
    clubIds: string[] = [],
    matchIds: number[] = [],
): Promise<PrivateClubTemplatePlacedBetsAdminResponseDto | null> => {
    const query = new URLSearchParams({
        view,
        offset: String(offset),
        limit: String(limit),
    });
    if (clubIds.length > 0) query.set('clubIds', clubIds.join(','));
    if (matchIds.length > 0) query.set('matchIds', matchIds.join(','));

    return dashboardGetJson<PrivateClubTemplatePlacedBetsAdminResponseDto>(
        '/api/dashboard/private-clubs/templates/' + encodeURIComponent(templateId)
        + '/placed-bets?' + query.toString(),
        'private-club-template-placed-bets',
    );
};

export const overridePrivateClubTemplatePlacedBetStatus = async (
    templateId: string,
    payload: PrivateClubOverridePlacedBetStatusAdminRequestDto,
): Promise<PrivateClubOverridePlacedBetStatusAdminResponseDto | null> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return null;
        const result = await fetch(
            BASE_URL + '/api/dashboard/private-clubs/templates/' + encodeURIComponent(templateId) + '/placed-bets/status-override',
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
                body: JSON.stringify(payload),
            },
        );
        if (!result.ok) {
            throw new Error(await handleResponseError(result, 'Private club placed bet status was not overridden.'));
        }
        return await result.json() as PrivateClubOverridePlacedBetStatusAdminResponseDto;
    } catch (e) {
        console.error('[dashboard] private-club-template-placed-bet-status-override', e);
        return null;
    }
};

export const getUserPrivateClub = async (userId: number, clubId: string): Promise<PrivateClubDto | null> => {
    return dashboardGetJson<PrivateClubDto>(
        '/api/dashboard/private-clubs/users/' + userId + '/clubs/' + encodeURIComponent(clubId),
        'user-private-club',
    );
};

export const getUserPrivateClubLeaderboard = async (
    userId: number,
    clubId: string,
): Promise<PrivateClubLeaderboardResponseDto | null> => {
    return dashboardGetJson<PrivateClubLeaderboardResponseDto>(
        '/api/dashboard/private-clubs/users/' + userId + '/clubs/' + encodeURIComponent(clubId) + '/leaderboard',
        'user-private-club-leaderboard',
    );
};

export const getUserPrivateClubCurrentRoundMatches = async (
    userId: number,
    clubId: string,
): Promise<PrivateClubCurrentRoundMatchesAdminResponseDto | null> => {
    return dashboardGetJson<PrivateClubCurrentRoundMatchesAdminResponseDto>(
        '/api/dashboard/private-clubs/users/' + userId + '/clubs/' + encodeURIComponent(clubId) + '/current-round/matches',
        'user-private-club-current-round-matches',
    );
};

export const getPrivateClubCurrentRoundMatches = async (
    clubId: string,
): Promise<PrivateClubCurrentRoundMatchesAdminResponseDto | null> => {
    return dashboardGetJson<PrivateClubCurrentRoundMatchesAdminResponseDto>(
        '/api/dashboard/private-clubs/clubs/' + encodeURIComponent(clubId) + '/current-round/matches',
        'private-club-current-round-matches',
    );
};

export const getPrivateClubJoinRequests = async (
    clubId: string,
    offset = 0,
    limit = 20,
): Promise<PaginatedPrivateClubJoinRequestsDto | null> => {
    const params = new URLSearchParams({
        offset: String(offset),
        limit: String(limit),
    });
    return dashboardGetJson<PaginatedPrivateClubJoinRequestsDto>(
        '/api/dashboard/private-clubs/clubs/' + encodeURIComponent(clubId) + '/join-requests?' + params.toString(),
        'private-club-join-requests',
    );
};

export const approvePrivateClubJoinRequest = async (
    clubId: string,
    requestId: string,
): Promise<{ ok: boolean; data?: PrivateClubJoinRequestDto; error?: string }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(
            BASE_URL + '/api/dashboard/private-clubs/clubs/' + encodeURIComponent(clubId)
            + '/join-requests/' + encodeURIComponent(requestId) + '/approve',
            {
                method: 'POST',
                headers: { 'Authorization': accessToken },
            },
        );
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Private club join request was not approved.') };
        }
        return { ok: true, data: await result.json() as PrivateClubJoinRequestDto };
    } catch {
        return { ok: false, error: 'Private club join request was not approved.' };
    }
};

export const rejectPrivateClubJoinRequest = async (
    clubId: string,
    requestId: string,
): Promise<{ ok: boolean; data?: PrivateClubJoinRequestDto; error?: string }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(
            BASE_URL + '/api/dashboard/private-clubs/clubs/' + encodeURIComponent(clubId)
            + '/join-requests/' + encodeURIComponent(requestId) + '/reject',
            {
                method: 'POST',
                headers: { 'Authorization': accessToken },
            },
        );
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Private club join request was not rejected.') };
        }
        return { ok: true, data: await result.json() as PrivateClubJoinRequestDto };
    } catch {
        return { ok: false, error: 'Private club join request was not rejected.' };
    }
};

export const joinUserPrivateClub = async (
    userId: number,
    payload: JoinPrivateClubRequestDto,
): Promise<PrivateClubMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/private-clubs/users/' + userId + '/clubs/join', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Private club was not joined.') };
        }
        return { ok: true, data: await result.json() as PrivateClubDto };
    } catch {
        return { ok: false, error: 'Private club was not joined.' };
    }
};

export const createUserPrivateClub = async (
    userId: number,
    payload: CreatePrivateClubRequestDto,
): Promise<PrivateClubMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/private-clubs/users/' + userId + '/clubs', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Private club was not created.') };
        }
        return { ok: true, data: await result.json() as PrivateClubDto };
    } catch {
        return { ok: false, error: 'Private club was not created.' };
    }
};

export const updateUserPrivateClub = async (
    userId: number,
    clubId: string,
    payload: UpdatePrivateClubRequestDto,
): Promise<PrivateClubMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/private-clubs/users/' + userId + '/clubs/' + encodeURIComponent(clubId), {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Private club was not updated.') };
        }
        return { ok: true, data: await result.json() as PrivateClubDto };
    } catch {
        return { ok: false, error: 'Private club was not updated.' };
    }
};

export const deleteUserPrivateClub = async (
    userId: number,
    clubId: string,
): Promise<PrivateClubDeleteResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/private-clubs/users/' + userId + '/clubs/' + encodeURIComponent(clubId), {
            method: 'DELETE',
            headers: { 'Authorization': accessToken },
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Private club was not deleted.') };
        }
        return { ok: true };
    } catch {
        return { ok: false, error: 'Private club was not deleted.' };
    }
};

export const getUserPrivateClubGrabbedBets = async (
    userId: number,
    clubId: string,
    roundId: string,
    matchId: number,
): Promise<CoreExternalGrabbedBetsResponseDto | null> => {
    return dashboardGetJson<CoreExternalGrabbedBetsResponseDto>(
        '/api/dashboard/private-clubs/users/' + userId + '/clubs/' + encodeURIComponent(clubId)
        + '/rounds/' + encodeURIComponent(roundId)
        + '/matches/' + encodeURIComponent(String(matchId))
        + '/grabbed-bets',
        'user-private-club-grabbed-bets',
    );
};

export const getUserPrivateClubPlacedBetsForMatch = async (
    userId: number,
    clubId: string,
    roundId: string,
    matchId: number,
): Promise<PrivateClubPlacedBetsResponseDto | null> => {
    return dashboardGetJson<PrivateClubPlacedBetsResponseDto>(
        '/api/dashboard/private-clubs/users/' + userId + '/clubs/' + encodeURIComponent(clubId)
        + '/rounds/' + encodeURIComponent(roundId)
        + '/matches/' + encodeURIComponent(String(matchId))
        + '/placed-bets',
        'user-private-club-placed-bets',
    );
};

export const placeUserPrivateClubPick = async (
    userId: number,
    clubId: string,
    payload: PlacePrivateClubPickRequestDto,
): Promise<PrivateClubPickMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/private-clubs/users/' + userId + '/clubs/' + encodeURIComponent(clubId) + '/picks', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Private club pick was not placed.') };
        }
        return { ok: true, data: await result.json() as PrivateClubPlacedBetDto[] };
    } catch {
        return { ok: false, error: 'Private club pick was not placed.' };
    }
};

export const getDailyQuestInstances = async (
    userId: number | undefined,
    status: DailyQuestStatus | undefined,
    rewardClaimed: boolean | undefined,
    offset: number,
    limit: number,
): Promise<PaginatedDailyQuestInstancesDto | null> => {
    const qs: string[] = [];
    appendQueryParam(qs, 'offset', offset);
    appendQueryParam(qs, 'limit', limit);
    appendQueryParam(qs, 'userId', userId);
    appendQueryParam(qs, 'status', status);
    appendQueryParam(qs, 'rewardClaimed', rewardClaimed);
    const path = '/api/dashboard/marketing/daily-quests-instances?' + qs.join('&');
    return dashboardGetJson<PaginatedDailyQuestInstancesDto>(path, 'daily-quests-instances');
};

export const getDailyQuestInstance = async (id: string): Promise<DailyQuestAdminInstanceDto | null> => {
    return dashboardGetJson<DailyQuestAdminInstanceDto>(
        '/api/dashboard/marketing/daily-quests-instances/' + encodeURIComponent(id),
        'daily-quests-instance',
    );
};

export const getDailyQuestStatistics = async (
    templateId: string | undefined,
    timeframe: DailyQuestStatisticsTimeframe,
): Promise<DailyQuestStatisticsDto | null> => {
    const qs: string[] = [];
    appendQueryParam(qs, 'timeframe', timeframe);
    appendQueryParam(qs, 'templateId', templateId);
    return dashboardGetJson<DailyQuestStatisticsDto>(
        '/api/dashboard/marketing/daily-quests-statistics?' + qs.join('&'),
        'daily-quests-statistics',
    );
};

export const resyncDailyQuestInstance = async (id: string): Promise<{ item: DailyQuestAdminInstanceDto | null; error: string | null }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { item: null, error: 'Missing access token' };
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quests-instances/' + encodeURIComponent(id) + '/resync', {
            method: 'POST',
            headers: { 'Authorization': accessToken },
        });
        if (!result.ok) {
            const errorText = await result.text().catch(() => '');
            return { item: null, error: errorText || `HTTP ${result.status}` };
        }
        return { item: await result.json() as DailyQuestAdminInstanceDto, error: null };
    } catch {
        return { item: null, error: 'Network error' };
    }
};

export const overrideDailyQuestTaskProgress = async (
    questId: string,
    userTaskId: number,
    action: 'RESET' | 'COMPLETE',
): Promise<{ item: DailyQuestAdminInstanceDto | null; error: string | null }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { item: null, error: 'Missing access token' };
        const result = await fetch(
            BASE_URL + '/api/dashboard/marketing/daily-quests-instances/' + encodeURIComponent(questId) + '/tasks/' + userTaskId + '/progress-override',
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
                body: JSON.stringify({ action }),
            },
        );
        if (!result.ok) {
            const errorText = await result.text().catch(() => '');
            return { item: null, error: errorText || `HTTP ${result.status}` };
        }
        return { item: await result.json() as DailyQuestAdminInstanceDto, error: null };
    } catch {
        return { item: null, error: 'Network error' };
    }
};

export const updateDailyQuestInstance = async (
    id: number,
    payload: UpdateDailyQuestInstanceDto,
): Promise<boolean> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return false;
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quests-instances/' + id, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload),
        });
        return result.ok;
    } catch {
        return false;
    }
};

export const assignDailyQuestsManually = async (
    payload: AssignDailyQuestsRequestDto,
): Promise<AssignDailyQuestsResponseDto | null> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return null;
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quests-assign', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) return null;
        return result.json() as Promise<AssignDailyQuestsResponseDto>;
    } catch {
        return null;
    }
};

export const createDailyQuestInstance = async (
    payload: CreateDailyQuestInstanceDto,
): Promise<{ item: DailyQuestAdminInstanceDto | null; error: string | null }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { item: null, error: 'Missing access token' };
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quests-instances', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            const errorText = await result.text().catch(() => '');
            return { item: null, error: errorText || `HTTP ${result.status}` };
        }
        const item = await (result.json() as Promise<DailyQuestAdminInstanceDto>);
        return { item, error: null };
    } catch {
        return { item: null, error: 'Network error' };
    }
};

export const cancelDailyQuestInstance = async (id: string): Promise<{ ok: boolean; error: string | null }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token' };
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quests-instances/' + encodeURIComponent(id) + '/cancel', {
            method: 'POST',
            headers: { 'Authorization': accessToken },
        });
        if (!result.ok) {
            const errorText = await result.text().catch(() => '');
            return { ok: false, error: errorText || `HTTP ${result.status}` };
        }
        return { ok: true, error: null };
    } catch {
        return { ok: false, error: 'Network error' };
    }
};

export const deleteDailyQuestInstance = cancelDailyQuestInstance;

export const deleteDailyQuestInstancesBulk = async (filters: {
    userId?: number;
    questDay?: string;
    questTemplateId?: number;
    eventType?: string;
    category?: string;
    claimed?: boolean;
    expired?: boolean;
}): Promise<{ ok: boolean; deleted: number; error: string | null }> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, deleted: 0, error: 'Missing access token' };
        const qs: string[] = [];
        appendQueryParam(qs, 'userId', filters.userId);
        if (filters.questDay != null && filters.questDay.trim() !== '') appendQueryParam(qs, 'questDay', filters.questDay.trim());
        appendQueryParam(qs, 'questTemplateId', filters.questTemplateId);
        if (filters.eventType != null && filters.eventType.trim() !== '') appendQueryParam(qs, 'eventType', filters.eventType.trim());
        if (filters.category != null && filters.category.trim() !== '') appendQueryParam(qs, 'category', filters.category.trim());
        if (filters.claimed !== undefined) appendQueryParam(qs, 'claimed', filters.claimed);
        if (filters.expired !== undefined) appendQueryParam(qs, 'expired', filters.expired);
        const query = qs.length > 0 ? ('?' + qs.join('&')) : '';
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quests-instances' + query, {
            method: 'DELETE',
            headers: { 'Authorization': accessToken },
        });
        if (!result.ok) {
            const errorText = await result.text().catch(() => '');
            return { ok: false, deleted: 0, error: errorText || `HTTP ${result.status}` };
        }
        const json = await result.json().catch(() => ({ deleted: 0 }));
        return { ok: true, deleted: Number(json.deleted ?? 0), error: null };
    } catch {
        return { ok: false, deleted: 0, error: 'Network error' };
    }
};

export const getDailyQuestTemplates = async (onlyActive: boolean): Promise<DailyQuestTemplateDto[] | null> => {
    const path = '/api/dashboard/marketing/daily-quests-templates?onlyActive=' + encodeURIComponent(String(onlyActive));
    return dashboardGetJson<DailyQuestTemplateDto[]>(path, 'daily-quests-templates');
};

export const getDailyQuestTemplate = async (id: string): Promise<DailyQuestTemplateDto | null> => {
    return dashboardGetJson<DailyQuestTemplateDto>(
        '/api/dashboard/marketing/daily-quests-templates/' + encodeURIComponent(id),
        'daily-quests-template',
    );
};

export const getDailyQuestTitleCatalog = (): Promise<DailyQuestTitleCatalogDto | null> => {
    return dashboardGetJson<DailyQuestTitleCatalogDto>(
        '/api/dashboard/marketing/daily-quests-title-catalog',
        'daily-quests-title-catalog',
    );
};

export const updateDailyQuestTitleCatalog = async (
    payload: DailyQuestTitleCatalogDto,
): Promise<DailyQuestTitleCatalogDto | null> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return null;
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quests-title-catalog', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) return null;
        return result.json() as Promise<DailyQuestTitleCatalogDto>;
    } catch {
        return null;
    }
};

export const createDailyQuestTemplate = async (payload: UpsertDailyQuestTemplateDto): Promise<DailyQuestTemplateMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quests-templates', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Template was not saved.') };
        }
        return { ok: true, data: await result.json() as DailyQuestTemplateDto };
    } catch {
        return { ok: false, error: 'Template was not saved.' };
    }
};

export const updateDailyQuestTemplate = async (id: string, payload: UpsertDailyQuestTemplateDto): Promise<DailyQuestTemplateMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quests-templates/' + encodeURIComponent(id), {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Template was not saved.') };
        }
        return { ok: true, data: await result.json() as DailyQuestTemplateDto };
    } catch {
        return { ok: false, error: 'Template was not saved.' };
    }
};

export const setDailyQuestTemplateActive = async (id: string, value: boolean): Promise<DailyQuestTemplateMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quests-templates/' + encodeURIComponent(id) + '/active?value=' + encodeURIComponent(String(value)), {
            method: 'PUT',
            headers: { 'Authorization': accessToken },
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Template was not updated.') };
        }
        return { ok: true, data: await result.json() as DailyQuestTemplateDto };
    } catch {
        return { ok: false, error: 'Template was not updated.' };
    }
};

export const resyncDailyQuestTemplateUserTaskTemplates = async (id: string): Promise<DailyQuestTemplateMutationResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quests-templates/' + encodeURIComponent(id) + '/user-task-templates/resync', {
            method: 'POST',
            headers: { 'Authorization': accessToken },
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Task template statuses were not re-synced.') };
        }
        return { ok: true, data: await result.json() as DailyQuestTemplateDto };
    } catch {
        return { ok: false, error: 'Task template statuses were not re-synced.' };
    }
};

export const deleteDailyQuestTemplate = async (id: string): Promise<DailyQuestTemplateDeleteResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return { ok: false, error: 'Missing access token.' };
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quests-templates/' + encodeURIComponent(id), {
            method: 'DELETE',
            headers: { 'Authorization': accessToken },
        });
        if (!result.ok) {
            return { ok: false, error: await handleResponseError(result, 'Template was not deleted.') };
        }
        return { ok: true };
    } catch {
        return { ok: false, error: 'Template was not deleted.' };
    }
};

export const assignDailyQuestDebug = async (payload: { userId: number; templateId: string }): Promise<DailyQuestAdminInstanceDto | null> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return null;
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quests-assign-debug', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) return null;
        return result.json() as Promise<DailyQuestAdminInstanceDto>;
    } catch {
        return null;
    }
};

export const testDailyQuestEligibility = async (
    userId: number,
    activationEvent: string = 'SessionStarted',
): Promise<{ ok: boolean; data?: DailyQuestEligibilityDto; error?: string }> => {
    try {
        const qs = new URLSearchParams();
        qs.set('userId', String(userId));
        qs.set('activationEvent', activationEvent);
        const response = await fetchFromApi('/api/dashboard/marketing/daily-quests-eligibility?' + qs.toString());
        if (!response.ok) {
            return { ok: false, error: await handleResponseError(response, 'Failed to test daily quest eligibility.') };
        }
        return { ok: true, data: await response.json().then(data => data as DailyQuestEligibilityDto) };
    } catch {
        return { ok: false, error: 'Failed to test daily quest eligibility.' };
    }
};

export const getUserTaskTemplates = async (taskType?: UserTaskType): Promise<UserTaskTemplateDto[] | null> => {
    const path = '/api/dashboard/marketing/user-task-templates' + (taskType ? ('?taskType=' + encodeURIComponent(taskType)) : '');
    return dashboardGetJson<UserTaskTemplateDto[]>(path, 'user-task-templates');
};

export const getDailyQuestImagePresets = async (kind: DailyQuestImageKind): Promise<DailyQuestImagePresetDto[] | null> => {
    return dashboardGetJson<DailyQuestImagePresetDto[]>(
        '/api/dashboard/marketing/daily-quest-images?kind=' + encodeURIComponent(kind),
        'daily-quest-images',
    );
};

export const createDailyQuestImagePreset = async (payload: { kind: DailyQuestImageKind; url: string }): Promise<DailyQuestImagePresetDto | null> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return null;
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quest-images', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) return null;
        return result.json() as Promise<DailyQuestImagePresetDto>;
    } catch {
        return null;
    }
};

export const deleteDailyQuestImagePreset = async (id: string): Promise<boolean> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return false;
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quest-images/' + encodeURIComponent(id), {
            method: 'DELETE',
            headers: { 'Authorization': accessToken },
        });
        return result.ok;
    } catch {
        return false;
    }
};

export const generateDailyQuestLocalizations = async (payload: {
    taskType: UserTaskType;
    taskName?: string | null;
    currentEnglishName?: string | null;
    currentEnglishDescription?: string | null;
    progressTargets: number[];
    supportedLanguages: string[];
    improveEnglish?: boolean;
}): Promise<{ localizations: { id: string; localizations: Record<string, string> }[] } | null> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return null;
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quests/tasks/localizations/generate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) return null;
        return result.json();
    } catch {
        return null;
    }
};

export const generateDailyQuestTemplateLocalizations = async (payload: {
    englishTitle: string;
    englishDescription: string;
    supportedLanguages: string[];
    improveEnglish?: boolean;
}): Promise<{ localizations: { id: string; localizations: Record<string, string> }[] } | null> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return null;
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quests/templates/localizations/generate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) return null;
        return result.json();
    } catch {
        return null;
    }
};

export const getDailyQuestTaskTemplates = async (questTemplateId: number): Promise<DailyQuestTaskTemplateDto[] | null> => {
    const path = '/api/dashboard/marketing/daily-quests-templates/' + questTemplateId + '/tasks';
    return dashboardGetJson<DailyQuestTaskTemplateDto[]>(path, 'daily-quests-task-templates');
};

export const createDailyQuestTaskTemplate = async (
    questTemplateId: number,
    payload: UpsertDailyQuestTaskTemplateDto,
): Promise<DailyQuestTaskTemplateDto | null> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return null;
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quests-templates/' + questTemplateId + '/tasks', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) return null;
        return result.json() as Promise<DailyQuestTaskTemplateDto>;
    } catch {
        return null;
    }
};

export const updateDailyQuestTaskTemplate = async (
    questTemplateId: number,
    id: number,
    payload: UpsertDailyQuestTaskTemplateDto,
): Promise<DailyQuestTaskTemplateDto | null> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return null;
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quests-templates/' + questTemplateId + '/tasks/' + id, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload),
        });
        if (!result.ok) return null;
        return result.json() as Promise<DailyQuestTaskTemplateDto>;
    } catch {
        return null;
    }
};

export const deleteDailyQuestTaskTemplate = async (questTemplateId: number, id: number): Promise<boolean> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) return false;
        const result = await fetch(BASE_URL + '/api/dashboard/marketing/daily-quests-templates/' + questTemplateId + '/tasks/' + id, {
            method: 'DELETE',
            headers: { 'Authorization': accessToken },
        });
        return result.ok;
    } catch {
        return false;
    }
};

export const getSearchMatches = (searchTerm: string) => {
    return fetchFromApi('/api/dashboard/search/matches?searchTerm=' + encodeURIComponent(searchTerm)).then(response => {
        if (!response.ok) throw new Error('Match search is unavailable.');
        return response.json().then(data => data as MatchDto[]);
    });
}

export const getSearchLeagues = (searchTerm: string, sportId?: number): Promise<PaginatedLeagueInfoResponseDto> => {
    const query = '/api/dashboard/search/leagues?searchTerm=' + encodeURIComponent(searchTerm)
        + (sportId ? '&sportId=' + encodeURIComponent(String(sportId)) : '');
    return fetchFromApi(query)
        .then(response => response.ok ? response.json().then(data => data as PaginatedLeagueInfoResponseDto) : { items: [], offset: 0, limit: 0, totalItems: 0 });
}

function virtualSportsQueryParams(): URLSearchParams {
    const params = new URLSearchParams();
    VIRTUAL_SPORT_IDS.forEach(id => params.append('sportIds', String(id)));
    return params;
}

export const getVirtualCatalogSports = (): Promise<VirtualCatalogSportDto[]> => {
    const params = virtualSportsQueryParams();
    return fetchFromApi('/api/dashboard/virtual-sports/sports?' + params.toString())
        .then(response => response.ok ? response.json() as Promise<VirtualCatalogSportDto[]> : [])
        .catch(() => []);
}

export const getVirtualCatalogLeagues = (
    offset: number,
    limit: number,
    sort: VirtualLeagueSort = 'MOST_RECENT',
    searchTerm?: string,
): Promise<VirtualCatalogPageDto<VirtualCatalogLeagueDto>> => {
    const params = virtualSportsQueryParams();
    params.set('offset', String(offset));
    params.set('limit', String(limit));
    params.set('sort', sort);
    if (searchTerm?.trim()) params.set('searchTerm', searchTerm.trim());
    return fetchFromApi('/api/dashboard/virtual-sports/leagues?' + params.toString())
        .then(response => response.ok
            ? response.json() as Promise<VirtualCatalogPageDto<VirtualCatalogLeagueDto>>
            : { items: [], offset, limit, totalItems: 0 })
        .catch(() => ({ items: [], offset, limit, totalItems: 0 }));
}

export const getVirtualCatalogMatches = (
    offset: number,
    limit: number,
    leagueId?: number | null,
    searchTerm?: string,
): Promise<VirtualCatalogPageDto<VirtualCatalogMatchDto>> => {
    const params = virtualSportsQueryParams();
    params.set('offset', String(offset));
    params.set('limit', String(limit));
    if (leagueId != null) params.set('leagueId', String(leagueId));
    if (searchTerm?.trim()) params.set('searchTerm', searchTerm.trim());
    return fetchFromApi('/api/dashboard/virtual-sports/matches?' + params.toString())
        .then(response => response.ok
            ? response.json() as Promise<VirtualCatalogPageDto<VirtualCatalogMatchDto>>
            : { items: [], offset, limit, totalItems: 0 })
        .catch(() => ({ items: [], offset, limit, totalItems: 0 }));
}

function virtualProviderFetch<T>(path: string, init?: RequestInit): Promise<T> {
    return fetchFromApi('/api/dashboard/sports/virtual' + path, init).then(async response => {
        if (!response.ok) {
            const responseText = await response.text();
            let message = responseText;
            try {
                const errorBody = JSON.parse(responseText) as { message?: string };
                message = errorBody.message || responseText;
            } catch {
                // The provider may return a plain-text gateway error.
            }
            throw new Error(message || `Virtual provider request failed (${response.status})`);
        }
        if (response.status === 204) return undefined as T;
        return response.json() as Promise<T>;
    });
}

function virtualProviderPost<T>(path: string, payload: unknown = {}): Promise<T> {
    return virtualProviderFetch<T>(path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
}

function virtualProviderPut<T>(path: string, payload: unknown): Promise<T> {
    return virtualProviderFetch<T>(path, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
}

function virtualProviderDelete(path: string): Promise<void> {
    return virtualProviderFetch<void>(path, { method: 'DELETE' });
}

export const searchVirtualProviderTeams = (query: VirtualTeamSearchQuery = {}): Promise<VirtualTeamPageDto> => {
    const params = new URLSearchParams();
    params.set('offset', String(query.offset ?? 0));
    params.set('limit', String(query.limit ?? 25));
    if (query.searchTerm?.trim()) params.set('searchTerm', query.searchTerm.trim());
    if (query.originCountry) params.set('originCountry', query.originCountry);
    if (query.active != null) params.set('active', String(query.active));
    if (query.sportId != null) params.set('sportId', String(query.sportId));
    return virtualProviderFetch(`/teams?${params.toString()}`);
};

export const getVirtualProviderTeams = async (): Promise<VirtualProviderTeamDto[]> =>
    (await searchVirtualProviderTeams({ limit: 100 })).items;

export const getVirtualProviderTeam = (teamId: string): Promise<VirtualProviderTeamDto> =>
    virtualProviderFetch(`/teams/${encodeURIComponent(teamId)}`);

export const getVirtualTeamPlayers = (teamId: string): Promise<VirtualProviderPlayerDto[]> =>
    virtualProviderFetch(`/teams/${encodeURIComponent(teamId)}/players`);

export const getVirtualProviderLeague = (leagueId: string): Promise<VirtualProviderLeagueDto> =>
    virtualProviderFetch(`/leagues/${encodeURIComponent(leagueId)}`);

export const getVirtualProviderLeaguesForSport = (sportId: number): Promise<VirtualProviderLeagueDto[]> =>
    virtualProviderFetch(`/${sportId}/leagues`);

export const getAvailableVirtualPlayers = (
    sportId: number,
    offset = 0,
    limit = 10,
): Promise<VirtualPlayerPageDto> => virtualProviderFetch(
    `/${sportId}/players/available?offset=${offset}&limit=${limit}`,
);

export const getRecentVirtualPlayers = (
    offset: number,
    limit: number,
): Promise<VirtualPlayerPageDto> => virtualProviderFetch(`/players/recent?offset=${offset}&limit=${limit}`);

export const searchVirtualProviderPlayers = (query: VirtualPlayerSearchQuery = {}): Promise<VirtualPlayerPageDto> => {
    const params = new URLSearchParams();
    params.set('offset', String(query.offset ?? 0));
    params.set('limit', String(query.limit ?? 25));
    if (query.searchTerm?.trim()) params.set('searchTerm', query.searchTerm.trim());
    if (query.originCountry) params.set('originCountry', query.originCountry);
    if (query.teamFilter) params.set('teamFilter', query.teamFilter);
    if (query.teamId) params.set('teamId', query.teamId);
    return virtualProviderFetch(`/players/search?${params.toString()}`);
};

export const getVirtualPlayer = (playerId: string): Promise<VirtualProviderPlayerDto> =>
    virtualProviderFetch(`/players/${encodeURIComponent(playerId)}`);

export const previewVirtualPlayer = (sportId: number): Promise<VirtualPlayerDraftDto> =>
    virtualProviderPost(`/${sportId}/players/ai-preview`);

export const createVirtualPlayer = (
    sportId: number,
    draft: VirtualPlayerDraftDto,
): Promise<VirtualProviderPlayerDto> => virtualProviderPost(`/${sportId}/players/manual`, draft);

export const updateVirtualPlayer = (
    playerId: string,
    draft: VirtualPlayerDraftDto,
): Promise<VirtualProviderPlayerDto> => virtualProviderPut(`/players/${encodeURIComponent(playerId)}`, draft);

export const deleteVirtualPlayer = (playerId: string): Promise<void> =>
    virtualProviderDelete(`/players/${encodeURIComponent(playerId)}`);

export const generateVirtualPlayer = (
    sportId: number,
    generatePortrait?: boolean,
): Promise<VirtualProviderPlayerDto> => virtualProviderPost(
    `/${sportId}/players${generatePortrait === undefined ? '' : `?generatePortrait=${generatePortrait}`}`,
);

export const importVirtualPlayers = (csv: string): Promise<VirtualPlayerImportResultDto> =>
    virtualProviderPost('/players/import', { csv });

export const importVirtualTeams = (csv: string): Promise<VirtualTeamImportResultDto> =>
    virtualProviderPost('/teams/import', { csv });

export const importVirtualLeagues = (csv: string): Promise<VirtualLeagueImportResultDto> =>
    virtualProviderPost('/leagues/import', { csv });

export const regenerateVirtualPlayerImage = (playerId: string): Promise<VirtualProviderPlayerDto> =>
    virtualProviderPost(`/players/${encodeURIComponent(playerId)}/image/regenerate`);

export const previewVirtualLeague = (sportId: number): Promise<VirtualLeagueDraftDto> =>
    virtualProviderPost(`/${sportId}/leagues/ai-preview`);

export const createVirtualLeague = (
    sportId: number,
    draft: VirtualLeagueDraftDto,
): Promise<VirtualProviderLeagueDto> => virtualProviderPost(`/${sportId}/leagues/manual`, draft);

export const updateVirtualLeague = (
    leagueId: string,
    draft: UpdateVirtualLeagueRequest,
): Promise<VirtualProviderLeagueDto> => virtualProviderPut(`/leagues/${encodeURIComponent(leagueId)}`, draft);

export const generateVirtualLeague = (sportId: number): Promise<VirtualProviderLeagueDto> =>
    virtualProviderPost(`/${sportId}/leagues`);

export const regenerateVirtualLeagueImage = (leagueId: string): Promise<VirtualProviderLeagueDto> =>
    virtualProviderPost(`/leagues/${encodeURIComponent(leagueId)}/image/regenerate`);

export const getVirtualLeagueSeasons = (leagueId: string): Promise<VirtualProviderSeasonDto[]> =>
    virtualProviderFetch(`/leagues/${encodeURIComponent(leagueId)}/seasons`);

export const getVirtualLeagueMatches = (leagueId: string): Promise<VirtualProviderMatchSummaryDto[]> =>
    virtualProviderFetch(`/leagues/${encodeURIComponent(leagueId)}/matches`);

export const getVirtualSeason = (seasonId: string): Promise<VirtualProviderSeasonDto> =>
    virtualProviderFetch(`/seasons/${encodeURIComponent(seasonId)}`);

export const getVirtualSeasonTable = (seasonId: string): Promise<VirtualProviderTournamentStandingDto[]> =>
    virtualProviderFetch(`/seasons/${encodeURIComponent(seasonId)}/table`);

export const getVirtualSeasonMatches = (seasonId: string): Promise<VirtualProviderMatchSummaryDto[]> =>
    virtualProviderFetch(`/seasons/${encodeURIComponent(seasonId)}/matches`);

export interface VirtualProviderMatchFilters {
    sportId?: number | null;
    leagueId?: string | null;
    teamId?: string | null;
    state?: VirtualMatchState | null;
    /** Inclusive ISO-8601 kickoff bounds. */
    startFrom?: string | null;
    startTo?: string | null;
}

export const getVirtualProviderMatches = (
    offset: number,
    limit: number,
    filters: VirtualProviderMatchFilters = {},
): Promise<VirtualProviderMatchPageDto> => {
    const params = new URLSearchParams();
    params.set('offset', String(offset));
    params.set('limit', String(limit));
    if (filters.sportId != null) params.set('sportId', String(filters.sportId));
    if (filters.leagueId) params.set('leagueId', filters.leagueId);
    if (filters.teamId) params.set('teamId', filters.teamId);
    if (filters.state) params.set('state', filters.state);
    if (filters.startFrom) params.set('startFrom', filters.startFrom);
    if (filters.startTo) params.set('startTo', filters.startTo);
    return virtualProviderFetch(`/matches?${params.toString()}`);
};

export const getBetupMatchIdByVirtualSyncId = (syncId: string): Promise<number | null> =>
    fetchFromApi(`/api/dashboard/virtual-sports/matches/sync/virtual/${encodeURIComponent(syncId)}`)
        .then(response => response.ok ? response.json() as Promise<{ id: number }> : null)
        .then(result => result?.id ?? null)
        .catch(() => null);

export const getVirtualActivityLog = (offset = 0, limit = 25): Promise<VirtualActivityLogPageDto> =>
    virtualProviderFetch(`/activity-log?offset=${offset}&limit=${limit}`);

export const markVirtualActivityLogEntryRead = (id: string): Promise<void> =>
    virtualProviderPost(`/activity-log/${encodeURIComponent(id)}/read`);

export const markAllVirtualActivityLogEntriesRead = (): Promise<void> =>
    virtualProviderPost('/activity-log/read-all');

export const getVirtualStatistics = (range: VirtualStatisticsRange): Promise<VirtualStatisticsDto> =>
    virtualProviderFetch(`/statistics?range=${range}`);

export const previewVirtualTeam = (
    sportId: number,
    poolPlayers: VirtualPoolPlayerAssignment[],
    hints: VirtualTeamGenerationHints = {},
): Promise<VirtualTeamDraftDto> => virtualProviderPost(`/${sportId}/teams/ai-preview`, { poolPlayers, ...hints });

export const createVirtualTeam = (
    sportId: number,
    draft: CreateVirtualTeamRequest,
): Promise<GeneratedVirtualTeamDto> => virtualProviderPost(`/${sportId}/teams/manual`, draft);

export const updateVirtualTeam = (
    teamId: string,
    draft: UpdateVirtualTeamRequest,
): Promise<GeneratedVirtualTeamDto> => virtualProviderPut(`/teams/${encodeURIComponent(teamId)}`, draft);

export const generateVirtualTeam = (
    sportId: number,
    hints: VirtualTeamGenerationHints = {},
): Promise<GeneratedVirtualTeamDto> => virtualProviderPost(`/${sportId}/teams`, hints);

export const regenerateVirtualTeamImage = (teamId: string): Promise<VirtualProviderTeamDto> =>
    virtualProviderPost(`/teams/${encodeURIComponent(teamId)}/image/regenerate`);

export const createVirtualMatch = (
    sportId: number,
    request: CreateVirtualMatchRequest,
): Promise<VirtualMatchScheduleResultDto> => virtualProviderPost(`/${sportId}/matches/manual`, request);

export const generateVirtualMatch = (
    sportId: number,
    request: GenerateVirtualMatchRequest = {},
): Promise<VirtualMatchScheduleResultDto> => virtualProviderPost(`/${sportId}/matches`, request);

export const getVirtualProviderMatchLiveInfo = (matchId: string): Promise<VirtualProviderMatchLiveInfoDto> =>
    virtualProviderFetch(`/matches/${encodeURIComponent(matchId)}`);

export const runAdjustMatchStartDatesScript = (): Promise<AdjustMatchStartDatesResultDto> =>
    virtualProviderPost('/scripts/adjust-start-dates');

export const runGenerateMatchBetsScript = (): Promise<GenerateMatchBetsResultDto> =>
    virtualProviderPost('/scripts/generate-bets');

/**
 * Creates one friendly kicking off in a minute, with its replay already generated, for testing the
 * live renderer without waiting for the scheduler to produce a fixture and its slot to come round.
 */
export const runSimulateMatchScript = (): Promise<VirtualMatchScheduleResultDto> =>
    virtualProviderPost('/scripts/simulate-match');

export const getMockVirtualCity = (cityId = 'ravenridge'): Promise<MockVirtualCityViewDto> =>
    virtualProviderFetch(`/cities/${encodeURIComponent(cityId)}`);

export const getVirtualAiSettings = (): Promise<VirtualAiSettingsDto> =>
    virtualProviderFetch('/ai/settings');

export const updateVirtualAiSettings = (
    generateTeamImages: boolean,
    generateLeagueImages: boolean,
): Promise<VirtualAiSettingsDto> => virtualProviderPost('/ai/settings', {
    generateTeamImages,
    generateLeagueImages,
});

export const getVirtualSportSettings = (): Promise<VirtualSportSettingsDto[]> =>
    virtualProviderFetch('/settings');

export const updateVirtualSportMaxMatchesPerDay = (
    sportId: number,
    maxMatchesPerDay: number,
): Promise<VirtualSportSettingsDto> =>
    virtualProviderPut(`/settings/${sportId}`, { maxMatchesPerDay });

export const getPrivateClubLeagueCandidates = (
    sportId: number,
    searchTerm?: string,
    limit: number = 20,
): Promise<LeagueInfoDto[]> => {
    const query = '/api/dashboard/private-clubs/league-candidates?sportId=' + encodeURIComponent(String(sportId))
        + '&limit=' + encodeURIComponent(String(limit))
        + (searchTerm?.trim() ? '&query=' + encodeURIComponent(searchTerm.trim()) : '');
    return fetchFromApi(query)
        .then(response => response.ok ? response.json().then(data => data as LeagueInfoDto[]) : []);
}

export const getPrivateClubScheduledMatches = (
    sportId: number,
    startsAt: number,
    endsAt: number,
    leagueId?: number | null,
    limit: number = 10,
): Promise<PaginatedPrivateClubScheduledMatchesResponseDto | null> => {
    const params = new URLSearchParams();
    params.set('sportId', String(sportId));
    params.set('startsAt', String(startsAt));
    params.set('endsAt', String(endsAt));
    params.set('limit', String(limit));
    if (leagueId != null) {
        params.set('leagueId', String(leagueId));
    }
    return fetchFromApi('/api/dashboard/private-clubs/matches/scheduled?' + params.toString())
        .then(response => response.ok ? response.json().then(data => data as PaginatedPrivateClubScheduledMatchesResponseDto) : null);
}

export const getPrivateClubMatchDetails = (matchId: number): Promise<MatchInfoDto | null> => {
    return fetchFromApi('/api/dashboard/private-clubs/matches/' + encodeURIComponent(String(matchId)) + '/details')
        .then(response => response.ok ? response.json().then(data => data as MatchInfoDto) : null);
}

export interface PrivateClubScheduledMatchDto extends MatchInfoDto {
    betGroups: PrivateClubBetGroupAvailabilityDto[];
}

export interface PaginatedPrivateClubScheduledMatchesResponseDto {
    items: PrivateClubScheduledMatchDto[];
    offset: number;
    limit: number;
    totalItems: number;
}

export const getPrivateClubMatchBetGroups = (matchId: number): Promise<PrivateClubBetGroupAvailabilityDto[]> => {
    return fetchFromApi('/api/dashboard/private-clubs/matches/' + encodeURIComponent(String(matchId)) + '/bet-groups')
        .then(response => response.ok ? response.json().then(data => data as PrivateClubBetGroupAvailabilityDto[]) : []);
}

export const getPrivateClubBetTypeGroups = (): Promise<PrivateClubBetTypeGroupOptionAdminDto[]> => {
    return fetchFromApi('/api/dashboard/private-clubs/bet-type-groups')
        .then(response => response.ok ? response.json().then(data => data as PrivateClubBetTypeGroupOptionAdminDto[]) : []);
}

export type DashboardMatchListSort = 'START_DATE_DESC' | 'START_DATE_ASC' | 'LEAGUE_NAME_ASC' | 'RELEVANCE';

export const paginateMatches = (
    offset: number,
    limit: number,
    before: string,
    after: string,
    options?: {
        matchState?: number | null;
        searchTerm?: string;
        sportId?: number | null;
        sort?: DashboardMatchListSort;
    }
) => {
    const params = new URLSearchParams();
    params.set('offset', String(offset));
    params.set('limit', String(limit));
    params.set('before', before);
    params.set('after', after);
    if (options?.matchState != null) {
        params.set('matchState', String(options.matchState));
    }
    if (options?.searchTerm) {
        params.set('searchTerm', options.searchTerm);
    }
    if (options?.sportId != null) {
        params.set('sportId', String(options.sportId));
    }
    if (options?.sort) {
        params.set('sort', options.sort);
    }
    return fetchFromApi('/api/dashboard/matchCalculation/matches?' + params.toString()).then(response =>
        response.json().then(data => data as PaginatedMatchesListResponseDto)
    );
};

export const getMatchDetails = (matchId: number) => {
    return fetchFromApi('/api/dashboard/matches/' + matchId).then(response => response.json().then(data => data as MatchDto));
}

export const getMatchPromoLink = (matchId: number) => {
    return fetchFromApi('/api/dashboard/promo/matches/' + matchId + '/link').then(response => response.ok ? response.text() : null);
}

export const getPromoMatchStats = (matchId: number, period: string) => {
    return fetchFromApi('/api/dashboard/promo/matches/' + matchId + '/stats/' + period).then(response => response.ok ? response.json().then(data => data as PromoMatchStat) : null);
}

export const getPromoMatchesStats = (period: string) => {
    return fetchFromApi('/api/dashboard/promo/matches/stats/' + period).then(response => response.ok ? response.json().then(data => data as PromoMatchesStat) : null);
}

export const getPromoMatchCharts = (matchId: number) => {
    return fetchFromApi('/api/dashboard/promo/matches/' + matchId + '/charts').then(response => response.ok ? response.json().then(data => data as PromoMatchChart) : null);
}

export const getPromoMatchesCharts = () => {
    return fetchFromApi('/api/dashboard/promo/matches/charts').then(response => response.ok ? response.json().then(data => data as PromoMatchChart) : null);
}

export const getFullMatchInfo = (matchId: number) => {
    return fetchFromApi('/api/dashboard/matches/' + matchId + '/full').then(response => response.ok ? response.json().then(data => data as AggregatedMatchInfoDto) : null);
}

export const getMatchAdminStat = (matchId: number) => {
    return fetchFromApi('/api/dashboard/matches/' + matchId + '/stat').then(response => response.ok ? response.json().then(data => data as AdminMatchStatDto) : null);
}

export const getMatchBettingStats = (matchId: number, excludeWhales = false, whaleThreshold = 1000000) => {
    const params = new URLSearchParams({
        excludeWhales: String(excludeWhales),
        whaleThreshold: String(whaleThreshold),
    });
    return fetchFromApi('/api/dashboard/matches/' + matchId + '/betting-stats?' + params.toString())
        .then(response => response.ok ? response.json().then(data => data as MatchBettingStatsDto) : null);
}

export const getMatchAdminPlayers = (matchId: number) => {
    return fetchFromApi('/api/dashboard/matches/' + matchId + '/players').then(response => response.ok ? response.json().then(data => data as AdminMatchPlayersDto) : null);
}

export const getMatchAdminHistory = (matchId: number) => {
    return fetchFromApi('/api/dashboard/matches/' + matchId + '/history').then(response => response.ok ? response.json().then(data => data as AdminMatchHistoryDto) : null);
}

async function putDashboardJson<TResponse>(path: string, body: unknown): Promise<TResponse> {
    const accessToken = getAccessToken()
    if (accessToken == null) {
        throw new Error('Not authenticated')
    }

    const response = await fetch(BASE_URL + path, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': accessToken
        },
        body: JSON.stringify(body)
    })

    if (!response.ok) {
        const text = await response.text().catch(() => '')
        throw new Error(text || `Request failed (${response.status})`)
    }

    return response.json() as Promise<TResponse>
}

export const updateMatchAdminStats = (matchId: number, stats: AdminMatchStatDto['stats']) => {
    return putDashboardJson<{ varietyId: number; providerEventId: string; providerSource: string; stats: AdminMatchStatDto['stats'] }>(
        '/api/dashboard/matches/' + matchId + '/stats',
        { stats }
    )
}

export const updateMatchAdminPlayers = (matchId: number, playersInfo: AdminMatchPlayersDto['playersInfo']) => {
    return putDashboardJson<{ varietyId: number; providerEventId: string; providerSource: string; playersInfo: AdminMatchPlayersDto['playersInfo'] }>(
        '/api/dashboard/matches/' + matchId + '/players',
        { playersInfo }
    )
}

export const updateMatchAdminHistory = (matchId: number, eventHistory: AdminMatchHistoryDto['eventHistory']) => {
    return putDashboardJson<{ varietyId: number; providerEventId: string; providerSource: string; eventHistory: AdminMatchHistoryDto['eventHistory'] }>(
        '/api/dashboard/matches/' + matchId + '/history',
        { eventHistory }
    )
}

export const getRacingResults = (matchId: number) => {
    return fetchFromApi('/api/dashboard/matches/' + matchId + '/racing-results').then(response => response.ok ? response.json().then(data => data as RacingParticipantResultDto[]) : []);
}

export const getProviderVarietyInfo = (varietyId: string, source: string) => {
    return fetchFromApi('/api/dashboard/provider/varieties/' + varietyId + '/info?source=' + source).then(response => response.ok ? response.json().then(data => data as ProviderMatchEventInfoDto) : null);
}

export const getMainProviderVarietyInfoDto = (matchId: string, source: string) => {
    return fetchFromApi('/api/dashboard/provider/matches/' + matchId + '/main-event?source=' + source).then(response => response.ok ? response.json().then(data => data as ProviderMatchEventInfoDto) : null);
}

export const getMatchVarietiesWithRequests = (matchId: number) => {
    return fetchFromApi('/api/dashboard/matches/' + matchId + '/requests').then(response => response.ok ? response.json().then(data => data as VarietyWithRequestsDto[]) : null);
}

export const getMatchBets = (matchId: number, offset: number, limit: number) => {
    return fetchFromApi('/api/dashboard/matches/' + matchId + '/bets?offset=' + offset + '&limit=' + limit).then(response => response.ok ? response.json().then(data => data as PaginatedMatchBetsDto) : null);
}

export const getMatchExternalBets = (matchId: number, offset: number, limit: number) => {
    return fetchFromApi(`/api/dashboard/matches/${matchId}/external-bets?offset=${offset}&limit=${limit}`)
        .then(response => response.ok ? response.json().then(data => data as PaginatedExternalPlacedBetsDto) : null)
        .catch(() => null);
}

export const updateMatchExternalBetStatus = async (
    matchId: number,
    externalReferenceId: number,
    resultState: ExternalPlacedBetResultState,
): Promise<{ ok: boolean; data?: ExternalPlacedBetDto; error?: string }> => {
    try {
        const response = await fetchFromApi(
            `/api/dashboard/matches/${matchId}/external-bets/${externalReferenceId}/status`,
            {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ resultState }),
            },
        );
        if (!response.ok) {
            return { ok: false, error: await handleResponseError(response, 'External bet status was not updated.') };
        }
        return { ok: true, data: await response.json() as ExternalPlacedBetDto };
    } catch (_error) {
        return { ok: false, error: 'External bet status was not updated.' };
    }
}

export const resyncMatchExternalBet = async (
    matchId: number,
    externalReferenceId: number,
): Promise<{ ok: boolean; data?: ExternalPlacedBetDto; error?: string }> => {
    try {
        const response = await fetchFromApi(
            `/api/dashboard/matches/${matchId}/external-bets/${externalReferenceId}/resync`,
            { method: 'POST' },
        );
        if (!response.ok) {
            return { ok: false, error: await handleResponseError(response, 'External bet was not re-synced.') };
        }
        return { ok: true, data: await response.json() as ExternalPlacedBetDto };
    } catch (_error) {
        return { ok: false, error: 'External bet was not re-synced.' };
    }
}

export const getPreliminaryCalculationResults = (offset: number, limit: number, sportId?: number, onlyBad?: Boolean, hidePending?: Boolean) => {
    return fetchFromApi('/api/dashboard/matchCalculation/preliminary?' + 'offset=' + offset + '&limit=' + limit + (sportId != null ? '&sportId=' + sportId : '') + '&onlyBad=' + (onlyBad ?? false) + '&hidePending=' + (hidePending ?? false)).then(response => response.ok ? response.json().then(data => data as PaginatedPreliminaryResultsDto) : null);
}

export const setMatchBadState = async (matchId: number, isBadMatch: boolean) => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return false;
        let result = await fetch(BASE_URL + `/api/dashboard/matchCalculation/matches/${matchId}/badMatch?isBadMatch=${isBadMatch}`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const getPaginatedCompetitions = async (offset: number, limit: number) => {
    const response = await fetchFromApi('/api/dashboard/competitions?' + 'offset=' + offset + '&limit=' + limit);
    if (!response.ok) {
        const body = await response.text().catch(() => '');
        throw new Error(
            `Competitions API failed (${response.status}). ` +
            'Ensure betup-server-analytics is running and REACT_APP_API_URL points to it. ' +
            (body ? body.slice(0, 300) : ''),
        );
    }
    return response.json().then(data => data as PaginatedCompetitionListDto);
}

export type PaginateChallengesOptions = {
    state?: number | null;
    userId?: number | null;
    matchId?: number | null;
    isPrivate?: boolean | null;
    after?: string | null;
    before?: string | null;
    searchTerm?: string | null;
    sort?: ChallengeAdminSort;
};

export const paginateChallenges = async (
    offset: number,
    limit: number,
    options: PaginateChallengesOptions = {},
): Promise<PaginatedChallengesResponseDto> => {
    const params = new URLSearchParams();
    params.set('offset', String(offset));
    params.set('limit', String(limit));
    if (options.state != null) params.set('state', String(options.state));
    if (options.userId != null) params.set('userId', String(options.userId));
    if (options.matchId != null) params.set('matchId', String(options.matchId));
    if (options.isPrivate != null) params.set('isPrivate', String(options.isPrivate));
    if (options.after) params.set('after', options.after);
    if (options.before) params.set('before', options.before);
    if (options.searchTerm) params.set('searchTerm', options.searchTerm);
    if (options.sort) params.set('sort', options.sort);

    const response = await fetchFromApi('/api/dashboard/challenges?' + params.toString());
    if (!response.ok) {
        const body = await response.text().catch(() => '');
        throw new Error(
            `Challenges API failed (${response.status}). ` +
            (body ? body.slice(0, 300) : ''),
        );
    }
    return response.json() as Promise<PaginatedChallengesResponseDto>;
};

export const getChallengeAdmin = async (id: number | string): Promise<ChallengeAdminDetailDto> => {
    const response = await fetchFromApi('/api/dashboard/challenges/' + id);
    if (!response.ok) {
        const body = await response.text().catch(() => '');
        throw new Error(`Challenge detail failed (${response.status}). ${body.slice(0, 300)}`);
    }
    return response.json() as Promise<ChallengeAdminDetailDto>;
};

export const updateChallengeAdmin = async (
    id: number | string,
    payload: UpdateChallengeAdminRequest,
): Promise<ChallengeAdminDetailDto> => {
    const accessToken = getAccessToken();
    if (accessToken == null) throw new Error('Not authenticated');
    const response = await fetch(BASE_URL + '/api/dashboard/challenges/' + id, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: accessToken },
        body: JSON.stringify(payload),
    });
    if (!response.ok) {
        const body = await response.text().catch(() => '');
        throw new Error(`Update challenge failed (${response.status}). ${body.slice(0, 300)}`);
    }
    return response.json() as Promise<ChallengeAdminDetailDto>;
};

export const updateChallengeParticipantAdmin = async (
    challengeId: number | string,
    participantId: number | string,
    payload: UpdateChallengeParticipantAdminRequest,
): Promise<ChallengeAdminDetailDto> => {
    const accessToken = getAccessToken();
    if (accessToken == null) throw new Error('Not authenticated');
    const response = await fetch(
        BASE_URL + `/api/dashboard/challenges/${challengeId}/participants/${participantId}`,
        {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', Authorization: accessToken },
            body: JSON.stringify(payload),
        },
    );
    if (!response.ok) {
        const body = await response.text().catch(() => '');
        throw new Error(`Update participant failed (${response.status}). ${body.slice(0, 300)}`);
    }
    return response.json() as Promise<ChallengeAdminDetailDto>;
};

export const getPaginatedSports = (offset: number, limit: number) => {
    return fetchFromApi('/api/dashboard/sports?' + 'offset=' + offset + '&limit=' + limit).then(response => response.ok ? response.json().then(data => data as PaginatedSportListDto) : null);
}


export const saveSport = async (sport: SportEntityDto) => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return false
        const formBody = JSON.stringify(sport);
        //body x-www-form-encoded
        let result = await fetch(BASE_URL + '/api/dashboard/sports/save', {
            method: 'POST', headers: {
                'Content-Type': 'application/json', 'Authorization': accessToken
            }, body: formBody
        }).then(response => response.ok);
        return result;
    } catch (e) {
        return false;
    }
}

export const getLeagueCatalog = (sportId: number): Promise<LeagueCatalogDto | null> => {
    return fetchFromApi('/api/dashboard/sports/' + sportId + '/league-catalog')
        .then(response => response.ok ? response.json().then(data => data as LeagueCatalogDto) : null);
}

export const seedLeagueCatalog = async (sportId: number): Promise<LeagueCatalogDto | null> => {
    const accessToken = getAccessToken();
    if (accessToken == null) return null;
    const response = await fetch(BASE_URL + '/api/dashboard/sports/' + sportId + '/league-catalog/seed', {
        method: 'POST',
        headers: { 'Authorization': accessToken },
    });
    return response.ok ? response.json().then(data => data as LeagueCatalogDto) : null;
}

export const saveLeagueCatalog = async (sportId: number, body: SaveLeagueCatalogRequest): Promise<LeagueCatalogDto | null> => {
    const accessToken = getAccessToken();
    if (accessToken == null) return null;
    const response = await fetch(BASE_URL + '/api/dashboard/sports/' + sportId + '/league-catalog', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
        body: JSON.stringify(body),
    });
    return response.ok ? response.json().then(data => data as LeagueCatalogDto) : null;
}

export const createLeagueCategory = async (sportId: number, body: UpsertLeagueCategoryRequest): Promise<LeagueCatalogCategoryDto | null> => {
    const accessToken = getAccessToken();
    if (accessToken == null) return null;
    const response = await fetch(BASE_URL + '/api/dashboard/sports/' + sportId + '/league-catalog/categories', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
        body: JSON.stringify(body),
    });
    return response.ok ? response.json().then(data => data as LeagueCatalogCategoryDto) : null;
}

export const updateLeagueCategory = async (sportId: number, categoryId: number, body: UpsertLeagueCategoryRequest): Promise<LeagueCatalogCategoryDto | null> => {
    const accessToken = getAccessToken();
    if (accessToken == null) return null;
    const response = await fetch(BASE_URL + '/api/dashboard/sports/' + sportId + '/league-catalog/categories/' + categoryId, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
        body: JSON.stringify(body),
    });
    return response.ok ? response.json().then(data => data as LeagueCatalogCategoryDto) : null;
}

export const deleteLeagueCategory = async (sportId: number, categoryId: number): Promise<boolean> => {
    const accessToken = getAccessToken();
    if (accessToken == null) return false;
    const response = await fetch(BASE_URL + '/api/dashboard/sports/' + sportId + '/league-catalog/categories/' + categoryId, {
        method: 'DELETE',
        headers: { 'Authorization': accessToken },
    });
    return response.ok;
}

export const updateCatalogLeague = async (sportId: number, leagueId: number, body: UpdateCatalogLeagueRequest): Promise<LeagueCatalogItemDto | null> => {
    const accessToken = getAccessToken();
    if (accessToken == null) return null;
    const response = await fetch(BASE_URL + '/api/dashboard/sports/' + sportId + '/league-catalog/leagues/' + leagueId, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
        body: JSON.stringify(body),
    });
    return response.ok ? response.json().then(data => data as LeagueCatalogItemDto) : null;
}


export const getCompetition = (id: string) => {
    return fetchFromApi('/api/dashboard/competitions/' + id).then(response => response.json().then(data => data as CompetitionDto));
}

function finiteNumber(value: unknown, fallback: number): number {
    const n = Number(value)
    return Number.isFinite(n) ? n : fallback
}

/** Body must match server SaveCompetitionRequestBodyModel (JSON). */
export const saveCompetition = async (competition: CompetitionDto): Promise<CompetitionDto> => {
    const accessToken = getAccessToken()
    if (accessToken == null) {
        throw new Error('Not authenticated')
    }
    const sportMatchIds = Array.from(new Set((competition.sportMatchIds ?? []).map(id => Math.trunc(Number(id))).filter(id => id > 0)))
    const reserveSportMatchIds = Array.from(new Set((competition.reserveSportMatchIds ?? []).map(id => Math.trunc(Number(id))).filter(id => id > 0)))
    const sportId = competition.sport?.id ?? null
    if (!sportId || sportId <= 0) {
        throw new Error('Sport is required.')
    }
    if (sportMatchIds.length !== 10) {
        throw new Error(`Exactly 10 unique primary matches are required (currently ${sportMatchIds.length}).`)
    }
    const overlap = sportMatchIds.filter(id => reserveSportMatchIds.includes(id))
    if (overlap.length > 0) {
        throw new Error(`Reserve cannot include primary match IDs: ${overlap.join(', ')}`)
    }
    const body = {
        id: competition.id ?? 0,
        name: competition.name ?? '',
        sportId,
        enterFee: Math.trunc(finiteNumber(competition.enterFee, 0)),
        jackpot: Math.trunc(finiteNumber(competition.jackpot, 0)),
        betGroupIds: (competition.betGroupIds ?? []).map(id => Math.trunc(Number(id))).filter(id => id > 0),
        sportMatchIds,
        reserveSportMatchIds,
        backgroundUrl: normalizeCompetitionBackgroundUrl(competition.backgroundUrl),
    }
    const response = await fetch(BASE_URL + '/api/dashboard/competitions/save', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': accessToken,
        },
        body: JSON.stringify(body),
    })
    if (!response.ok) {
        const text = await response.text().catch(() => '')
        let msg = text
        try {
            const j = JSON.parse(text) as { message?: string; error?: string }
            if (typeof j?.message === 'string' && j.message.length > 0) {
                msg = j.message
            } else if (typeof j?.error === 'string' && j.error.length > 0) {
                msg = response.status >= 500
                    ? `${j.error} (${response.status}). Check analytics server logs.`
                    : j.error
            }
        } catch {
            /* plain-text body */
        }
        throw new Error(msg || `Save competition failed (${response.status})`)
    }
    return response.json() as Promise<CompetitionDto>
}

export const getCompetitionOptions = () => {
    return fetchFromApi('/api/dashboard/competitions/options').then(response => response.json().then(data => data as CompetitionOptions));
}

export const getCompetitionMatches = async (
    betGroupIds: number[],
    sportId: number | null,
    limit: number,
    offset: number,
    searchTermId: number[],
    beginsIn: string,
    sortBy: string = 'bets',
    endsIn?: string | null,
    startsAfter?: string | null,
    startsBefore?: string | null,
): Promise<PaginatedMatchesShortListResponseDto | null> => {
    if (beginsIn === '' || betGroupIds.length === 0) return null
    const endsParam = endsIn && endsIn !== '' ? `&endsIn=${encodeURIComponent(endsIn)}` : ''
    const afterParam = startsAfter ? `&startsAfter=${encodeURIComponent(startsAfter)}` : ''
    const beforeParam = startsBefore ? `&startsBefore=${encodeURIComponent(startsBefore)}` : ''
    const response = await fetchFromApi(
        `/api/dashboard/competitions/matches?offset=${offset}&limit=${limit}` +
        `${sportId != null ? `&sportId=${sportId}` : ''}` +
        `&betGroupIds=${betGroupIds}&beginsIn=${beginsIn}&sortBy=${encodeURIComponent(sortBy)}` +
        endsParam + afterParam + beforeParam +
        `${searchTermId.length > 0 ? `&searchTermIds=${searchTermId.join(',')}` : ''}`,
    )
    if (!response.ok) {
        const text = await response.text().catch(() => '')
        let msg = text
        try {
            const j = JSON.parse(text) as { message?: string }
            if (typeof j?.message === 'string' && j.message.length > 0) {
                msg = j.message
            }
        } catch {
            /* plain-text body */
        }
        throw new Error(msg || `Load matches failed (${response.status})`)
    }
    return response.json().then(data => data as PaginatedMatchesShortListResponseDto)
}

export const getQuizOptions = () => {
    return fetchFromApi('/api/dashboard/quiz/options').then(response =>
        response.ok ? response.json().then(data => data as CompetitionOptions) : { sports: [], betGroups: [] }
    );
};

export const getQuizConfigurations = (offset: number, limit: number): Promise<PaginatedQuizConfigurationListDto | null> => {
    return fetchFromApi(`/api/dashboard/quiz/configurations?offset=${offset}&limit=${limit}`).then(async response => {
        if (response.ok) {
            return response.json().then(data => data as PaginatedQuizConfigurationListDto);
        }
        return null;
    });
};

export const getQuizConfigurationsError = async (offset: number, limit: number): Promise<string | null> => {
    const response = await fetchFromApi(`/api/dashboard/quiz/configurations?offset=${offset}&limit=${limit}`);
    if (response.ok) return null;
    let detail = '';
    try {
        const body = await response.json();
        detail = body?.message ?? body?.error ?? '';
    } catch {
        detail = await response.text().catch(() => '');
    }
    return `HTTP ${response.status}${detail ? `: ${detail}` : ''}`;
};

export const getQuizConfiguration = (id: number): Promise<QuizConfigurationDto | null> => {
    return fetchFromApi(`/api/dashboard/quiz/configurations/${id}`).then(response =>
        response.ok ? response.json().then(data => data as QuizConfigurationDto) : null
    );
};

export const saveQuizConfiguration = async (payload: SaveQuizConfigurationRequest): Promise<QuizConfigurationDto | null> => {
    const response = await fetchFromApi('/api/dashboard/quiz/configurations/save', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
    return response.ok ? response.json() as Promise<QuizConfigurationDto> : null;
};

export const deleteQuizConfiguration = async (id: number): Promise<boolean> => {
    const response = await fetchFromApi(`/api/dashboard/quiz/configurations/${id}`, { method: 'DELETE' });
    return response.ok;
};

export const getQuizConfigurationPreview = (
    id: number,
    offset: number,
    limit: number
): Promise<PaginatedQuizEligibleMatchesDto | null> => {
    return fetchFromApi(`/api/dashboard/quiz/configurations/${id}/preview?offset=${offset}&limit=${limit}`).then(response =>
        response.ok ? response.json().then(data => data as PaginatedQuizEligibleMatchesDto) : null
    );
};

export const getQuizTiers = (): Promise<QuizTierDto[]> => {
    return fetchFromApi('/api/dashboard/quiz/tiers').then(response =>
        response.ok ? response.json().then(data => data as QuizTierDto[]) : []
    );
};

export const saveQuizTier = async (payload: SaveQuizTierRequest): Promise<QuizTierDto | null> => {
    const response = await fetchFromApi('/api/dashboard/quiz/tiers/save', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
    return response.ok ? response.json() as Promise<QuizTierDto> : null;
};

export const deleteQuizTier = async (id: number): Promise<boolean> => {
    const response = await fetchFromApi(`/api/dashboard/quiz/tiers/${id}`, { method: 'DELETE' });
    return response.ok;
};

export const getQuizBetTypeGroups = (): Promise<QuizBetTypeGroupOptionDto[]> => {
    return fetchFromApi('/api/dashboard/quiz/bet-type-groups').then(response =>
        response.ok ? response.json().then(data => data as QuizBetTypeGroupOptionDto[]) : []
    );
};

export const getQuizBetTypes = (): Promise<QuizBetTypeDto[]> => {
    return fetchFromApi('/api/dashboard/quiz/bet-types').then(response =>
        response.ok ? response.json().then(data => data as QuizBetTypeDto[]) : []
    );
};

export const saveQuizBetType = async (payload: SaveQuizBetTypeRequest): Promise<QuizBetTypeDto | null> => {
    const response = await fetchFromApi('/api/dashboard/quiz/bet-types/save', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
    return response.ok ? response.json() as Promise<QuizBetTypeDto> : null;
};

export const deleteQuizBetType = async (id: number): Promise<boolean> => {
    const response = await fetchFromApi(`/api/dashboard/quiz/bet-types/${id}`, { method: 'DELETE' });
    return response.ok;
};

export const getQuizParticipations = async (
    offset: number,
    limit: number,
    options: {
        userId?: number | null;
        state?: number | null;
        quizState?: number | null;
        searchTerm?: string | null;
    } = {},
): Promise<PaginatedQuizParticipationsDto> => {
    const params = new URLSearchParams();
    params.set('offset', String(offset));
    params.set('limit', String(limit));
    if (options.userId != null) params.set('userId', String(options.userId));
    if (options.state != null) params.set('state', String(options.state));
    if (options.quizState != null) params.set('quizState', String(options.quizState));
    if (options.searchTerm) params.set('searchTerm', options.searchTerm);
    const response = await fetchFromApi('/api/dashboard/quiz/participations?' + params.toString());
    if (!response.ok) {
        const body = await response.text().catch(() => '');
        throw new Error(`Quiz participations failed (${response.status}). ${body.slice(0, 300)}`);
    }
    return response.json() as Promise<PaginatedQuizParticipationsDto>;
};

export const getQuizParticipationAdmin = async (id: number): Promise<QuizParticipationAdminDetailDto> => {
    const response = await fetchFromApi('/api/dashboard/quiz/participations/' + id);
    if (!response.ok) {
        const body = await response.text().catch(() => '');
        throw new Error(`Quiz participation detail failed (${response.status}). ${body.slice(0, 300)}`);
    }
    return response.json() as Promise<QuizParticipationAdminDetailDto>;
};


export const putMatch = async (matchId: number, bannerId: string, countriesAvailable: string[], languagesAvailable: string[], active?: Boolean, clickUrl?: string) => {
    try {
        let activeState = active ?? true;
        let accessToken = getAccessToken()
        if (accessToken == null) return false

        let result = await fetch(BASE_URL + '/api/dashboard/promo/matches/' + matchId, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify({
                clickUrl: clickUrl,
                bannerId: bannerId,
                countriesAvailable: countriesAvailable,
                languagesAvailable: languagesAvailable,
                active: activeState
            })
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const createBanner = async (name: string, titles: Localization, descriptions: Localization, imgUrls: Localization, callToActions: Localization, location: string) => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/promo/banners', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify({
                name: name,
                descriptions: descriptions,
                titles: titles,
                callToActions: callToActions,
                imgUrls: imgUrls,
                location: location
            })
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}


export type CreateHomeMatchAdResult =
    | { ok: true }
    | { ok: false; status: number; message: string };

function clarifyHomeMatchAdSaveError(status: number, message: string): string {
    const t = message.trim();
    const looksLikeGenericNotFound =
        status === 404 &&
        (t === '' || /^not found\.?$/i.test(t) || /^404\b/i.test(t));
    if (looksLikeGenericNotFound) {
        return (
            'Not Found (404): The save URL was not handled by the server. Typical causes: wrong REACT_APP_API_URL, ' +
            'API gateway without /api/dashboard/matches/ad, or the analytics service not reachable from the dashboard backend ' +
            '(POST must reach /api/stats/promo/home/ad). If this happens only when editing, the ad id may have been deleted.'
        );
    }
    return message;
}

export const createOrUpdateHomeMatchAd = async (dto: HomeMatchAdDto): Promise<CreateHomeMatchAdResult> => {
    try {
        const accessToken = getAccessToken();
        if (accessToken == null) {
            return { ok: false, status: 401, message: 'You are not signed in. Please log in again.' };
        }
        const response = await fetch(BASE_URL + '/api/dashboard/matches/ad', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(dto),
        });
        if (response.ok) {
            return { ok: true };
        }
        let message = `Request failed (${response.status} ${response.statusText || ''})`.trim();
        try {
            const text = await response.text();
            if (text) {
                try {
                    const parsed = JSON.parse(text) as { message?: string; error?: string };
                    message = parsed.message || parsed.error || text;
                } catch {
                    message = text.length > 800 ? `${text.slice(0, 800)}…` : text;
                }
            }
        } catch {
            /* keep default message */
        }
        return {
            ok: false,
            status: response.status,
            message: clarifyHomeMatchAdSaveError(response.status, message),
        };
    } catch (e) {
        const msg = e instanceof Error ? e.message : 'Network error';
        return { ok: false, status: 0, message: msg };
    }
};

export enum DestinationFolder {
    User = 'User',
    Sport = 'Sport',
    Tour = 'Tour',
    External = 'External',
    Stats = 'Stats',
    Ads = 'Ads',
    WebGames = 'WebGames'
}

export const uploadFile = async (
    file: File,
    destinationFolder: DestinationFolder,
    namePrefix?: string | null
): Promise<string | null> => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return null
        const formData = new FormData();
        formData.append('file', file);
        formData.append('destinationFolder', destinationFolder);
        const extension = file.name.split('.').pop() || '';
        formData.append('ext', extension);
        const normalizedPrefix = namePrefix?.trim();
        if (normalizedPrefix) {
            formData.append('namePrefix', normalizedPrefix);
        }
        const response = await fetch(BASE_URL + '/api/dashboard/files/uploadFile', {
            method: 'POST',
            headers: { 'Authorization': accessToken },
            body: formData
        });
        if (response.ok) {
            const data = await response.json() as { id: number, path: string };
            if (destinationFolder === DestinationFolder.WebGames) {
                const normalizedPath = normalizeWebGameUploadStoredPath(data.path);
                return normalizedPath || data.path;
            }
            return data.path;
        }
        return null;
    } catch (e) {
        return null;
    }
}


export const putBanner = async (bannerId: string, name: string, titles: Localization, descriptions: Localization, imgUrls: Localization, callToActions: Localization, location: string) => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/promo/banners/' + bannerId, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify({
                name: name,
                descriptions: descriptions,
                titles: titles,
                callToActions: callToActions,
                imgUrls: imgUrls,
                location: location
            })
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const putFunnel = async (id: string, dto: UpdateFunnelDto) => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/offers/funnels/' + id, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(dto)
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const cancelOffer = async (id: string) => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return false

        let result = await fetch(BASE_URL + '/api/dashboard/offers/' + id + '/cancel', {
            method: 'PATCH', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const createFunnel = async (dto: UpdateFunnelDto) => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/offers/funnels', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(dto)
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const createOrUpdateTemplate = async (dto: TemplateDto) => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/offers/funnels/templates', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(dto)
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const deleteTemplate = async (id: string) => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/offers/funnels/templates/' + id, {
            method: 'DELETE', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

// HTML Template API endpoints
export const getHtmlTemplates = (): Promise<HtmlTemplateDto[]> => {
    return fetchFromApi('/api/dashboard/offers/funnels/html-templates').then(response => response.json().then(data => data as HtmlTemplateDto[]));
}

export const getHtmlTemplate = (id: string): Promise<HtmlTemplateDto> => {
    return fetchFromApi('/api/dashboard/offers/funnels/html-templates/' + id).then(response => response.json().then(data => data as HtmlTemplateDto));
}

export const createHtmlTemplate = async (dto: HtmlTemplateUpsertDto): Promise<HtmlTemplateDto | null> => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return null
        let result = await fetch(BASE_URL + '/api/dashboard/offers/funnels/html-templates', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(dto)
        });
        return result.ok ? await result.json() as HtmlTemplateDto : null;
    } catch (e) {
        return null;
    }
}

export const updateHtmlTemplate = async (id: string, dto: HtmlTemplateUpsertDto): Promise<HtmlTemplateDto | null> => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return null
        let result = await fetch(BASE_URL + '/api/dashboard/offers/funnels/html-templates/' + id, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(dto)
        });
        return result.ok ? await result.json() as HtmlTemplateDto : null;
    } catch (e) {
        return null;
    }
}

export const deleteHtmlTemplate = async (id: string): Promise<boolean> => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/offers/funnels/html-templates/' + id, {
            method: 'DELETE', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const cloneHtmlTemplate = async (id: string): Promise<HtmlTemplateCloneResponse | null> => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return null
        let result = await fetch(BASE_URL + '/api/dashboard/offers/funnels/html-templates/' + id + '/clone', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        });
        return result.ok ? await result.json() as HtmlTemplateCloneResponse : null;
    } catch (e) {
        return null;
    }
}

export const improveHtmlTemplate = async (id: string, prompt: string): Promise<HtmlTemplateImprovementResponse | null> => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return null
        let result = await fetch(BASE_URL + '/api/dashboard/offers/funnels/html-templates/' + id + '/improve', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify({ prompt })
        });
        return result.ok ? await result.json() as HtmlTemplateImprovementResponse : null;
    } catch (e) {
        return null;
    }
}

export const getImprovementRequest = async (improvementRequestId: string): Promise<HtmlTemplateImprovementResponse | null> => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return null
        let result = await fetch(BASE_URL + '/api/dashboard/offers/funnels/html-templates/improvementRequests/' + improvementRequestId, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        });
        return result.ok ? await result.json() as HtmlTemplateImprovementResponse : null;
    } catch (e) {
        return null;
    }
}

export const generateHtmlTemplateLocalizations = async (dto: GenerateHtmlTemplateLocalizationsRequest): Promise<HtmlTemplateLocalizationsGenerationResponse | null> => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return null
        let result = await fetch(BASE_URL + '/api/dashboard/offers/funnels/html-templates/localizations/generate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(dto)
        });
        return result.ok ? await result.json() as HtmlTemplateLocalizationsGenerationResponse : null;
    } catch (e) {
        return null;
    }
}

export const validateHtmlTemplate = async (dto: HtmlTemplateUpsertDto): Promise<HtmlTemplateValidationResultDto | null> => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return null
        let result = await fetch(BASE_URL + '/api/dashboard/offers/funnels/html-templates/validate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(dto)
        });
        return result.ok ? await result.json() as HtmlTemplateValidationResultDto : null;
    } catch (e) {
        return null;
    }
}

export const analyzeHtmlTemplate = async (htmlContent: string): Promise<HtmlTemplateAnalysisDto | null> => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return null
        let result = await fetch(BASE_URL + '/api/dashboard/offers/funnels/html-templates/analyze', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify({ htmlContent })
        });
        return result.ok ? await result.json() as HtmlTemplateAnalysisDto : null;
    } catch (e) {
        return null;
    }
}

export const deleteFunnel = async (id: string) => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/offers/funnels/' + id, {
            method: 'DELETE', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const updateConfig = async (enabled: boolean, baseUrl: string) => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/promo/config', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify({ enabled: enabled, baseUrl: baseUrl })
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const deleteMatch = async (matchId: number) => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/promo/matches/' + matchId, {
            method: 'DELETE', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}


export const deleteBanner = async (bannerId: string) => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/promo/banners/' + bannerId, {
            method: 'DELETE', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const sendDeleteAccountRequest = async (email: string, message: string) => {
    try {
        let result = await fetch(BASE_URL + '/api/dashboard/accounts/deletionRequests', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: email, message: message })
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const getAccountDeletionRequest = (code: string) => {
    return fetchFromApi('/api/dashboard/accounts/deletionRequests/' + code + '/status').then(response => response.ok ? response.json().then(data => data as AccountDeletionRequestDto) : null);
}

export const getAccountDeletionRequests = (state: string) => {
    return fetchFromApi('/api/dashboard/accounts/deletionRequests?' + 'state=' + state).then(response => response.ok ? response.json().then(data => data as AccountDeletionRequestDto[]) : null);
}

export const approveAccountDeletionRequest = async (id: number) => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/accounts/deletionRequests/' + id + '/complete', {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify({})
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const rejectAccountDeletionRequest = async (id: number) => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/accounts/deletionRequests/' + id + '/reject', {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify({})
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const assignUserIdToDeletionRequest = async (id: number, userId: number) => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/accounts/deletionRequests/' + id + '/users/' + userId + '/assign', {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify({})
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}


const normalizeShopItemDto = (raw: ShopItemDto & { deleted?: boolean }): ShopItemDto => ({
    ...raw,
    isDeleted: raw.isDeleted === true || raw.deleted === true,
});

export const getShopProducts = (osType?: string) => {
    return fetchFromApi('/api/dashboard/shop/products' + (osType ? '?osType=' + osType : '')).then(response => response.ok ? response.json().then((data: (ShopItemDto & { deleted?: boolean })[]) => data.map(normalizeShopItemDto)) : null);
}

export const getShopEffects = () => {
    return fetchFromApi('/api/dashboard/shop/effects').then(response => response.ok ? response.json().then(data => data as ShopEffectDto[]) : null);
}

export const getShopProduct = (id: number) => {
    return fetchFromApi('/api/dashboard/shop/products/' + id).then(response => response.ok ? response.json().then((data: ShopItemDto & { deleted?: boolean }) => normalizeShopItemDto(data)) : null);
}

export const createShopProduct = async (payload: import('./models/dtos/ShopItemDto').ShopItemPayload) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return false;
        let result = await fetch(BASE_URL + '/api/dashboard/shop/products', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload)
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const updateShopProduct = async (id: number, payload: import('./models/dtos/ShopItemDto').ShopItemPayload) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return false;
        let result = await fetch(BASE_URL + '/api/dashboard/shop/products/' + id, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(payload)
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const disableShopProduct = async (id: number) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/shop/products/' + id, {
            method: 'DELETE', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const enableShopProduct = async (id: number) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/shop/products/' + id + '/enable', {
            method: 'PATCH', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const checkStoreCode = async (storeCode: string, productIdAssigned: number) => {
    return fetchFromApi('/api/dashboard/shop/checkStoreCode?storeCode=' + storeCode + "&productIdAssigned=" + productIdAssigned).then(response => response.ok ? response.json().then(data => data as StoreCodeCheckResult) : null);
}

export const getVideoPlacements = () => {
    return fetchFromApi('/api/dashboard/videoPlacements').then(response => response.ok ? response.json().then(data => data as VideoPlacementDto[]) : null);
}

export const getVideoPlacement = (id: string) => {
    return fetchFromApi('/api/dashboard/videoPlacements/' + id).then(response => response.ok ? response.json().then(data => data as VideoPlacementDto) : null);
}

export const getVideoPlacementStats = (id: string) => {
    return fetchFromApi('/api/dashboard/videoPlacements/' + id + '/stats').then(response => response.ok ? response.json().then(data => data as VideoPlacementStatsDto) : null);
}

export const getVideoPlacementsStats = (period: string) => {
    return fetchFromApi('/api/dashboard/videoPlacements/stats?periodType=' + period).then(response => response.ok ? response.json().then(data => data as SummaryVideoPlacementStatsDto) : null);
}

export const getVideoRewardConfig = () => {
    return fetchFromApi('/api/dashboard/videoPlacements/config').then(response => response.ok ? response.json().then(data => data as VideoRewardConfigDto) : null);
}

export const updateVideoRewardConfig = async (maxVideosPerDayForUser: number) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return false;
        let result = await fetch(BASE_URL + '/api/dashboard/videoPlacements/config', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify({ maxVideosPerDayForUser: maxVideosPerDayForUser })
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const getMatchRecalculationRequests = () => {
    return fetchFromApi('/api/dashboard/matchCalculation/requests').then(response => response.ok ? response.json().then(data => data as DetailedRecalculationRequestDto[]) : null);
}

export const updateVideoPlacement = async (
    id: string,
    intervalInHours: number,
    maxTimesPerInterval: number,
    oneTimeOffer: boolean,
    options: VideoRewardOptionsDto,
    enabled: boolean,
    intervalAlignment: string | null | undefined,
    intervalZoneId: string | null | undefined,
    claimWindowSeconds?: number | null,
    missCooldownSeconds?: number | null,
    urgencyLastSeconds?: number | null,
) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/videoPlacements/' + id, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify({
                intervalInHours: intervalInHours,
                maxTimesPerInterval: maxTimesPerInterval,
                oneTimeOffer: oneTimeOffer,
                rewardOptions: options,
                enabled: enabled,
                intervalAlignment: intervalAlignment ?? null,
                intervalZoneId: intervalZoneId && intervalZoneId.trim() !== '' ? intervalZoneId.trim() : null,
                claimWindowSeconds: claimWindowSeconds ?? 0,
                missCooldownSeconds: missCooldownSeconds ?? 0,
                urgencyLastSeconds: urgencyLastSeconds ?? 0,
            })
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const enableVideoPlacement = async (id: string) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/videoPlacements/' + id + '/enable', {
            method: 'PATCH', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const disableVideoPlacement = async (id: string) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/videoPlacements/' + id + '/disable', {
            method: 'PATCH', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const changeAdsStatusForUser = async (id: number, enabled: boolean) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/accounts/users/' + id + '/ads?adsEnabled=' + enabled, {
            method: 'PUT', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const updateUserBalance = async (id: number, balance: number) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return false
        if (!Number.isFinite(balance) || balance < 0 || balance > Number.MAX_SAFE_INTEGER) {
            return false;
        }
        const newValue = Math.trunc(balance);
        let result = await fetch(BASE_URL + '/api/dashboard/accounts/users/' + id + '/balance?newValue=' + encodeURIComponent(String(newValue)), {
            method: 'PUT', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const addUserEffects = async (id: number) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/accounts/users/' + id + '/effects', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        }).then(response => response.ok ? response.text() : null).then(data => data ? parseInt(data) : null);
        return result;
    } catch (e) {
        return false;
    }
}

export const updateBetStateForBetlist = async (userId: number, betlistId: number, betId: number, state: number) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/accounts/users/' + userId + '/betlists/' + betlistId + '/bets/' + betId + '?newBetState=' + state, {
            method: 'PATCH', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        }).then(response => response.ok ? response.json() : null).then(data => data as BetlistShortDto);
        return result;
    } catch (e) {
        return false;
    }
}

export const resyncSingleMatch = (matchId: string, source: string) => {
    return fetchFromApi('/api/dashboard/provider/matches/' + matchId + '/retry?source=' + source)
        .then(response => {
            if (response.ok) return response.text().then(data => Boolean(JSON.parse(data)));
            return null;
        })
        .catch(() => null);
}

export const resyncDlqMatches = (source: string) => {
    return fetchFromApi('/api/dashboard/provider/matches/dlq/retry?source=' + source)
        .then(response => {
            if (response.ok) return response.text().then(data => Boolean(JSON.parse(data)));
            return null;
        })
        .catch(() => null);
}

export const recalculateMatch = async (varietyId: number, action: number, newScore?: string) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/matchCalculation/requests', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify({ varietyId: varietyId, action: action, newScore: newScore })
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const cancelRecalculateMatch = async (requestId: number) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/matchCalculation/requests/' + requestId, {
            method: 'DELETE', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const sendMessageToUser = async (userId: number, chatId: number, message: string, translateTo?: string) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return false
        const queryParam = translateTo ? `?translateTo=${translateTo}` : '';
        let result = await fetch(BASE_URL + '/api/dashboard/support/admin/' + userId + '/chats/' + chatId + '/messages' + queryParam, {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }, body: message
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

/**
 * A photo for a support reply (analytics → main API `admin/support/images`): its public url, or the server's
 * refusal. The reply then carries it as an IMAGE line (utils/supportPhotos.ts).
 */
export const uploadSupportImage = async (image: Blob): Promise<{ url: string } | { error: string }> => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return { error: 'Not signed in' };
        const formData = new FormData();
        formData.append('image', image, 'support.jpg');
        const response = await fetch(BASE_URL + '/api/dashboard/support/images', {
            method: 'POST',
            headers: { 'Authorization': accessToken },
            body: formData
        });
        const body = await response.text();
        if (response.ok) {
            const url = (JSON.parse(body) as { url?: string }).url;
            return url ? { url } : { error: 'No url in the answer' };
        }
        let message = `HTTP ${response.status}`;
        try {
            message = (JSON.parse(body) as { message?: string }).message || message;
        } catch {
            // Not JSON: keep the status.
        }
        return { error: message };
    } catch (e) {
        return { error: String(e) };
    }
}

export const closeSupportChat = async (userId: number, chatId: number) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return false;
        let result = await fetch(BASE_URL + '/api/dashboard/support/admin/' + userId + '/chats/' + chatId, {
            method: 'DELETE', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const reopenSupportChat = async (userId: number, chatId: number) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return false;
        let result = await fetch(BASE_URL + '/api/dashboard/support/admin/' + userId + '/chats/' + chatId + '/reopen', {
            method: 'PUT', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const createSupportChatForUser = async (userId: number, chatName: string, message: string, categoryId?: string) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return false;
        let result = await fetch(BASE_URL + '/api/dashboard/support/admin/' + userId + '/chats', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify({ chatName: chatName, message: message, categoryId: categoryId })
        }).then(response => response.ok ? response.json().then(data => data as SupportMessageDto) : null);
        return result;
    } catch (e) {
        return null;
    }
}

export const toggleSupportChatPriority = async (userId: number, chatId: number) => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return false;
        let result = await fetch(BASE_URL + '/api/dashboard/support/admin/' + userId + '/chats/' + chatId + '/priority', {
            method: 'PUT', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        }).then(response => response.ok ? true : false);
        return result;
    } catch (e) {
        return false;
    }
}

export const translateMessage = async (message: string, languageCode: string): Promise<TranslateMessageResponseDto | null> => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return null;
        let requestBody = {
            message: message,
            languageCode: languageCode
        };
        let result = await fetch(BASE_URL + '/api/dashboard/support/admin/translate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(requestBody)
        });
        if (result.ok) {
            return await result.json();
        }
        return null;
    } catch (e) {
        console.error('Translation error:', e);
        return null;
    }
}

// AI Support Configuration API endpoints
export const getAISupportConfiguration = async (): Promise<AISupportConfigurationDto | null> => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return null;
        let result = await fetch(BASE_URL + '/api/dashboard/support/admin/configuration', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        });
        if (result.ok) {
            return await result.json();
        }
        return null;
    } catch (e) {
        return null;
    }
}

export const updateAISupportConfiguration = async (data: UpdateAISupportConfigurationDto): Promise<AISupportConfigurationDto | null> => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return null;
        let result = await fetch(BASE_URL + '/api/dashboard/support/admin/configuration', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify(data)
        });
        if (result.ok) {
            return await result.json();
        }
        return null;
    } catch (e) {
        return null;
    }
}

export const getChatAISummary = async (userId: number, chatId: number): Promise<AIChatSummaryDto | null> => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return null;
        let result = await fetch(BASE_URL + `/api/dashboard/support/admin/${userId}/chats/${chatId}/ai-summary`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        });
        if (result.ok) {
            return await result.json();
        }
        // Return null if 404 (no summary available) or other errors
        return null;
    } catch (e) {
        return null;
    }
}

export const generateChatAISummary = async (userId: number, chatId: number): Promise<AIChatSummaryDto | null> => {
    try {
        let accessToken = getAccessToken();
        if (accessToken == null) return null;
        let result = await fetch(BASE_URL + `/api/dashboard/support/admin/${userId}/chats/${chatId}/ai-summary`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken }
        });
        if (result.ok) {
            return await result.json();
        }
        return null;
    } catch (e) {
        return null;
    }
}

// FlashBet API endpoints

// Helper function to handle BASE_URL API responses with proper error handling
const handleGameApiResponse = async (response: Response) => {
    if (response.ok) {
        return response.json();
    }
    
    let resultText = await response.text();
    try {
        let resultObj = JSON.parse(resultText);
        if (resultObj && resultObj.message) {
            throw new Error(resultObj.message);
        }
    } catch (parseError) {
        // If we can't parse JSON, use the text directly if it's meaningful
        if (resultText && resultText.trim() && resultText.length < 200) {
            throw new Error(resultText.trim());
        }
    }
    throw new Error('Request failed');
};

export const getFlashBetSports = async (): Promise<FlashBetSportDto[]> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return []
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/sports', {
        method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    if (result.ok) {
        return result.json();
    }
    
    // For GET requests that return arrays, return empty array on error
    return [];
}

export const updateFlashBetSport = async (sportId: number, data: UpdateSportRequest): Promise<FlashBetSportDto[] | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/sports/' + sportId, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! },
        body: JSON.stringify(data)
    });
    
    return await handleGameApiResponse(result);
}

export const toggleFlashBetSportEnabled = async (sportId: number): Promise<FlashBetSportDto[] | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/sports/' + sportId + '/toggle-enabled', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

export const getFlashBetCategoriesBySport = async (sportId: number): Promise<FlashBetCategoryDto[]> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return []
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/categories/by-sport/' + sportId, {
        method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    if (result.ok) {
        return result.json();
    }
    
    // For GET requests that return arrays, return empty array on error
    return [];
}

export const createFlashBetCategory = async (data: CreateCategoryRequest): Promise<FlashBetCategoryDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/categories', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! },
        body: JSON.stringify(data)
    });
    
    return await handleGameApiResponse(result);
}

export const updateFlashBetCategory = async (categoryId: string, data: UpdateCategoryRequest): Promise<FlashBetCategoryDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/categories/' + categoryId, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! },
        body: JSON.stringify(data)
    });
    
    return await handleGameApiResponse(result);
}

export const deleteFlashBetCategory = async (categoryId: string): Promise<boolean> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return false
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/categories/' + categoryId, {
        method: 'DELETE', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    if (result.ok) {
        return true;
    }
    
    let resultText = await result.text();
    try {
        let resultObj = JSON.parse(resultText);
        if (resultObj && resultObj.message) {
            throw new Error(resultObj.message);
        }
    } catch (parseError) {
        if (resultText && resultText.trim() && resultText.length < 200) {
            throw new Error(resultText.trim());
        }
    }
    throw new Error('Failed to delete category');
}

export const getFlashBetCategory = async (categoryId: string): Promise<FlashBetCategoryDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/categories/' + categoryId, {
        method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

// Question Templates API endpoints
export const getFlashBetQuestionTemplates = async (): Promise<FlashBetQuestionTemplateDto[]> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return []
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/question-templates', {
        method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    if (result.ok) {
        return result.json();
    }
    
    // For GET requests that return arrays, return empty array on error
    return [];
}

export const getFlashBetQuestionTemplate = async (id: string): Promise<FlashBetQuestionTemplateDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/question-templates/' + id, {
        method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

export const createFlashBetQuestionTemplate = async (data: CreateQuestionTemplateRequest): Promise<FlashBetQuestionTemplateDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/question-templates', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! },
        body: JSON.stringify(data)
    });
    
    return await handleGameApiResponse(result);
}

export const updateFlashBetQuestionTemplate = async (id: string, data: UpdateQuestionTemplateRequest): Promise<FlashBetQuestionTemplateDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/question-templates/' + id, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! },
        body: JSON.stringify(data)
    });
    
    return await handleGameApiResponse(result);
}

export const deleteFlashBetQuestionTemplate = async (id: string): Promise<boolean> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return false
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/question-templates/' + id, {
        method: 'DELETE', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    if (result.ok) {
        return true;
    }
    
    let resultText = await result.text();
    try {
        let resultObj = JSON.parse(resultText);
        if (resultObj && resultObj.message) {
            throw new Error(resultObj.message);
        }
    } catch (parseError) {
        if (resultText && resultText.trim() && resultText.length < 200) {
            throw new Error(resultText.trim());
        }
    }
    throw new Error('Failed to delete question template');
}

export const toggleFlashBetQuestionTemplateEnabled = async (id: string): Promise<FlashBetQuestionTemplateDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/question-templates/' + id + '/toggle-enabled', {
        method: 'PATCH', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

// Match API endpoints
export const getFlashBetMatchesByCategory = async (categoryId: string, page: number = 0, size: number = 10, searchTerm?: string): Promise<PageFlashBetMatchDto> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return {
        content: [],
        totalElements: 0,
        totalPages: 0,
        first: true,
        last: true,
        size: size,
        number: page,
        numberOfElements: 0,
        empty: true
    };
    
    let url = BASE_URL + '/api/dashboard/games/flashbet/matches/by-category/' + categoryId + `?page=${page}&size=${size}`;
    if (searchTerm && searchTerm.trim()) {
        url += `&searchTerm=${encodeURIComponent(searchTerm.trim())}`;
    }
    
    let result = await fetch(url, {
        method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    if (result.ok) {
        return result.json();
    }
    
    // For GET requests that return paginated data, return empty page structure on error
    return {
        content: [],
        totalElements: 0,
        totalPages: 0,
        first: true,
        last: true,
        size: size,
        number: page,
        numberOfElements: 0,
        empty: true
    };
}

export const getFlashBetMatch = async (id: string): Promise<FlashBetMatchDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/matches/' + id, {
        method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

export const createFlashBetMatch = async (data: CreateMatchRequest): Promise<FlashBetMatchDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/matches', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! },
        body: JSON.stringify(data)
    });
    
    return await handleGameApiResponse(result);
}

export const updateFlashBetMatch = async (id: string, data: UpdateMatchRequest): Promise<FlashBetMatchDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/matches/' + id, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! },
        body: JSON.stringify(data)
    });
    
    return await handleGameApiResponse(result);
}

export const updateFlashBetMatchMetadata = async (id: string, data: UpdateMatchMetadataRequest): Promise<FlashBetMatchDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/matches/' + id + '/metadata', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! },
        body: JSON.stringify(data)
    });
    
    return await handleGameApiResponse(result);
}

export const deleteFlashBetMatch = async (id: string): Promise<boolean> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return false
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/matches/' + id, {
        method: 'DELETE', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    if (result.ok) {
        return true;
    }
    
    let resultText = await result.text();
    try {
        let resultObj = JSON.parse(resultText);
        if (resultObj && resultObj.message) {
            throw new Error(resultObj.message);
        }
    } catch (parseError) {
        if (resultText && resultText.trim() && resultText.length < 200) {
            throw new Error(resultText.trim());
        }
    }
    throw new Error('Failed to delete match');
}

export const checkFlashBetMatchExists = async (betsApiId: string): Promise<{ exists: boolean } | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/matches/exists/' + encodeURIComponent(betsApiId), {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

export const toggleFlashBetMatchEnabled = async (id: string): Promise<FlashBetMatchDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/matches/' + id + '/toggle-enabled', {
        method: 'PATCH', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

export const addFlashBetMatchQuestion = async (matchId: string, data: AddMatchQuestionRequest): Promise<FlashBetMatchDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/matches/' + matchId + '/questions', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! },
        body: JSON.stringify(data)
    });
    
    return await handleGameApiResponse(result);
}

export const updateFlashBetMatchQuestion = async (matchId: string, questionId: string, data: UpdateMatchQuestionByIdRequest): Promise<FlashBetMatchDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/matches/' + matchId + '/questions/' + questionId, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! },
        body: JSON.stringify(data)
    });
    
    return await handleGameApiResponse(result);
}

export const deleteFlashBetMatchQuestion = async (matchId: string, questionId: string): Promise<FlashBetMatchDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/matches/' + matchId + '/questions/' + questionId, {
        method: 'DELETE', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

export const generateQuestionsForMatch = async (matchId: string, promptId?: string): Promise<boolean> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return false
    
    let url = BASE_URL + '/api/dashboard/games/flashbet/matches/' + matchId + '/generate-questions';
    if (promptId) {
        url += '?promptId=' + encodeURIComponent(promptId);
    }
    
    let result = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    if (result.ok) {
        return true;
    }
    
    let resultText = await result.text();
    try {
        let resultObj = JSON.parse(resultText);
        if (resultObj && resultObj.message) {
            throw new Error(resultObj.message);
        }
    } catch (parseError) {
        if (resultText && resultText.trim() && resultText.length < 200) {
            throw new Error(resultText.trim());
        }
    }
    throw new Error('Failed to generate questions');
}

export const getPromptPreviewForQuestionGeneration = async (matchId: string, promptId?: string): Promise<string> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return ''
    
    let url = BASE_URL + '/api/dashboard/games/flashbet/matches/' + matchId + '/prompt-preview';
    if (promptId) {
        url += '?promptId=' + encodeURIComponent(promptId);
    }
    
    let result = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    if (result.ok) {
        const response = await result.json() as { prompt: string };
        return response.prompt;
    }
    
    let resultText = await result.text();
    try {
        let resultObj = JSON.parse(resultText);
        if (resultObj && resultObj.message) {
            throw new Error(resultObj.message);
        }
    } catch (parseError) {
        if (resultText && resultText.trim() && resultText.length < 200) {
            throw new Error(resultText.trim());
        }
    }
    throw new Error('Failed to fetch prompt preview');
}

export const getFlashBetMatchQuestionStats = async (matchId: string): Promise<FlashBetMatchQuestionsStatsDto[]> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return []
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/matches/' + matchId + '/questions-stats', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    if (result.ok) {
        return await result.json() as FlashBetMatchQuestionsStatsDto[];
    }
    
    // For GET requests that return arrays, return empty array on error
    return [];
}

export const getMatchScoreRecords = async (matchId: string): Promise<MatchTimeScoreRecordDto[] | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/matches/' + matchId + '/score-records', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

export const updateMatchScoreRecords = async (matchId: string, data: UpdateMatchScoreRecordsRequest): Promise<MatchTimeScoreRecordDto[] | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/matches/' + matchId + '/score-records', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! },
        body: JSON.stringify(data)
    });
    
    return await handleGameApiResponse(result);
}

// Match Events API functions
export const getMatchEvents = async (matchId: string): Promise<FlashBetEventDto[] | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/matches/' + matchId + '/events', {
        method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    if (result.ok) {
        return result.json();
    }
    
    // For GET requests that return arrays, return empty array on error
    return [];
}

export const updateMatchEvents = async (matchId: string, data: UpdateMatchEventsRequest): Promise<FlashBetEventDto[] | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/matches/' + matchId + '/events', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! },
        body: JSON.stringify(data)
    });
    
    return await handleGameApiResponse(result);
}

export const refetchMatchEvents = async (matchId: string): Promise<FlashBetMatchDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/matches/' + matchId + '/refetch-events', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

export interface FlashBetPossessionBackfillResultDto {
    processed: number;
    updated: number;
    skipped: number;
    failed: number;
    remaining: number;
    failures: { matchId: string; betsApiId: string; message: string }[];
}

export const getMissingPossessionCount = async (onlyEnabled: boolean = true): Promise<number> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return 0
    let result = await fetch(
        BASE_URL + '/api/dashboard/games/flashbet/matches/missing-possession-count?onlyEnabled=' + onlyEnabled,
        { headers: { 'Authorization': accessToken! } },
    );
    if (!result.ok) return 0;
    const body = await result.json();
    return body.count ?? 0;
}

export const backfillMissingPossession = async (
    limit: number = 50,
    onlyEnabled: boolean = true,
): Promise<FlashBetPossessionBackfillResultDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(
        BASE_URL + '/api/dashboard/games/flashbet/matches/backfill-possession?limit=' + limit + '&onlyEnabled=' + onlyEnabled,
        { method: 'POST', headers: { 'Authorization': accessToken! } },
    );
    return await handleGameApiResponse(result);
}

export const backfillMatchPossession = async (matchId: string): Promise<FlashBetMatchDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(
        BASE_URL + '/api/dashboard/games/flashbet/matches/' + matchId + '/backfill-possession',
        { method: 'POST', headers: { 'Authorization': accessToken! } },
    );
    return await handleGameApiResponse(result);
}

export const refetchMatchDetails = async (matchId: string): Promise<FlashBetMatchDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/matches/' + matchId + '/refetch-details', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    if (result.ok)
        return result.json();

    let resultText = await result.text();
    let resultObj = JSON.parse(resultText);
    if (resultObj && resultObj.message) {
        throw new Error(resultObj.message);
    }
    throw new Error('Failed to refetch match details');
}

// League API functions
export const getAllFlashBetLeagues = async (page: number = 0, size: number = 20, search?: string): Promise<PageFlashBetLeagueDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null

    let url = `${BASE_URL}/api/dashboard/games/flashbet/leagues?page=${page}&size=${size}`;
    if (search) {
        url += `&search=${encodeURIComponent(search)}`;
    }

    let result = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

// Stadium API functions
export const getAllFlashBetStadiums = async (page: number = 0, size: number = 20, search?: string): Promise<PageFlashBetStadiumDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null

    let url = `${BASE_URL}/api/dashboard/games/flashbet/stadiums?page=${page}&size=${size}`;
    if (search) {
        url += `&search=${encodeURIComponent(search)}`;
    }

    let result = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

// Task queue management functions
export const getTaskQueueStatus = async (hoursThreshold: number = 24): Promise<TaskQueueStatusDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null

    let result = await fetch(BASE_URL + `/api/dashboard/games/flashbet/tasks/queue-status?hoursThreshold=${hoursThreshold}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

export const getTasks = async (page: number = 0, size: number = 20, hoursThreshold: number = 24): Promise<PageFlashBetTaskDetailDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null

    let result = await fetch(BASE_URL + `/api/dashboard/games/flashbet/tasks?page=${page}&size=${size}&hoursThreshold=${hoursThreshold}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

export const deleteTask = async (taskId: string): Promise<boolean> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return false

    let result = await fetch(BASE_URL + `/api/dashboard/games/flashbet/tasks/${taskId}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    if (result.ok) {
        return true;
    }
    
    let resultText = await result.text();
    try {
        let resultObj = JSON.parse(resultText);
        if (resultObj && resultObj.message) {
            throw new Error(resultObj.message);
        }
    } catch (parseError) {
        if (resultText && resultText.trim() && resultText.length < 200) {
            throw new Error(resultText.trim());
        }
    }
    throw new Error('Failed to delete task');
}

export const retryTask = async (taskId: string): Promise<FlashBetTaskDetailDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null

    let result = await fetch(BASE_URL + `/api/dashboard/games/flashbet/tasks/${taskId}/retry`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

export const cleanupTaskQueue = async (): Promise<{ deletedCount: number } | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null

    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/tasks/cleanup', {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

export const getCategoriesBySports = async (sportIds: number[]): Promise<FlashBetCategoryDto[]> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return []
    
    if (sportIds.length === 0) return []
    
    const queryParams = sportIds.map(id => `sportIds=${id}`).join('&');
    let result = await fetch(BASE_URL + `/api/dashboard/games/flashbet/categories/by-sports?${queryParams}`, {
        method: 'GET', 
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    if (result.ok) {
        return result.json();
    }
    
    return [];
}

export const getMatchesWithFilters = async (
    sportIds: number[] = [], 
    categoryIds: string[] = [], 
    searchTerm?: string, 
    showOnlyEnabled: boolean = false,
    page: number = 0, 
    size: number = 10
): Promise<PageFlashBetMatchDto> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return {
        content: [],
        totalElements: 0,
        totalPages: 0,
        first: true,
        last: true,
        size: size,
        number: page,
        numberOfElements: 0,
        empty: true
    };
    
    let url = BASE_URL + `/api/dashboard/games/flashbet/matches/filtered?page=${page}&size=${size}&showOnlyEnabled=${showOnlyEnabled}`;
    
    if (sportIds.length > 0) {
        const sportIdsParam = sportIds.map(id => `sportIds=${id}`).join('&');
        url += `&${sportIdsParam}`;
    }
    
    if (categoryIds.length > 0) {
        const categoryIdsParam = categoryIds.map(id => `categoryIds=${encodeURIComponent(id)}`).join('&');
        url += `&${categoryIdsParam}`;
    }
    
    if (searchTerm && searchTerm.trim()) {
        url += `&searchTerm=${encodeURIComponent(searchTerm.trim())}`;
    }
    
    let result = await fetch(url, {
        method: 'GET', 
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    if (result.ok) {
        return result.json();
    }
    
    return {
        content: [],
        totalElements: 0,
        totalPages: 0,
        first: true,
        last: true,
        size: size,
        number: page,
        numberOfElements: 0,
        empty: true
    };
}

export const createTasks = async (tasksData: { sportId: number; categoryId: string; betsApiIds: string[] }): Promise<FlashBetMatchCreationTaskDto[]> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return []

    // Convert the input format to match the API spec
    const matches = tasksData.betsApiIds.map(betsApiId => ({
        betsApiId,
        sportId: tasksData.sportId,
        categoryId: tasksData.categoryId,
        enabled: true
    }));

    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/tasks/matches', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! },
        body: JSON.stringify({ matches })
    });
    
    return await handleGameApiResponse(result);
}

// Statistics API endpoints
export const getFlashBetOverviewStats = async (
    interval: StatsInterval,
    sportIds: number[] = [],
    categoryIds: string[] = []
): Promise<FlashBetOverviewStatsDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null;

    let url = BASE_URL + `/api/dashboard/games/flashbet/stats/overview?interval=${interval}`;
    
    if (sportIds.length > 0) {
        const sportIdsParam = sportIds.map(id => `sportIds=${id}`).join('&');
        url += `&${sportIdsParam}`;
    }
    
    if (categoryIds.length > 0) {
        const categoryIdsParam = categoryIds.map(id => `categoryIds=${encodeURIComponent(id)}`).join('&');
        url += `&${categoryIdsParam}`;
    }

    let result = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

// FlashBet Sport Prompt API endpoints

export const getSportPrompts = async (sportId: number): Promise<FlashBetSportPromptSummaryDto[]> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return []
    
    let result = await fetch(BASE_URL + `/api/dashboard/games/flashbet/sports/${sportId}/prompts`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result) || [];
}

export const getSportPrompt = async (sportId: number, promptId: string): Promise<FlashBetSportPromptDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    
    let result = await fetch(BASE_URL + `/api/dashboard/games/flashbet/sports/${sportId}/prompts/${promptId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

export const getActiveSportPrompt = async (sportId: number): Promise<FlashBetSportPromptDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    
    let result = await fetch(BASE_URL + `/api/dashboard/games/flashbet/sports/${sportId}/prompts/active`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

export const createSportPrompt = async (sportId: number, data: CreateSportPromptRequest): Promise<FlashBetSportPromptDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    
    let result = await fetch(BASE_URL + `/api/dashboard/games/flashbet/sports/${sportId}/prompts`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! },
        body: JSON.stringify(data)
    });
    
    return await handleGameApiResponse(result);
}

export const updateSportPrompt = async (sportId: number, promptId: string, data: UpdateSportPromptRequest): Promise<FlashBetSportPromptDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    
    let result = await fetch(BASE_URL + `/api/dashboard/games/flashbet/sports/${sportId}/prompts/${promptId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! },
        body: JSON.stringify(data)
    });
    
    return await handleGameApiResponse(result);
}

export const setActivePrompt = async (sportId: number, request: SetActivePromptRequest): Promise<FlashBetSportPromptDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    
    let result = await fetch(BASE_URL + `/api/dashboard/games/flashbet/sports/${sportId}/prompts/active`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! },
        body: JSON.stringify(request)
    });
    
    return await handleGameApiResponse(result);
}

export const deleteSportPrompt = async (sportId: number, promptId: string): Promise<boolean> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return false
    
    try {
        let result = await fetch(BASE_URL + `/api/dashboard/games/flashbet/sports/${sportId}/prompts/${promptId}`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
        });
        
        if (result.ok) {
            return true;
        } else {
            const errorData = await result.json().catch(() => null);
            console.error('Failed to delete sport prompt:', errorData);
            return false;
        }
    } catch (error) {
        console.error('Error deleting sport prompt:', error);
        return false;
    }
}

export const getPromptMacros = async (): Promise<PromptMacrosDto | null> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null
    
    let result = await fetch(BASE_URL + '/api/dashboard/games/flashbet/prompt-macros', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });
    
    return await handleGameApiResponse(result);
}

/** The Flash Bet prompt variants' texts from before the AI hub as a betup-server-ai bundle (import in AI › Import). */
export const getFlashBetPromptsHubBundle = async (model: string): Promise<unknown> => {
    let accessToken = getAccessToken()
    if (accessToken == null) return null

    let result = await fetch(BASE_URL + `/api/dashboard/games/flashbet/prompts/hub-bundle?model=${encodeURIComponent(model)}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': accessToken! }
    });

    return await handleGameApiResponse(result);
}

// Health endpoints
export const getReplicationHealth = () => {
    return fetchFromApi('/api/dashboard/health/replication').then(response => response.json().then(data => data as ReplicationHealthResponseDto));
}

export const getQueuesHealth = () => {
    return fetchFromApi('/api/dashboard/health/queues').then(response => response.json().then(data => data as QueueStatusInfoDto[]));
}

export const purgeHealthQueue = (queueName: string) => {
    return fetchFromApi('/api/dashboard/health/queues/' + encodeURIComponent(queueName) + '/purge', {
        method: 'POST'
    }).then(response => response.json().then(data => data as QueueActionResultDto));
}

export const retryHealthDeadLetterQueue = (queueName: string) => {
    return fetchFromApi('/api/dashboard/health/queues/' + encodeURIComponent(queueName) + '/retry', {
        method: 'POST'
    }).then(response => response.json().then(data => data as QueueActionResultDto));
}

export const getDeploymentsHealth = () => {
    return fetchFromApi('/api/dashboard/health/deployments').then(response => response.json().then(data => data as KubernetesDeploymentHealthResponseDto[]));
}

export const getServersHealth = () => {
    return fetchFromApi('/api/dashboard/health/servers').then(response => response.json().then(data => data as ServerHealthStatusResponseDto[]));
}

export const getCronsHealth = () => {
    return fetchFromApi('/api/dashboard/health/crons').then(response => response.json().then(data => data as CronHealthResponseDto));
}

/** Provider task run stats; rejects with the server's error text when the request fails. */
export const getProviderTaskStats = async (query: ProviderTaskStatsQuery): Promise<ProviderTaskStatsResponseDto> => {
    const params = new URLSearchParams();
    if (query.from) params.set('from', query.from);
    if (query.to) params.set('to', query.to);
    if (query.tasks && query.tasks.length > 0) params.set('tasks', query.tasks.join(','));
    if (query.bucketMinutes) params.set('bucketMinutes', String(query.bucketMinutes));
    const response = await fetchFromApi('/api/dashboard/health/provider-tasks/stats?' + params.toString());
    if (!response.ok) {
        const text = await response.text().catch(() => '');
        let message = text;
        try { message = JSON.parse(text).error ?? text; } catch { /* plain text body */ }
        throw new Error(message || `HTTP ${response.status}`);
    }
    return await response.json() as ProviderTaskStatsResponseDto;
}

export const sendHealthReport = async (email: string): Promise<boolean> => {
    try {
        let accessToken = getAccessToken()
        if (accessToken == null) return false
        let result = await fetch(BASE_URL + '/api/dashboard/health/report', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
            body: JSON.stringify({ email })
        });
        return result.ok;
    } catch (e) {
        return false;
    }
}

export const getServerHealthCharts = (serverId: string, timeFilter: ServerHealthChartTimeFilter) => {
    return fetchFromApi('/api/dashboard/health/server/' + encodeURIComponent(serverId) + '/charts?timeFilter=' + timeFilter)
        .then(response => response.json().then(data => data as ServerHealthChartResponseDto));
}

// ---- AI match briefs (Matches › AI predictions; betup-server-api docs/match-briefs.md §5) ----

/** Briefs newest first; null on failure. */
export const getMatchBriefs = (offset: number, limit: number, status?: MatchBriefStatus | null) =>
    dashboardGetJson<MatchBriefPageDto>(
        `/api/dashboard/admin/match-briefs?offset=${offset}&limit=${limit}${status ? `&status=${status}` : ''}`,
        'match-briefs',
    );

/** One brief with its texts and neighbours; null on failure. */
export const getMatchBrief = (id: number) => dashboardGetJson<MatchBriefDto>(`/api/dashboard/admin/match-briefs/${id}`, 'match-brief');

/** The match's brief; null when it has none (404, not logged as an error) or on failure. */
export const getMatchBriefByMatch = async (matchId: number): Promise<MatchBriefDto | null> => {
    try {
        const response = await fetchFromApi(`/api/dashboard/admin/match-briefs/by-match/${matchId}`);
        return response.ok ? (await response.json()) as MatchBriefDto : null;
    } catch {
        return null;
    }
}

/** Invocations newest first; `sort` 'status' orders by stage; [matchId] narrows to one match. null on failure. */
export const getMatchBriefExecutions = (offset: number, limit: number, status: MatchBriefExecutionStatus | null, sort: 'created' | 'status', direction: 'asc' | 'desc', matchId?: number | null) =>
    dashboardGetJson<MatchBriefExecutionPageDto>(
        `/api/dashboard/admin/match-briefs/executions?offset=${offset}&limit=${limit}&sort=${sort}&direction=${direction}${status ? `&status=${status}` : ''}${matchId ? `&match_id=${matchId}` : ''}`,
        'match-brief-executions',
    );

/** Match researches newest first, without findings; [matchId] narrows to one match. null on failure. */
export const getMatchResearches = (offset: number, limit: number, matchId?: number | null) =>
    dashboardGetJson<MatchResearchPageDto>(
        `/api/dashboard/admin/match-briefs/researches?offset=${offset}&limit=${limit}${matchId ? `&match_id=${matchId}` : ''}`,
        'match-researches',
    );

/** One research with its findings; null on failure. */
export const getMatchResearch = (id: number) => dashboardGetJson<MatchResearchDto>(`/api/dashboard/admin/match-briefs/researches/${id}`, 'match-research');

/** One match's AI state (brief, researches, an invocation in progress); null on failure. */
export const getMatchAiStatus = (matchId: number) =>
    dashboardGetJson<MatchAiStatusDto>(`/api/dashboard/admin/match-briefs/matches/${matchId}`, 'match-ai-status');

export const getMatchBriefExecution = (id: number) =>
    dashboardGetJson<MatchBriefExecutionDto>(`/api/dashboard/admin/match-briefs/executions/${id}`, 'match-brief-execution');

/**
 * A manual trigger to Crons (no scheduler limits): the brief of [matchId] or of the best uncovered match, or with scope
 * RESEARCH a new web research of [matchId] only; error = the server's message.
 */
export const triggerMatchBrief = async (matchId: number | null, scope: MatchBriefScope = 'BRIEF'): Promise<{ error: string | null }> => {
    try {
        const response = await fetchFromApi('/api/dashboard/admin/match-briefs/trigger', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...(matchId == null ? {} : { match_id: matchId }), scope: scope.toLowerCase() }),
        });
        if (response.ok) return { error: null };
        const text = await response.text().catch(() => '');
        let message = '';
        try { message = JSON.parse(text)?.message ?? ''; } catch { message = text; }
        return { error: message || `HTTP ${response.status}` };
    } catch (e) {
        return { error: e instanceof Error ? e.message : 'Network error' };
    }
}
